"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[12],{

/***/ 84348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ useLocalProduct; }
});

// UNUSED EXPORTS: getLocalProductServerSide

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@apollo/client/index.js
var client = __webpack_require__(46829);
// EXTERNAL MODULE: ./src/api/local/index.ts + 28 modules
var api_local = __webpack_require__(52645);
// EXTERNAL MODULE: ./src/api/saleor/generated/index.tsx
var generated = __webpack_require__(49554);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/index.js
var core = __webpack_require__(71439);
;// CONCATENATED MODULE: ./src/api/local/generated/hooks.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query ProductBySlug($slug: String!) {\n    productBySlug(slug: $slug) @client {\n      __typename\n      id\n      slug\n      isAvailable\n      hidePrice\n      name\n      relatedProducts {\n        __typename\n        id\n        productId\n      }\n      description\n      fullDescription\n      sku\n      variantId\n      categoryName\n      breadcrumbs {\n        __typename\n        id\n        title\n        href\n      }\n      defaultUnitType {\n        __typename\n        id\n        name\n        displayNameSingular\n        displayNamePlural\n        minQuantity\n        quantityPerUnit\n      }\n      unitTypes {\n        __typename\n        displayNamePlural\n        displayNameSingular\n        id\n        name\n        minQuantity\n        quantityPerUnit\n      }\n      miscTags {\n        __typename\n        id\n        slug\n        name\n        thumbnail {\n          __typename\n          id\n          url\n        }\n      }\n      ecoCerts {\n        __typename\n        id\n        slug\n        name\n        thumbnail {\n          id\n          url\n        }\n      }\n      securityDocs {\n        __typename\n        id\n        slug\n        name\n        url\n      }\n      infoDocs {\n        __typename\n        id\n        slug\n        name\n        url\n      }\n      media {\n        ... on Image {\n          __typename\n          type\n          id\n          url\n        }\n        ... on Video {\n          __typename\n          id\n          type\n          thumbnail {\n            id\n            url\n          }\n          youtubeID\n          embedURL\n        }\n      }\n      labels {\n        id\n        slug\n        name\n        thumbnail {\n          id\n          url\n        }\n      }\n      pricing {\n        id\n        unitType\n        gross\n        grossFormatted\n        net\n        netFormatted\n        discount\n        discountFormatted\n        grossOriginalPriceFormatted\n        minQuantity\n        quantityPerUnit\n        displayNameSingular\n        displayNamePlural\n        netUnitPrice\n        netUnitPriceFormatted\n        grossUnitPrice\n        grossUnitPriceFormatted\n      }\n      offerString\n      thumbnail {\n        __typename\n        id\n        url\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var defaultOptions = {};
var ProductBySlugDocument = (0,core.gql)(_templateObject());
/**
 * __useProductBySlugQuery__
 *
 * To run a query within a React component, call `useProductBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */ function useProductBySlugQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return client.useQuery(ProductBySlugDocument, options);
}
function useProductBySlugLazyQuery(baseOptions) {
    var options = _objectSpread({}, defaultOptions, baseOptions);
    return Apollo.useLazyQuery(ProductBySlugDocument, options);
}

;// CONCATENATED MODULE: ./src/api/local/useLocalProduct.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var getLocalProductServerSide = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var throwNotFound, query, context, getProp, slug, data, local;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    throwNotFound = param.throwNotFound, query = param.query, context = param.context, getProp = param.getProp;
                    slug = getProp(context, {
                        key: "slug"
                    });
                    _ctx.next = 4;
                    return query({
                        query: generated/* ProductDocument */.MPV,
                        variables: {
                            slug: slug
                        }
                    });
                case 4:
                    data = _ctx.sent;
                    _ctx.next = 7;
                    return query({
                        query: api_local/* ProductBySlugDocument */.uN,
                        variables: {
                            slug: slug
                        }
                    });
                case 7:
                    local = _ctx.sent;
                    if (data) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", throwNotFound());
                case 10:
                    return _ctx.abrupt("return", data);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getLocalProductServerSide(_) {
        return _ref.apply(this, arguments);
    };
}();
var useLocalProduct = function(param) {
    var _slug = param.slug, injected = param.injected;
    if (!_slug || typeof _slug !== "string") {
        throw new Error("Slug incorrectly defined");
    }
    var slug = Array.isArray(_slug) ? _slug[0] : _slug;
    // Since it is anti pattern to fetch from Apollo in TypePolicy
    // we fetch Product here first
    var ref = (0,client.useQuery)(generated/* ProductDocument */.MPV, {
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        context: {
            nonAuthorized: true
        },
        variables: {
            slug: slug
        }
    }), productData = ref.data, productError = ref.error, productLoading = ref.loading;
    var ref1 = useProductBySlugQuery({
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-first",
        skip: !(productData === null || productData === void 0 ? void 0 : productData.product),
        variables: {
            slug: slug
        },
        returnPartialData: true
    }), data = ref1.data, error = ref1.error, loading = ref1.loading;
    return {
        loading: loading || productLoading,
        error: error || productError,
        data: injected !== null && injected !== void 0 ? injected : data
    };
};


/***/ }),

/***/ 12391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ AccountNav; }
/* harmony export */ });
/* unused harmony export iconLinkStyles */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69293);
/* harmony import */ var remixicon_react_User3LineIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19878);
/* harmony import */ var remixicon_react_User3LineIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_User3LineIcon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31041);
/* harmony import */ var remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_Building4LineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64402);
/* harmony import */ var remixicon_react_Building4LineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Building4LineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(186);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41145);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54572);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var src_utils_strings__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8597);
/* harmony import */ var _utils_paths__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27827);
/* harmony import */ var _common_Link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5695);
/* harmony import */ var _themes_theme__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69431);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(84047);
/* harmony import */ var _context_UserContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(76336);
/* harmony import */ var _context_OverlayContext__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(33906);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  margin: 0 15px 0 10px;\n  font-size: 0.875rem;\n\n  ",
        "\n\n  @media screen and (max-width:1400px) {\n    display: none;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  white-space: nowrap;\n  position: relative;\n  cursor: pointer;\n  transition: transform 0.15s;\n  padding: 8px;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  display: none;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
















var NavBarIconText = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].span(_templateObject1(), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_6__.media.md(_templateObject()));
var iconLinkStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__.css)(_templateObject2(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_5__/* .palette */ .DG)("primary"));
var ShoppingListLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__["default"])(_common_Link__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_templateObject4(), iconLinkStyles, styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_6__.media.md(_templateObject3()));
var UserIconButton = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].div(_templateObject5(), iconLinkStyles);
var UserWrapper = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].div(_templateObject6());
var UserIconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].div(_templateObject7(), iconLinkStyles);
var AccountNav = function() {
    var ref;
    var ref1 = (0,_context_UserContext__WEBPACK_IMPORTED_MODULE_12__/* .useUser */ .aF)(), user = ref1.user, currentCompany = ref1.currentCompany, showLogin = ref1.showLogin;
    var setSideDrawerIsOpen = (0,_context_OverlayContext__WEBPACK_IMPORTED_MODULE_13__/* .useOverlay */ .Ir)().setSideDrawerIsOpen;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showUserDropdown = ref2[0], setShowUserDropdown = ref2[1];
    var userMenuRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var handleClick = function() {
        setSideDrawerIsOpen(true);
    };
    var toggleDropdown = function() {
        setShowUserDropdown(!showUserDropdown);
    };
    (0,react_use__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(userMenuRef, function() {
        setShowUserDropdown(false);
    });
    if (!showLogin) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ShoppingListLink, {
                    href: _utils_paths__WEBPACK_IMPORTED_MODULE_8__/* .paths.shoppingList */ .H.shoppingList,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_3___default()), {
                            color: _themes_theme__WEBPACK_IMPORTED_MODULE_10__/* ["default"].palette.red */ .Z.palette.red,
                            size: 28
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavBarIconText, {
                            children: "\xd3skalistar"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UserWrapper, {
                    ref: userMenuRef,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserIconWrapper, {
                            onClick: toggleDropdown,
                            children: currentCompany ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Building4LineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        color: _themes_theme__WEBPACK_IMPORTED_MODULE_10__/* ["default"].palette.red */ .Z.palette.red,
                                        size: 26
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavBarIconText, {
                                        children: currentCompany.name
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_User3LineIcon__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        color: _themes_theme__WEBPACK_IMPORTED_MODULE_10__/* ["default"].palette.red */ .Z.palette.red,
                                        size: 28
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavBarIconText, {
                                        children: (ref = (0,src_utils_strings__WEBPACK_IMPORTED_MODULE_7__/* .splitName */ .cF)(user.name)) === null || ref === void 0 ? void 0 : ref[0]
                                    })
                                ]
                            })
                        }),
                        showUserDropdown && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_11__/* .AccountNavDropdown */ .p8, {
                            setShowUserDropdown: setShowUserDropdown
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(UserIconButton, {
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_User3LineIcon__WEBPACK_IMPORTED_MODULE_2___default()), {
                    color: _themes_theme__WEBPACK_IMPORTED_MODULE_10__/* ["default"].palette.red */ .Z.palette.red,
                    size: 28
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NavBarIconText, {
                    children: "Innskr\xe1ning"
                })
            ]
        })
    });
};


/***/ }),

/***/ 77019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ account_AccountPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-bootstrap-grid/dist/index.js
var dist = __webpack_require__(54572);
// EXTERNAL MODULE: ./src/components/layout/index.ts + 8 modules
var layout = __webpack_require__(49012);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./src/components/products/index.tsx + 38 modules
var products = __webpack_require__(18254);
// EXTERNAL MODULE: ./src/utils/paths.ts
var paths = __webpack_require__(27827);
// EXTERNAL MODULE: ./src/themes/index.tsx
var themes = __webpack_require__(52287);
// EXTERNAL MODULE: ./node_modules/styled-tools/dist/es/index.js + 6 modules
var es = __webpack_require__(41145);
;// CONCATENATED MODULE: ./src/components/account/AccountPage/BreadcrumbWrapper.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 5px 10px;\n  border-bottom: 1px solid ",
        ";\n  width: 100%;\n  margin: 0 45px;\n  @media (max-width: ",
        "px) {\n    margin: 0 10px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var BreadcrumbWrapper = (0,styled_components_browser_esm["default"])(dist.Container)(_templateObject(), (0,es/* palette */.DG)("primary"), themes/* gridTheme.breakpoints.sm */.k.breakpoints.sm);

// EXTERNAL MODULE: ./node_modules/remixicon-react/Layout2LineIcon.js
var Layout2LineIcon = __webpack_require__(54527);
var Layout2LineIcon_default = /*#__PURE__*/__webpack_require__.n(Layout2LineIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/UserLineIcon.js
var UserLineIcon = __webpack_require__(12331);
var UserLineIcon_default = /*#__PURE__*/__webpack_require__.n(UserLineIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/Building4LineIcon.js
var Building4LineIcon = __webpack_require__(64402);
var Building4LineIcon_default = /*#__PURE__*/__webpack_require__.n(Building4LineIcon);
;// CONCATENATED MODULE: ./src/components/account/AccountPage/items.tsx
// import HeartLineIcon from 'remixicon-react/HeartLineIcon'




var items = [
    {
        key: "account",
        title: "Yfirlit",
        href: paths/* paths.account */.H.account,
        icon: (Layout2LineIcon_default())
    },
    {
        key: "myInfo",
        title: "M\xednar uppl\xfdsingar",
        href: paths/* paths.myInfo */.H.myInfo,
        icon: (UserLineIcon_default())
    },
    {
        key: "myOrders",
        title: "M\xednar pantanir",
        href: paths/* paths.myOrders */.H.myOrders,
        icon: (UserLineIcon_default())
    },
    {
        key: "fyrirtaekjabeidni",
        title: "Tengjast fyrirt\xe6ki",
        href: paths/* paths.companyRequest */.H.companyRequest,
        icon: (Building4LineIcon_default())
    }, 
];

// EXTERNAL MODULE: ./src/components/account/hooks/useCurrentPath.tsx
var useCurrentPath = __webpack_require__(77965);
;// CONCATENATED MODULE: ./src/components/account/AccountPage/BreadcrumbsBar.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var DEFAULT_BREADCRUMBS_ITEMS = [
    {
        title: "Fors\xed\xf0a",
        href: paths/* paths.home */.H.home
    }, 
];
function BreadcrumbsBar() {
    var currentPath = (0,useCurrentPath/* useCurrentPath */.J)();
    var breadcrumItems = (0,react.useMemo)(function() {
        var item = items.find(function(value) {
            return value.href === currentPath;
        }, []) || items[0];
        return _toConsumableArray(DEFAULT_BREADCRUMBS_ITEMS).concat([
            item
        ]);
    }, [
        currentPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(products/* Breadcrumbs */.Oo, {
            breadcrumbs: breadcrumItems
        })
    });
}

// EXTERNAL MODULE: ./src/components/account/hooks/useHasLowResolution.ts
var useHasLowResolution = __webpack_require__(69580);
;// CONCATENATED MODULE: ./src/components/account/AccountPage/AccountPage.tsx
function AccountPage_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function AccountPage_templateObject() {
    var data = AccountPage_taggedTemplateLiteral([
        "\n  margin: 0 12px 10px 21px;\n  margin: auto;\n"
    ]);
    AccountPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var AccountContainer = (0,styled_components_browser_esm["default"])(dist.Container)(AccountPage_templateObject());
function AccountPage(param) {
    var children = param.children, cols = param.cols;
    var hasLowResolution = (0,useHasLowResolution/* useHasLowResolution */.P)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbsBar, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                    sm: cols || (hasLowResolution ? 12 : 9),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* SpacingWrapper */.$3, {
                        spacing: 60,
                        children: children
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/account/AccountPage/index.ts

/* harmony default export */ var account_AccountPage = (AccountPage);


/***/ }),

/***/ 77834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ AddressForm; }
/* harmony export */ });
/* unused harmony exports Form, FormContainer, FormWrapper, TitleWrapper, ButtonWrapper */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59433);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54572);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(186);
/* harmony import */ var src_api_saleor_generated__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49554);
/* harmony import */ var src_components_typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56795);
/* harmony import */ var src_utils_strings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8597);
/* harmony import */ var _form_Input__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92469);
/* harmony import */ var _buttons_Button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3798);
/* harmony import */ var _context_UserContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76336);
/* harmony import */ var _form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27618);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: start;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: 25px;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  padding-bottom: 0px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}












var Form = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].form(_templateObject());
var FormContainer = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div(_templateObject1());
var FormWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div(_templateObject2());
var TitleWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div(_templateObject3());
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div(_templateObject4());
function AddressForm(param1) {
    var id = param1.id, firstName = param1.firstName, lastName = param1.lastName, phone = param1.phone, streetAddress1 = param1.streetAddress1, city = param1.city, postalCode = param1.postalCode, setShow = param1.setShow, handleAddAddress = param1.handleAddAddress, formTitle = param1.formTitle;
    var validateAddressFormFields = function validateAddressFormFields(values) {
        var errors = {};
        if (!values.lastName) {
            errors.lastName = "H\xe9r vantar kennit\xf6lu";
        } else if (!(0,src_utils_strings__WEBPACK_IMPORTED_MODULE_6__/* .isValidSsn */ .aR)(values.lastName)) {
            errors.lastName = "\xd3gild kennitala";
        }
        if (!values.firstName) {
            errors.firstName = "H\xe9r vantar nafn";
        }
        if (!values.streetAddress1) {
            errors.streetAddress1 = "H\xe9r vantar heimilisfang";
        }
        if (!values.city) {
            errors.city = "H\xe9r vantar sta\xf0";
        }
        if (!values.postalCode) {
            errors.postalCode = "H\xe9r vantar p\xf3stn\xfamer";
        }
        if (!values.phone) {
            errors.phone = "H\xe9r vantar s\xedman\xfamer";
        } else if (!src_utils_strings__WEBPACK_IMPORTED_MODULE_6__/* .phoneRegExp.test */ .Oj.test(values.phone)) {
            errors.phone = "S\xedman\xfamer \xfearf a\xf0 vera 7 t\xf6lustafir";
        }
        return errors;
    };
    var ref = (0,_context_UserContext__WEBPACK_IMPORTED_MODULE_9__/* .useUser */ .aF)(), createAddress = ref.createAddress, updateAddress = ref.updateAddress, deleteAddress = ref.deleteAddress;
    var onComplete = function(address) {
        if (setShow) {
            setShow(false);
        }
        if (handleAddAddress) {
            handleAddAddress(address);
        }
    };
    var code = src_api_saleor_generated__WEBPACK_IMPORTED_MODULE_4__/* .CountryCode.Is */ .CvE.Is;
    var initialValues = {
        firstName: firstName,
        lastName: lastName,
        phone: phone,
        streetAddress1: streetAddress1,
        city: city,
        postalCode: postalCode,
        country: code
    };
    var formik = (0,formik__WEBPACK_IMPORTED_MODULE_2__/* .useFormik */ .TA)({
        initialValues: initialValues,
        validateOnChange: false,
        validate: function(values) {
            return validateAddressFormFields(values);
        },
        onSubmit: function(values, param) {
            var resetForm = param.resetForm;
            if (!id) {
                createAddress(values).then(function(res) {
                    if (res && formTitle === "M\xf3ttakandi" || res && formTitle === "Grei\xf0andi") {
                        onComplete(res);
                    } else if (setShow) {
                        setShow(false);
                    }
                });
            } else {
                updateAddress(id, values);
                if (setShow) {
                    setShow(false);
                }
            }
            resetForm();
        }
    });
    var handleDelete = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (id) {
            deleteAddress(id);
        }
        if (setShow) {
            setShow(false);
        }
    }, [
        deleteAddress,
        id,
        setShow
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FormContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TitleWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_typography__WEBPACK_IMPORTED_MODULE_5__/* .Title5 */ .IV, {
                    children: formTitle
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FormWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Form, {
                    onSubmit: formik.handleSubmit,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Row, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Col, {
                                md: 6,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form__WEBPACK_IMPORTED_MODULE_10__/* .CleaveInput */ .n7, {
                                    label: "Kennitala",
                                    name: "lastName",
                                    type: "tel",
                                    onChange: formik.handleChange,
                                    withGutter: true,
                                    value: lastName,
                                    showError: !!formik.errors.lastName,
                                    errorMsg: formik.errors.lastName,
                                    options: {
                                        numericOnly: true,
                                        delimiters: [
                                            "-"
                                        ],
                                        blocks: [
                                            6,
                                            4
                                        ]
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Col, {
                                md: 6,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form_Input__WEBPACK_IMPORTED_MODULE_7__/* .Input */ .II, {
                                    label: "Nafn",
                                    name: "firstName",
                                    type: "text",
                                    onChange: formik.handleChange,
                                    withGutter: true,
                                    defaultValue: firstName,
                                    showError: !!formik.errors.firstName,
                                    errorMsg: formik.errors.firstName
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Col, {
                                md: 6,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form__WEBPACK_IMPORTED_MODULE_10__/* .CleaveInput */ .n7, {
                                    label: "S\xedman\xfamer",
                                    name: "phone",
                                    type: "tel",
                                    onChange: formik.handleChange,
                                    withGutter: true,
                                    value: phone,
                                    showError: !!formik.errors.phone,
                                    errorMsg: formik.errors.phone,
                                    options: {
                                        numericOnly: true,
                                        delimiters: [
                                            " "
                                        ],
                                        blocks: [
                                            3,
                                            4
                                        ]
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Col, {
                                md: 6,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form_Input__WEBPACK_IMPORTED_MODULE_7__/* .Input */ .II, {
                                    label: "Heimilisfang",
                                    name: "streetAddress1",
                                    type: "text",
                                    onChange: formik.handleChange,
                                    withGutter: true,
                                    defaultValue: streetAddress1,
                                    showError: !!formik.errors.streetAddress1,
                                    errorMsg: formik.errors.streetAddress1
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Col, {
                                md: 6,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form__WEBPACK_IMPORTED_MODULE_10__/* .CleaveInput */ .n7, {
                                    label: "P\xf3stn\xfamer",
                                    name: "postalCode",
                                    type: "tel",
                                    onChange: formik.handleChange,
                                    withGutter: true,
                                    value: postalCode,
                                    showError: !!formik.errors.postalCode,
                                    errorMsg: formik.errors.postalCode,
                                    options: {
                                        numericOnly: true,
                                        blocks: [
                                            3
                                        ]
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Col, {
                                md: 6,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form_Input__WEBPACK_IMPORTED_MODULE_7__/* .Input */ .II, {
                                    label: "Sta\xf0ur",
                                    name: "city",
                                    type: "text",
                                    onChange: formik.handleChange,
                                    withGutter: true,
                                    defaultValue: city,
                                    showError: !!formik.errors.city,
                                    errorMsg: formik.errors.city
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Col, {
                                md: 6,
                                children: id && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    fill: true,
                                    withGutter: true,
                                    outlined: true,
                                    onClick: handleDelete,
                                    children: "Ey\xf0a"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Col, {
                                md: 6,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons_Button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    fill: true,
                                    withGutter: true,
                                    type: "submit",
                                    children: "Vista"
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 65260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InfoCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(186);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41145);
/* harmony import */ var remixicon_react_PencilLineIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53320);
/* harmony import */ var remixicon_react_PencilLineIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_PencilLineIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_DeleteBinLineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39285);
/* harmony import */ var remixicon_react_DeleteBinLineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_DeleteBinLineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54572);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _buttons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31494);
/* harmony import */ var _typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56795);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n\n  margin: 16px 0;\n  width: 100%;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n\n  &.selected {\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    padding: 34px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 34px 34px 34px 24px;\n  cursor: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    padding-right: 50px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  padding-right: 24px;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}










var CardWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("white"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("red"));
var Card = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject2(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .ifProp */ .fq)({
    pointerCursor: true
}, "pointer", "default"), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_5__.media.md(_templateObject1()));
var Inner = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject3());
var IconContainer = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject5(), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_5__.media.md(_templateObject4()));
var TextContainer = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject6());
var Description = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject7());
function InfoCard(param) {
    var icon = param.icon, deleteIcon = param.deleteIcon, title = param.title, description = param.description, onSelect = param.onSelect, handleEdit = param.handleEdit, handleDelete = param.handleDelete, cornerButton = param.cornerButton, _selected = param.selected, selected = _selected === void 0 ? false : _selected, _pointerCursor = param.pointerCursor, pointerCursor = _pointerCursor === void 0 ? false : _pointerCursor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CardWrapper, {
        className: classnames__WEBPACK_IMPORTED_MODULE_6___default()({
            selected: selected
        }),
        children: [
            cornerButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons__WEBPACK_IMPORTED_MODULE_7__/* .CornerButton */ .gm, {
                icon: deleteIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_DeleteBinLineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                    size: 16
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_PencilLineIcon__WEBPACK_IMPORTED_MODULE_3___default()), {
                    size: 16
                }),
                onClick: handleEdit || handleDelete
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, {
                pointerCursor: pointerCursor,
                onClick: onSelect && onSelect,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Inner, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconContainer, {
                            children: icon
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TextContainer, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_8__/* .Title8 */ .Mk, {
                                    withGutter: true,
                                    children: title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Description, {
                                    children: description
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 91541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LoginPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/context/OverlayContext.tsx
var OverlayContext = __webpack_require__(33906);
// EXTERNAL MODULE: ./src/context/UserContext.tsx + 1 modules
var UserContext = __webpack_require__(76336);
// EXTERNAL MODULE: ./src/components/account/index.tsx + 9 modules
var account = __webpack_require__(84047);
// EXTERNAL MODULE: ./src/components/common/index.tsx + 15 modules
var common = __webpack_require__(69446);
// EXTERNAL MODULE: ./src/components/registration/ShowEnd.tsx
var ShowEnd = __webpack_require__(8134);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 120 modules
var formik_esm = __webpack_require__(59433);
// EXTERNAL MODULE: ./src/utils/validation.ts
var validation = __webpack_require__(37424);
// EXTERNAL MODULE: ./src/constants/index.ts + 1 modules
var constants = __webpack_require__(31115);
// EXTERNAL MODULE: ./src/components/buttons/index.tsx + 6 modules
var buttons = __webpack_require__(31494);
// EXTERNAL MODULE: ./src/components/form/index.tsx + 3 modules
var components_form = __webpack_require__(27618);
// EXTERNAL MODULE: ./src/components/typography/index.tsx + 1 modules
var typography = __webpack_require__(56795);
;// CONCATENATED MODULE: ./src/components/account/EmailForm.tsx








var Form = function(param) {
    var handleSubmit = param.handleSubmit, isSubmitting = param.isSubmitting;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H5, {
                withGutter: true,
                children: "Hva\xf0 er netfangi\xf0 \xfeitt?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                withGutter: true,
                children: "Netfangi\xf0 er nota\xf0 til a\xf0 senda uppl\xfdsingar um p\xf6ntun. Vi\xf0 munum ekki nota \xfea\xf0 til a\xf0 senda \xfe\xe9r fj\xf6lp\xf3st."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginBottom: "38px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_form/* FormikInput */.jc, {
                    name: "email",
                    type: "email",
                    label: "Netfang"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                type: "submit",
                withGutter: true,
                loading: isSubmitting,
                children: "\xc1fram"
            })
        ]
    });
};
var EmailForm = (0,formik_esm/* withFormik */.j0)({
    mapPropsToValues: function() {
        return {
            email: ""
        };
    },
    validate: function(param) {
        var email = param.email;
        var errors = {};
        if (!email) {
            errors.email = "H\xe9r vantar netfang";
        } else if (!(0,validation/* validateEmail */.o)(email)) {
            errors.email = "Netfangi\xf0 er ekki \xe1 r\xe9ttu formi";
        }
        return errors;
    },
    handleSubmit: function(values, param) {
        var _props = param.props, id = _props.id, changeUserEmail = _props.changeUserEmail, setFieldError = param.setFieldError, setSubmitting = param.setSubmitting;
        changeUserEmail(id, values).then(function() {
            return setSubmitting(false);
        }).catch(function(err) {
            var ref;
            var error = constants/* emailChangeErrorCodeStrings */.v1[err === null || err === void 0 ? void 0 : (ref = err.error) === null || ref === void 0 ? void 0 : ref.code];
            setFieldError("email", error || "\xd3\xfeekkt villa, reyni\xf0 aftur s\xed\xf0ar");
            setSubmitting(false);
        });
    },
    displayName: "EmailForm"
})(Form);
/* harmony default export */ var account_EmailForm = (EmailForm);

;// CONCATENATED MODULE: ./src/components/account/LoginPage.tsx








// TODO(style): Needs better styling/design
function LoginPage() {
    var ref = (0,UserContext/* useUser */.aF)(), user = ref.user, missingEmail = ref.missingEmail, changeUserEmail = ref.changeUserEmail, userLoading = ref.userLoading, userCompanies = ref.userCompanies, userCompaniesLoading = ref.userCompaniesLoading, showChooseCustomer = ref.showChooseCustomer, showRegistrationMsg = ref.showRegistrationMsg, resetUser = ref.resetUser, selectAccount = ref.selectAccount;
    var setSideDrawerIsOpen = (0,OverlayContext/* useOverlay */.Ir)().setSideDrawerIsOpen;
    var showSelectAccount = showChooseCustomer && selectAccount && userCompanies.length > 0;
    var showLoader = userLoading || user && userCompaniesLoading;
    var showLoginForm = !user && !userLoading || resetUser;
    var showEmailForm = user && missingEmail;
    var showCompanyUserForm = user && !missingEmail && !(userCompanies === null || userCompanies === void 0 ? void 0 : userCompanies.length) && !showRegistrationMsg && !userCompaniesLoading;
    (0,react.useEffect)(function() {
        if (showSelectAccount) {
            requestAnimationFrame(function() {
                return setSideDrawerIsOpen(true);
            });
        } else {
            requestAnimationFrame(function() {
                return setSideDrawerIsOpen(false);
            });
        }
    }, [
        setSideDrawerIsOpen,
        showSelectAccount
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Loader */.aN, {}),
            showLoginForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(account/* LoginForm */.U0, {}),
            showEmailForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(account_EmailForm, {
                changeUserEmail: changeUserEmail,
                id: user === null || user === void 0 ? void 0 : user.id
            }),
            showCompanyUserForm && /*#__PURE__*/ (0,jsx_runtime.jsx)(account/* CompanyUserForm */._1, {}),
            showRegistrationMsg && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowEnd/* ShowEnd */.U, {}),
            showSelectAccount && /*#__PURE__*/ (0,jsx_runtime.jsx)(account/* ChooseCustomer */.g6, {})
        ]
    });
};


/***/ }),

/***/ 37597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MyShoppingListPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54572);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_components_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56795);
/* harmony import */ var src_components_shoppingLists__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53220);





function MyShoppingListPage() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__.Row, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__.Col, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_typography__WEBPACK_IMPORTED_MODULE_3__.H5, {
                    withGutter: true,
                    children: "M\xednir \xd3skalistar"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_shoppingLists__WEBPACK_IMPORTED_MODULE_4__/* .ShoppingListsPage */ .EC, {})
            ]
        })
    });
};


/***/ }),

/***/ 72570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PaymentCardsInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_components_account_InfoCard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65260);
/* harmony import */ var remixicon_react_BankCard2LineIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70557);
/* harmony import */ var remixicon_react_BankCard2LineIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_BankCard2LineIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_components_typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56795);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52287);
/* harmony import */ var _context_UserContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76336);







function PaymentCardsInfo() {
    var valitorCards = (0,_context_UserContext__WEBPACK_IMPORTED_MODULE_6__/* .useUser */ .aF)().valitorCards;
    var handlePaymentCards = function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: valitorCards === null || valitorCards === void 0 ? void 0 : valitorCards.map(function(value) {
                var ref;
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_account_InfoCard__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_BankCard2LineIcon__WEBPACK_IMPORTED_MODULE_3___default()), {
                        size: 30,
                        color: src_themes__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.primary */ .r.palette.primary
                    }),
                    title: "",
                    description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_typography__WEBPACK_IMPORTED_MODULE_4__.P, {
                                children: [
                                    value.brand,
                                    " - ",
                                    (ref = value.maskedCardNumber) === null || ref === void 0 ? void 0 : ref.slice(-4)
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_typography__WEBPACK_IMPORTED_MODULE_4__.P, {
                                children: [
                                    "Gildist\xedmi ",
                                    value.expMonth,
                                    "/",
                                    value.expYear
                                ]
                            })
                        ]
                    })
                }, value.id);
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                !!(valitorCards === null || valitorCards === void 0 ? void 0 : valitorCards.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_typography__WEBPACK_IMPORTED_MODULE_4__/* .Title7 */ .Mz, {
                    withGutter: true,
                    children: "Veski"
                }),
                (valitorCards === null || valitorCards === void 0 ? void 0 : valitorCards.length) ? handlePaymentCards() : null
            ]
        })
    });
};


/***/ }),

/***/ 82977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UserInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var remixicon_react_User3LineIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19878);
/* harmony import */ var remixicon_react_User3LineIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_User3LineIcon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var kennitala__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61473);
/* harmony import */ var kennitala__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(kennitala__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_components_account_InfoCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65260);
/* harmony import */ var src_components_typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56795);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52287);
/* harmony import */ var src_utils_strings__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8597);
/* harmony import */ var _context_UserContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76336);









function UserInfo() {
    var ref, ref1, ref2;
    var user = (0,_context_UserContext__WEBPACK_IMPORTED_MODULE_8__/* .useUser */ .aF)().user;
    var ssn = user === null || user === void 0 ? void 0 : (ref = user.verified) === null || ref === void 0 ? void 0 : ref.ssn;
    var phoneNumber = (user === null || user === void 0 ? void 0 : (ref1 = user.verified) === null || ref1 === void 0 ? void 0 : ref1.phoneNumber) ? (0,src_utils_strings__WEBPACK_IMPORTED_MODULE_7__/* .formatPhoneNumber */ .un)(user === null || user === void 0 ? void 0 : (ref2 = user.verified) === null || ref2 === void 0 ? void 0 : ref2.phoneNumber) : "";
    /** This is only for debuging */ if (user === null) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: "Engar notenda uppl\xfdsingar fundust"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_typography__WEBPACK_IMPORTED_MODULE_5__/* .Title7 */ .Mz, {
                withGutter: true,
                children: "Pers\xf3nuuppl\xfdsingar"
            }),
            user && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_account_InfoCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_User3LineIcon__WEBPACK_IMPORTED_MODULE_2___default()), {
                    size: 30,
                    color: src_themes__WEBPACK_IMPORTED_MODULE_6__/* .theme.palette.primary */ .r.palette.primary
                }),
                title: "".concat(user.name),
                description: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_typography__WEBPACK_IMPORTED_MODULE_5__.P, {
                            children: ssn && (0,kennitala__WEBPACK_IMPORTED_MODULE_3__.format)(ssn)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_typography__WEBPACK_IMPORTED_MODULE_5__.P, {
                            children: phoneNumber
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_typography__WEBPACK_IMPORTED_MODULE_5__.P, {
                            children: user.email
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 84390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UserOverview; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-bootstrap-grid/dist/index.js
var dist = __webpack_require__(54572);
// EXTERNAL MODULE: ./src/components/typography/index.tsx + 1 modules
var typography = __webpack_require__(56795);
// EXTERNAL MODULE: ./src/components/layout/index.ts + 8 modules
var layout = __webpack_require__(49012);
// EXTERNAL MODULE: ./src/components/account/UserInfo.tsx
var UserInfo = __webpack_require__(82977);
// EXTERNAL MODULE: ./src/components/account/PaymentCardsInfo.tsx
var PaymentCardsInfo = __webpack_require__(72570);
// EXTERNAL MODULE: ./node_modules/remixicon-react/Home4LineIcon.js
var Home4LineIcon = __webpack_require__(8778);
var Home4LineIcon_default = /*#__PURE__*/__webpack_require__.n(Home4LineIcon);
// EXTERNAL MODULE: ./src/components/account/InfoCard.tsx
var InfoCard = __webpack_require__(65260);
// EXTERNAL MODULE: ./src/themes/index.tsx
var themes = __webpack_require__(52287);
// EXTERNAL MODULE: ./node_modules/remixicon-react/AddLineIcon.js
var AddLineIcon = __webpack_require__(69675);
var AddLineIcon_default = /*#__PURE__*/__webpack_require__.n(AddLineIcon);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(8597);
// EXTERNAL MODULE: ./src/utils/isNotNull.ts
var isNotNull = __webpack_require__(84403);
// EXTERNAL MODULE: ./src/components/buttons/index.tsx + 6 modules
var buttons = __webpack_require__(31494);
// EXTERNAL MODULE: ./src/context/UserContext.tsx + 1 modules
var UserContext = __webpack_require__(76336);
// EXTERNAL MODULE: ./src/components/common/Modal.tsx + 32 modules
var Modal = __webpack_require__(92627);
// EXTERNAL MODULE: ./src/components/account/AddressForm.tsx
var AddressForm = __webpack_require__(77834);
;// CONCATENATED MODULE: ./src/components/account/AddressInfo.tsx













function AddressInfo() {
    var ref13, ref1, ref2, ref3;
    var ref4 = (0,UserContext/* useUser */.aF)(), user = ref4.user, addressData = ref4.addressData;
    var ref5 = (0,react.useState)(false), show = ref5[0], setShow = ref5[1];
    var ref6 = (0,react.useState)(""), ID = ref6[0], setID = ref6[1];
    var ref7 = (0,react.useState)(""), firstNameValue = ref7[0], setFirstNameValue = ref7[1];
    var ref8 = (0,react.useState)(""), lastNameValue = ref8[0], setLastNameValue = ref8[1];
    var ref9 = (0,react.useState)(""), phoneValue = ref9[0], setPhoneValue = ref9[1];
    var ref10 = (0,react.useState)(""), address = ref10[0], setAddress = ref10[1];
    var ref11 = (0,react.useState)(""), cityValue = ref11[0], setCityValue = ref11[1];
    var ref12 = (0,react.useState)(""), postalCodeValue = ref12[0], setPostalCodeValue = ref12[1];
    var handleAddress = (0,react.useCallback)(function() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, id = ref.id, firstName = ref.firstName, lastName = ref.lastName, phone = ref.phone, streetAddress1 = ref.streetAddress1, city = ref.city, postalCode = ref.postalCode;
        if (!id) {
            setID("");
            setFirstNameValue("");
            setLastNameValue("");
            setPhoneValue("");
            setAddress("");
            setCityValue("");
            setPostalCodeValue("");
            setShow(true);
        }
        setID(id !== null && id !== void 0 ? id : "");
        setFirstNameValue(firstName !== null && firstName !== void 0 ? firstName : "");
        setLastNameValue(lastName !== null && lastName !== void 0 ? lastName : "");
        setPhoneValue((0,strings/* formatPhoneNumberNoSpaces */.fc)(phone !== null && phone !== void 0 ? phone : ""));
        setAddress(streetAddress1 !== null && streetAddress1 !== void 0 ? streetAddress1 : "");
        setCityValue(city !== null && city !== void 0 ? city : "");
        setPostalCodeValue(postalCode !== null && postalCode !== void 0 ? postalCode : "");
        setShow(true);
    }, [
        setShow,
        setID
    ]);
    var handleAddresses = function() {
        var ref, ref14;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: addressData === null || addressData === void 0 ? void 0 : (ref = addressData.me) === null || ref === void 0 ? void 0 : (ref14 = ref.addresses) === null || ref14 === void 0 ? void 0 : ref14.filter(isNotNull/* isNotNull */.K).map(function(value) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoCard/* default */.Z, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((Home4LineIcon_default()), {
                        size: 30,
                        color: themes/* theme.palette.primary */.r.palette.primary
                    }),
                    title: "",
                    description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography.P, {
                                children: [
                                    value.streetAddress1,
                                    ","
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography.P, {
                                children: [
                                    value.postalCode,
                                    " ",
                                    value.city
                                ]
                            })
                        ]
                    }),
                    cornerButton: true,
                    handleEdit: function() {
                        return handleAddress(value);
                    }
                }, value.id);
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title7 */.Mz, {
                        withGutter: true,
                        children: "Heimilisf\xf6ng"
                    }),
                    !!(addressData === null || addressData === void 0 ? void 0 : (ref13 = addressData.me) === null || ref13 === void 0 ? void 0 : (ref1 = ref13.addresses) === null || ref1 === void 0 ? void 0 : ref1.length) && handleAddresses(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* UnderlineButton */.tg, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((AddLineIcon_default()), {
                            color: themes/* theme.palette.primary */.r.palette.primary
                        }),
                        text: "N\xfdtt heimilisfang",
                        onClick: function() {
                            return handleAddress();
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                width: "800px",
                setShow: setShow,
                show: show,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressForm/* default */.ZP, {
                    id: ID,
                    formTitle: "Heimilisfang",
                    firstName: firstNameValue || (user === null || user === void 0 ? void 0 : user.name),
                    lastName: lastNameValue || (user === null || user === void 0 ? void 0 : (ref2 = user.verified) === null || ref2 === void 0 ? void 0 : ref2.ssn),
                    phone: phoneValue || (user === null || user === void 0 ? void 0 : (ref3 = user.verified) === null || ref3 === void 0 ? void 0 : ref3.phoneNumber),
                    streetAddress1: address,
                    city: cityValue,
                    postalCode: postalCodeValue,
                    setShow: setShow
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/account/UserOverview.tsx








function UserOverview() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Col, {
            sm: 5,
            smOffset: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H5, {
                    withGutter: true,
                    children: "M\xednar Uppl\xfdsingar"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* SpacingWrapper */.$3, {
                    spacing: 24,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfo/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* SpacingWrapper */.$3, {
                    spacing: 24,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressInfo, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* SpacingWrapper */.$3, {
                    spacing: 24,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentCardsInfo/* default */.Z, {})
                })
            ]
        })
    });
};


/***/ }),

/***/ 77965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useCurrentPath; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);

function useCurrentPath() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var hasSlash = router.asPath.slice(-1) === "/";
    var currentPath = "".concat(router.asPath).concat(hasSlash ? "" : "/");
    return currentPath;
}


/***/ }),

/***/ 69580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useHasLowResolution; }
/* harmony export */ });
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52287);
/* harmony import */ var _useSize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66374);


var viewports = {
    high: src_themes__WEBPACK_IMPORTED_MODULE_0__/* .gridTheme.breakpoints.md */ .k.breakpoints.md,
    low: 0
};
function useHasLowResolution() {
    var resolution = (0,_useSize__WEBPACK_IMPORTED_MODULE_1__/* .useSize */ .t)({
        viewports: viewports
    });
    return resolution === "low";
}


/***/ }),

/***/ 66374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var use_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19302);


function useSize(param) {
    var viewports = param.viewports, _defaultSize = param.defaultSize, defaultSize = _defaultSize === void 0 ? 0 : _defaultSize;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)( false ? 0 : window.innerWidth), windowWidth = ref[0], setWindowWidth = ref[1];
    var handleResize = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setWindowWidth(window.innerWidth);
    }, []);
    var handleResizeDebounce = (0,use_debounce__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(handleResize);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        window.addEventListener("resize", handleResizeDebounce);
        return function() {
            window.removeEventListener("resize", handleResizeDebounce);
        };
    }, [
        handleResizeDebounce
    ]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var keys = Object.keys(viewports);
        var key = keys.find(function(currentKey) {
            return viewports[currentKey] <= windowWidth;
        });
        return key !== null && key !== void 0 ? key : keys[keys.length - 1];
    }, [
        viewports,
        windowWidth
    ]);
}


/***/ }),

/***/ 84047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p8": function() { return /* reexport */ AccountNavDropdown; },
  "w1": function() { return /* reexport */ AccountPage/* default */.Z; },
  "g6": function() { return /* reexport */ ChooseCustomer; },
  "b_": function() { return /* reexport */ ChooseCustomerCard; },
  "_e": function() { return /* reexport */ CompanyRequestPage; },
  "_1": function() { return /* reexport */ account_CompanyUserForm; },
  "iG": function() { return /* reexport */ EmailLoginForm; },
  "rJ": function() { return /* reexport */ account_InfoCard/* default */.Z; },
  "U0": function() { return /* reexport */ LoginForm; }
});

// UNUSED EXPORTS: AccountNav, AddressForm, CompanyInfo, LoginPage, MyShoppingListPage, PaymentCardsInfo, UserInfo, UserOverview

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 120 modules
var formik_esm = __webpack_require__(59433);
// EXTERNAL MODULE: ./src/context/UserContext.tsx + 1 modules
var UserContext = __webpack_require__(76336);
// EXTERNAL MODULE: ./src/components/typography/index.tsx + 1 modules
var typography = __webpack_require__(56795);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(8597);
// EXTERNAL MODULE: ./src/components/layout/index.ts + 8 modules
var layout = __webpack_require__(49012);
// EXTERNAL MODULE: ./src/components/buttons/index.tsx + 6 modules
var buttons = __webpack_require__(31494);
// EXTERNAL MODULE: ./src/components/common/Loader.tsx
var Loader = __webpack_require__(965);
// EXTERNAL MODULE: ./src/components/form/index.tsx + 3 modules
var components_form = __webpack_require__(27618);
;// CONCATENATED MODULE: ./src/components/account/LoginForm.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 50px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: 18px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  color: #ef3f57;\n  font-weight: normal;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

/* eslint-disable no-console */ 










var Divider = styled_components_browser_esm["default"].div(_templateObject());
var LoaderWrapper = styled_components_browser_esm["default"].div(_templateObject1());
var LoadingMsg = styled_components_browser_esm["default"].div(_templateObject2());
var ErrorTitle = (0,styled_components_browser_esm["default"])(typography/* Title6 */.L8)(_templateObject3());
function LoginForm() {
    var ref = (0,UserContext/* useUser */.aF)(), signIn = ref.signIn, errorMsg = ref.errorMsg, isVerifyingLogin = ref.isVerifyingLogin, resetUser = ref.resetUser;
    // Initial values for formik hook
    var initialValues = {
        phoneNumber: ""
    };
    // Defining a scema for yup validation
    var phoneNumberSchema = es/* object */.Ry().shape({
        phoneNumber: es/* string */.Z_().matches(strings/* phoneRegExp */.Oj, "S\xedman\xfamer \xfearf a\xf0 vera 7 t\xf6lustafir").required("H\xe9r vantar s\xedman\xfamer")
    });
    // UseFormik to handle the form and validate it with yub
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: initialValues,
        validationSchema: phoneNumberSchema,
        validateOnChange: false,
        onSubmit: function(values, param) {
            var resetForm = param.resetForm;
            var phone = (0,strings/* parsePhoneNumber */.SR)(values.phoneNumber);
            signIn(phone);
            resetForm();
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isVerifyingLogin ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoaderWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingMsg, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title6 */.L8, {
                        children: "Au\xf0kenning hefur veri\xf0 send."
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                resetUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorTitle, {
                    withGutter: true,
                    children: "Notandalotunni \xfeinni er loki\xf0"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title4 */.Gn, {
                    withGutter: true,
                    children: "Innskr\xe1ning me\xf0 rafr\xe6num skilr\xedkjum"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* SpacingWrapper */.$3, {
                    spacing: 24,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: formik.handleSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_form/* CleaveInput */.n7, {
                                label: "S\xedman\xfamer",
                                name: "phoneNumber",
                                type: "tel",
                                showError: !!formik.errors.phoneNumber || !!errorMsg,
                                errorMsg: formik.errors.phoneNumber || errorMsg || "",
                                onChange: formik.handleChange,
                                options: {
                                    numericOnly: true,
                                    delimiters: [
                                        " "
                                    ],
                                    blocks: [
                                        3,
                                        4
                                    ]
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                                type: "submit",
                                children: "Skr\xe1 inn"
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/remixicon-react/EyeLineIcon.js
var EyeLineIcon = __webpack_require__(25039);
var EyeLineIcon_default = /*#__PURE__*/__webpack_require__.n(EyeLineIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/EyeOffLineIcon.js
var EyeOffLineIcon = __webpack_require__(58773);
var EyeOffLineIcon_default = /*#__PURE__*/__webpack_require__.n(EyeOffLineIcon);
// EXTERNAL MODULE: ./src/utils/validation.ts
var validation = __webpack_require__(37424);
// EXTERNAL MODULE: ./src/components/form/Input.tsx
var Input = __webpack_require__(92469);
;// CONCATENATED MODULE: ./src/components/account/EmailLoginForm.tsx
function EmailLoginForm_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function EmailLoginForm_templateObject() {
    var data = EmailLoginForm_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 18px;\n"
    ]);
    EmailLoginForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmailLoginForm_templateObject1() {
    var data = EmailLoginForm_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    EmailLoginForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

/* eslint-disable no-console */ 











var EmailLoginForm_Divider = styled_components_browser_esm["default"].div(EmailLoginForm_templateObject());
var EmailLoginForm_LoaderWrapper = styled_components_browser_esm["default"].div(EmailLoginForm_templateObject1());
function EmailLoginForm() {
    var validateEmailLoginFormFields = function validateEmailLoginFormFields(values) {
        var errors = {};
        if (!values.email) {
            errors.email = "H\xe9r vantar netfang";
        } else if (!(0,validation/* validateEmail */.o)(values.email)) {
            errors.email = "Netfangi\xf0 er ekki \xe1 r\xe9ttu formi";
        }
        if (!values.password) {
            errors.password = "H\xe9r vantar lykilor\xf0";
        }
        return errors;
    };
    var ref = (0,UserContext/* useUser */.aF)(), signInWithEmail = ref.signInWithEmail, errorMsg = ref.errorMsg, setErrorMsg = ref.setErrorMsg, isVerifyingLogin = ref.isVerifyingLogin;
    var ref1 = (0,react.useState)(false), showPassword = ref1[0], setShowPassword = ref1[1];
    var togglePassword = (0,react.useCallback)(function() {
        setShowPassword(!showPassword);
    }, [
        showPassword
    ]);
    var initialValues = {
        email: "",
        password: ""
    };
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: initialValues,
        validateOnChange: false,
        validate: function(values) {
            return validateEmailLoginFormFields(values);
        },
        onSubmit: function(values) {
            signInWithEmail(values.email, values.password);
        }
    });
    var handleClick = (0,react.useCallback)(function() {
        setErrorMsg(null);
    }, [
        setErrorMsg
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isVerifyingLogin ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailLoginForm_LoaderWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title4 */.Gn, {
                    withGutter: true,
                    children: "Innskr\xe1ning"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* SpacingWrapper */.$3, {
                    spacing: 24,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: formik.handleSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.II, {
                                label: "Netfang",
                                type: "email",
                                name: "email",
                                withGutter: true,
                                value: formik.values.email,
                                showError: !!formik.errors.email || !!errorMsg,
                                errorMsg: formik.errors.email || errorMsg || "",
                                onChange: formik.handleChange
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.II, {
                                label: "Lykilor\xf0",
                                type: showPassword ? "text" : "password",
                                name: "password",
                                withGutter: true,
                                value: formik.values.password,
                                showError: !!formik.errors.password || !!errorMsg,
                                errorMsg: formik.errors.password || errorMsg || "",
                                onChange: formik.handleChange,
                                icon: showPassword ? /*#__PURE__*/ (0,jsx_runtime.jsx)((EyeOffLineIcon_default()), {
                                    onClick: togglePassword,
                                    style: {
                                        cursor: "pointer"
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((EyeLineIcon_default()), {
                                    onClick: togglePassword,
                                    style: {
                                        cursor: "pointer"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailLoginForm_Divider, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                                onClick: handleClick,
                                type: "submit",
                                children: "Skr\xe1 inn"
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/account/UserInfo.tsx
var UserInfo = __webpack_require__(82977);
// EXTERNAL MODULE: ./src/components/account/AccountNav.tsx
var AccountNav = __webpack_require__(12391);
// EXTERNAL MODULE: ./src/components/account/AccountPage/index.ts + 4 modules
var AccountPage = __webpack_require__(77019);
// EXTERNAL MODULE: ./src/components/account/AddressForm.tsx
var AddressForm = __webpack_require__(77834);
// EXTERNAL MODULE: ./node_modules/remixicon-react/Building4LineIcon.js
var Building4LineIcon = __webpack_require__(64402);
var Building4LineIcon_default = /*#__PURE__*/__webpack_require__.n(Building4LineIcon);
// EXTERNAL MODULE: ./node_modules/kennitala/dist/kennitala.min.js
var kennitala_min = __webpack_require__(61473);
// EXTERNAL MODULE: ./src/themes/index.tsx
var themes = __webpack_require__(52287);
;// CONCATENATED MODULE: ./src/components/account/CompanyInfo.tsx









function CompanyInfo() {
    var userCompanies = useUser().userCompanies;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Title7, {
                withGutter: true,
                children: "Fyrirt\xe6ki"
            }),
            userCompanies === null || userCompanies === void 0 ? void 0 : userCompanies.map(function(company) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                var ssn = formatSSN(company.ssn);
                var phoneNumber = ((ref = company.addresses) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.phone) ? formatPhoneNumber((ref2 = company.addresses) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.phone) : "";
                var streetAddress = (ref4 = company.addresses) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.streetAddress1;
                var postalCode = (ref6 = company.addresses) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.postalCode;
                var city = (ref8 = company.addresses) === null || ref8 === void 0 ? void 0 : (ref9 = ref8[0]) === null || ref9 === void 0 ? void 0 : ref9.city;
                return /*#__PURE__*/ _jsx(InfoCard, {
                    icon: /*#__PURE__*/ _jsx(BuildingLineIcon, {
                        size: 30,
                        color: theme.palette.primary
                    }),
                    title: company.name,
                    description: /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            ssn ? /*#__PURE__*/ _jsx(P, {
                                children: formatSSN(ssn)
                            }) : null,
                            phoneNumber ? /*#__PURE__*/ _jsx(P, {
                                children: phoneNumber
                            }) : null,
                            streetAddress ? /*#__PURE__*/ _jsxs(P, {
                                children: [
                                    streetAddress,
                                    ","
                                ]
                            }) : null,
                            /*#__PURE__*/ _jsxs(P, {
                                children: [
                                    postalCode,
                                    " ",
                                    city
                                ]
                            })
                        ]
                    })
                }, company.id);
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/account/InfoCard.tsx
var account_InfoCard = __webpack_require__(65260);
// EXTERNAL MODULE: ./src/components/account/LoginPage.tsx + 1 modules
var LoginPage = __webpack_require__(91541);
// EXTERNAL MODULE: ./src/components/account/MyShoppingListPage.tsx
var MyShoppingListPage = __webpack_require__(37597);
// EXTERNAL MODULE: ./src/components/account/PaymentCardsInfo.tsx
var PaymentCardsInfo = __webpack_require__(72570);
// EXTERNAL MODULE: ./src/components/account/UserOverview.tsx + 1 modules
var UserOverview = __webpack_require__(84390);
// EXTERNAL MODULE: ./node_modules/remixicon-react/User3LineIcon.js
var User3LineIcon = __webpack_require__(19878);
var User3LineIcon_default = /*#__PURE__*/__webpack_require__.n(User3LineIcon);
// EXTERNAL MODULE: ./src/context/OverlayContext.tsx
var OverlayContext = __webpack_require__(33906);
;// CONCATENATED MODULE: ./src/components/account/ChooseCustomer.tsx









function ChooseCustomer() {
    var ref = (0,UserContext/* useUser */.aF)(), user = ref.user, userCompanies = ref.userCompanies, setCompanyId = ref.setCompanyId, removeCompanyId = ref.removeCompanyId, resetSelectAccount = ref.resetSelectAccount;
    var setSideDrawerIsOpen = (0,OverlayContext/* useOverlay */.Ir)().setSideDrawerIsOpen;
    var handleClick = function(selectedUser, selectedCompany) {
        requestAnimationFrame(function() {
            return setSideDrawerIsOpen(false);
        });
        if (selectedUser) {
            removeCompanyId();
        } else if (selectedCompany) {
            setCompanyId(selectedCompany);
        }
        resetSelectAccount();
    };
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                bold: true,
                children: "Halda \xe1fram a\xf0 versla sem:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChooseCustomerCard, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((User3LineIcon_default()), {
                    size: 30,
                    color: themes/* theme.palette.primary */.r.palette.primary
                }),
                title: (ref1 = user === null || user === void 0 ? void 0 : user.name) !== null && ref1 !== void 0 ? ref1 : "Notandi",
                onSelect: function() {
                    return handleClick(true, null);
                }
            }),
            userCompanies === null || userCompanies === void 0 ? void 0 : userCompanies.map(function(company) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChooseCustomerCard, {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((Building4LineIcon_default()), {
                        size: 30,
                        color: themes/* theme.palette.primary */.r.palette.primary
                    }),
                    title: company.name,
                    onSelect: function() {
                        return handleClick(false, "".concat(company.id));
                    }
                }, company.id);
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/styled-bootstrap-grid/dist/index.js
var dist = __webpack_require__(54572);
// EXTERNAL MODULE: ./node_modules/styled-tools/dist/es/index.js + 6 modules
var dist_es = __webpack_require__(41145);
;// CONCATENATED MODULE: ./src/components/account/ChooseCustomerCard.tsx
function ChooseCustomerCard_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ChooseCustomerCard_templateObject() {
    var data = ChooseCustomerCard_taggedTemplateLiteral([
        "\n    padding: 20px;\n  "
    ]);
    ChooseCustomerCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ChooseCustomerCard_templateObject1() {
    var data = ChooseCustomerCard_taggedTemplateLiteral([
        "\n  position: relative;\n  padding: 20px 20px 20px 20px;\n  display: flex;\n  align-items: center;\n  text-align: left;\n  margin: 16px 0;\n  width: 100%;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  cursor: pointer;\n\n  &.selected {\n    border: 1px solid ",
        ";\n    background: ",
        ";\n  }\n\n  &:hover {\n    border: 1px solid ",
        ";\n    background: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    ChooseCustomerCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ChooseCustomerCard_templateObject2() {
    var data = ChooseCustomerCard_taggedTemplateLiteral([
        "\n  padding-right: 20px;\n"
    ]);
    ChooseCustomerCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ChooseCustomerCard_templateObject3() {
    var data = ChooseCustomerCard_taggedTemplateLiteral([
        ""
    ]);
    ChooseCustomerCard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = ChooseCustomerCard_taggedTemplateLiteral([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var Card = styled_components_browser_esm["default"].div(ChooseCustomerCard_templateObject1(), (0,dist_es/* palette */.DG)("black"), (0,dist_es/* palette */.DG)("white"), (0,dist_es/* palette */.DG)("primary"), (0,dist_es/* palette */.DG)("red10"), (0,dist_es/* palette */.DG)("primary"), (0,dist_es/* palette */.DG)("red10"), dist.media.md(ChooseCustomerCard_templateObject()));
var IconContainer = styled_components_browser_esm["default"].div(ChooseCustomerCard_templateObject2());
var TextContainer = styled_components_browser_esm["default"].div(ChooseCustomerCard_templateObject3());
var Description = styled_components_browser_esm["default"].div(_templateObject4());
function ChooseCustomerCard(param) {
    var title = param.title, description = param.description, onSelect = param.onSelect, icon = param.icon, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
        onClick: onSelect,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title7 */.Mz, {
                        withGutter: true,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: description
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/remixicon-react/UserLineIcon.js
var UserLineIcon = __webpack_require__(12331);
var UserLineIcon_default = /*#__PURE__*/__webpack_require__.n(UserLineIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/LogoutBoxLineIcon.js
var LogoutBoxLineIcon = __webpack_require__(43120);
var LogoutBoxLineIcon_default = /*#__PURE__*/__webpack_require__.n(LogoutBoxLineIcon);
// EXTERNAL MODULE: ./src/styles/scrollStyle.ts
var scrollStyle = __webpack_require__(58728);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(70148);
// EXTERNAL MODULE: ./src/utils/paths.ts
var paths = __webpack_require__(27827);
// EXTERNAL MODULE: ./src/styles/shadowStyles.ts
var shadowStyles = __webpack_require__(23633);
// EXTERNAL MODULE: ./src/components/common/Link.tsx
var Link = __webpack_require__(5695);
// EXTERNAL MODULE: ./src/components/account/hooks/useCurrentPath.tsx
var useCurrentPath = __webpack_require__(77965);
// EXTERNAL MODULE: ./src/components/account/hooks/useHasLowResolution.ts
var useHasLowResolution = __webpack_require__(69580);
// EXTERNAL MODULE: ./src/components/account/hooks/useSize.ts
var useSize = __webpack_require__(66374);
;// CONCATENATED MODULE: ./src/components/account/hooks/index.ts




;// CONCATENATED MODULE: ./src/components/account/AccountNavDropdown.tsx
function AccountNavDropdown_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function AccountNavDropdown_templateObject() {
    var data = AccountNavDropdown_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 0;\n  min-width: 230px;\n  transition: opacity 0.15s;\n  z-index: 9999;\n  max-height: 60vh;\n  ",
        "\n"
    ]);
    AccountNavDropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AccountNavDropdown_templateObject1() {
    var data = AccountNavDropdown_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  font-size: 0.875rem;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid ",
        ";\n  padding-bottom: 20px;\n  ",
        "\n"
    ]);
    AccountNavDropdown_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AccountNavDropdown_templateObject2() {
    var data = AccountNavDropdown_taggedTemplateLiteral([
        "\n  margin-bottom: 8px;\n"
    ]);
    AccountNavDropdown_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AccountNavDropdown_templateObject3() {
    var data = AccountNavDropdown_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 10px 4px 10px 20px;\n\n  &.selected {\n    background-color: ",
        ";\n    font-weight: 700;\n\n    .remixicon-icon {\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    AccountNavDropdown_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AccountNavDropdown_templateObject4() {
    var data = AccountNavDropdown_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  font-size: 0.75rem;\n  padding-left: 10px;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    AccountNavDropdown_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = AccountNavDropdown_taggedTemplateLiteral([
        "\n  margin: 0;\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = AccountNavDropdown_taggedTemplateLiteral([
        "\n\n    &.hideDesktop {\n      display: none;\n    }\n\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = AccountNavDropdown_taggedTemplateLiteral([
        "\n  padding: 10px 20px;\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  &.hideDesktop {\n    display: block;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = AccountNavDropdown_taggedTemplateLiteral([
        "\n  padding: 10px 20px 0 20px;\n  background-color: transparent;\n  border: none;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  .remixicon-icon {\n    margin-right: 6px;\n  }\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



















var DropdownWrapper = styled_components_browser_esm["default"].div(AccountNavDropdown_templateObject(), (0,scrollStyle/* default */.Z)({
    color: "red"
}));
var Dropdown = styled_components_browser_esm["default"].div(AccountNavDropdown_templateObject1(), (0,dist_es/* palette */.DG)("white"), (0,dist_es/* palette */.DG)("red"), (0,shadowStyles/* default */.ZP)({
    color: "red",
    outlined: false,
    length: 8,
    showOnHover: false
}));
var CustomerDropdown = styled_components_browser_esm["default"].div(AccountNavDropdown_templateObject2());
var CustomerWrapper = styled_components_browser_esm["default"].div(AccountNavDropdown_templateObject3(), (0,dist_es/* palette */.DG)("red10"), (0,dist_es/* palette */.DG)("primary"));
var Customer = styled_components_browser_esm["default"].div(AccountNavDropdown_templateObject4(), (0,dist_es/* palette */.DG)("primary"));
var LineDivider = styled_components_browser_esm["default"].div(_templateObject5(), (0,dist_es/* palette */.DG)("red20"));
var UserMenuLink = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(_templateObject7(), (0,dist_es/* palette */.DG)("primary"), dist.media.md(_templateObject6()));
var SignOutWrapper = styled_components_browser_esm["default"].button(_templateObject8(), (0,dist_es/* palette */.DG)("primary"));
function AccountNavDropdown(param) {
    var setShowUserDropdown = param.setShowUserDropdown, _hideDesktop = param.hideDesktop, hideDesktop = _hideDesktop === void 0 ? true : _hideDesktop;
    var router = (0,next_router.useRouter)();
    var currentPath = (0,useCurrentPath/* useCurrentPath */.J)();
    var isDeliveryRoute = currentPath === paths/* paths.delivery */.H.delivery;
    var isPaymentRoute = currentPath === paths/* paths.payment */.H.payment;
    var routeCheck = (0,react.useCallback)(function() {
        if (isDeliveryRoute || isPaymentRoute) {
            router.push(paths/* paths.checkout */.H.checkout);
            react_toastify_esm/* toast.warning */.Am.warning("Vinsamlegast uppf\xe6ri\xf0 m\xf3ttakanda og grei\xf0anda.");
        }
    }, [
        isDeliveryRoute,
        isPaymentRoute,
        router
    ]);
    var ref = (0,UserContext/* useUser */.aF)(), user = ref.user, companyId = ref.companyId, setCompanyId = ref.setCompanyId, removeCompanyId = ref.removeCompanyId, userCompanies = ref.userCompanies, signOut = ref.signOut;
    var handleCompanyClick = (0,react.useCallback)(function(id) {
        setCompanyId("".concat(id));
        routeCheck();
        setShowUserDropdown(false);
    }, [
        routeCheck,
        setCompanyId,
        setShowUserDropdown
    ]);
    var handleUserClick = (0,react.useCallback)(function() {
        removeCompanyId();
        routeCheck();
        setShowUserDropdown(false);
    }, [
        removeCompanyId,
        routeCheck,
        setShowUserDropdown
    ]);
    var handleUserMenuLinkClick = (0,react.useCallback)(function() {
        setShowUserDropdown(false);
    }, [
        setShowUserDropdown
    ]);
    var handleSignOut = (0,react.useCallback)(function() {
        setShowUserDropdown(false);
        signOut();
    }, [
        signOut,
        setShowUserDropdown
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown, {
            children: [
                !!(userCompanies === null || userCompanies === void 0 ? void 0 : userCompanies.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomerDropdown, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomerWrapper, {
                            onClick: handleUserClick,
                            className: classnames_default()({
                                selected: !companyId
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((UserLineIcon_default()), {
                                    color: themes/* theme.palette.black90 */.r.palette.black90,
                                    size: 18
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Customer, {
                                    children: user === null || user === void 0 ? void 0 : user.name
                                })
                            ]
                        }),
                        userCompanies === null || userCompanies === void 0 ? void 0 : userCompanies.map(function(company) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LineDivider, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomerWrapper, {
                                        onClick: function() {
                                            return handleCompanyClick(company.id);
                                        },
                                        className: classnames_default()({
                                            selected: companyId === "".concat(company.id)
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((Building4LineIcon_default()), {
                                                color: themes/* theme.palette.black90 */.r.palette.black90,
                                                size: 16
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Customer, {
                                                children: company.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LineDivider, {})
                                ]
                            }, company.id);
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMenuLink, {
                    onClick: handleUserMenuLinkClick,
                    href: paths/* paths.myInfo */.H.myInfo,
                    children: "M\xednar uppl\xfdsingar"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMenuLink, {
                    onClick: handleUserMenuLinkClick,
                    href: paths/* paths.myOrders */.H.myOrders,
                    children: "Reikningar"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMenuLink, {
                    onClick: handleUserMenuLinkClick,
                    href: paths/* paths.salesHistory */.H.salesHistory,
                    children: "S\xf6lusaga"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMenuLink, {
                    onClick: handleUserMenuLinkClick,
                    href: paths/* paths.myTransactions */.H.myTransactions,
                    children: "Hreyfingayfirlit"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMenuLink, {
                    onClick: handleUserMenuLinkClick,
                    href: paths/* paths.companyRequest */.H.companyRequest,
                    children: "Tengjast fyrirt\xe6ki"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMenuLink, {
                    onClick: handleUserMenuLinkClick,
                    href: paths/* paths.shoppingList */.H.shoppingList,
                    className: classnames_default()({
                        hideDesktop: hideDesktop
                    }),
                    children: "\xd3skalistar"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SignOutWrapper, {
                    onClick: handleSignOut,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((LogoutBoxLineIcon_default()), {
                            size: 16,
                            color: themes/* theme.palette.primary */.r.palette.primary
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PSmall */.zK, {
                            children: "\xdatskr\xe1ning"
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/api/rest/index.ts + 6 modules
var rest = __webpack_require__(73565);
;// CONCATENATED MODULE: ./src/components/account/CompanyUserForm.tsx










var COMPLETED_STATUS = "CompletedWow";
var Form = function(param) {
    var handleSubmit = param.handleSubmit, status = param.status, isSubmitting = param.isSubmitting;
    var setShowRegistrationMsg = (0,UserContext/* useUser */.aF)().setShowRegistrationMsg;
    (0,react.useEffect)(function() {
        if (status === COMPLETED_STATUS) {
            setShowRegistrationMsg(true);
        }
    }, [
        setShowRegistrationMsg,
        status
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H5, {
                withGutter: true,
                children: "M\xe1 bj\xf3\xf0a \xfe\xe9r a\xf0 tengjast fyrirt\xe6ki?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                withGutter: true,
                children: "H\xe9r getur \xfe\xfa \xf3ska\xf0 eftir a\xf0gangi a\xf0 fyrirt\xe6ki."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginBottom: "32px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_form/* FormikInput */.jc, {
                    name: "companyName",
                    type: "text",
                    label: "Nafn fyrirt\xe6kis*"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginBottom: "32px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_form/* FormikInput */.jc, {
                    name: "companySsn",
                    type: "text",
                    label: "Kennitala fyrirt\xe6kis*"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    marginBottom: "32px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_form/* FormikInput */.jc, {
                    name: "message",
                    type: "textarea",
                    label: "Skilabo\xf0 - deild e\xf0a sta\xf0ur sem versla \xe1 fyrir e\xf0a a\xf0rar uppl\xfdsingar"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                type: "submit",
                withGutter: true,
                loading: isSubmitting,
                children: "Senda"
            })
        ]
    });
};
var CompanyUserForm = (0,formik_esm/* withFormik */.j0)({
    mapPropsToValues: function() {
        return {
            companyName: "",
            companySsn: "",
            message: ""
        };
    },
    validate: function(param) {
        var companyName = param.companyName, companySsn = param.companySsn;
        var errors = {};
        if (!companyName) {
            errors.companyName = "H\xe9r vantar nafn";
        }
        if (!companySsn) {
            errors.companySsn = "H\xe9r vantar kennit\xf6lu";
        } else if (!(0,strings/* isValidCompanySsn */.X7)(companySsn)) {
            errors.companySsn = "\xd3gild fyrirt\xe6kja kennitala";
        }
        return errors;
    },
    handleSubmit: function(values, param) {
        var resetForm = param.resetForm, setSubmitting = param.setSubmitting, setStatus = param.setStatus;
        return rest/* restApi.companyUserRequestsCreate */._O.companyUserRequestsCreate(values).then(function(res) {
            if (res.statusText === "Created") {
                // toast.success('Beiðni hefur verið stofnuð!')
                setStatus(COMPLETED_STATUS);
            }
            setSubmitting(false);
            resetForm();
        }).catch(function() {
            react_toastify_esm/* toast.error */.Am.error("\xd3\xfeekkt villa, reyni\xf0 aftur s\xed\xf0ar");
            setSubmitting(false);
            return false;
        });
    },
    displayName: "CompanyUserForm"
})(Form);
/* harmony default export */ var account_CompanyUserForm = (CompanyUserForm);

// EXTERNAL MODULE: ./node_modules/remixicon-react/CloseLineIcon.js
var CloseLineIcon = __webpack_require__(46550);
var CloseLineIcon_default = /*#__PURE__*/__webpack_require__.n(CloseLineIcon);
// EXTERNAL MODULE: ./src/components/registration/ShowEnd.tsx
var ShowEnd = __webpack_require__(8134);
;// CONCATENATED MODULE: ./src/components/account/CompanyRequestPage.tsx
function CompanyRequestPage_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyRequestPage_templateObject() {
    var data = CompanyRequestPage_taggedTemplateLiteral([
        "\n  padding: 0 24px 8px 24px;\n  margin-bottom: 24px;\n  border: 1px solid ",
        ";\n"
    ]);
    CompanyRequestPage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyRequestPage_templateObject1() {
    var data = CompanyRequestPage_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 25px;\n  top: 10px;\n  display: flex;\n  cursor: pointer;\n"
    ]);
    CompanyRequestPage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var MessageWrapper = styled_components_browser_esm["default"].div(CompanyRequestPage_templateObject(), (0,dist_es/* palette */.DG)("success"));
var CloseButton = styled_components_browser_esm["default"].div(CompanyRequestPage_templateObject1());
function CompanyRequestPage() {
    var ref = (0,UserContext/* useUser */.aF)(), showRegistrationMsg = ref.showRegistrationMsg, setShowRegistrationMsg = ref.setShowRegistrationMsg;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                    md: 5,
                    mdOffset: 1,
                    mdOrder: 2,
                    mdAlignSelf: "center",
                    children: showRegistrationMsg && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                                onClick: function() {
                                    return setShowRegistrationMsg(false);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((CloseLineIcon_default()), {
                                    color: themes/* theme.palette.success */.r.palette.success
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowEnd/* ShowEnd */.U, {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                    md: 5,
                    mdOffset: 1,
                    mdOrder: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(account_CompanyUserForm, {})
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/account/index.tsx



















/***/ }),

/***/ 1771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* unused harmony export FormikCheckbox */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(186);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41145);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59433);
/* harmony import */ var remixicon_react_CheckLineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19226);
/* harmony import */ var remixicon_react_CheckLineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_CheckLineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _styles_shadowStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23633);
/* harmony import */ var _themes_theme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69431);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: ",
        ";\n  font-size: 1rem;\n  color: ",
        ";\n  line-height: 1;\n  margin-left: 12px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  position: relative;\n  cursor: ",
        ";\n  justify-content: flex-end;\n  padding: 4px;\n\n  ",
        " {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  min-width: 18px;\n  height: 18px;\n  min-height: 18px;\n  transition: background-color 0.15s, border-color 0.15s;\n  background-color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  border-radius: 0;\n  opacity: 0;\n  pointer-events: none;\n\n  &:disabled {\n    ~ ",
        " {\n      border-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    border: 1px solid ",
        ";\n  }\n  ",
        " {\n    &:disabled {\n      ~ ",
        " {\n        &:hover {\n          transform: none;\n\n          &:before {\n            transform: translateZ(-1em);\n          }\n        }\n      }\n    }\n    &:checked {\n      ~ ",
        " {\n        background-color: ",
        ";\n      &:disabled {\n        ~ ",
        " {\n          background-color: ",
        ";\n\n          &:hover {\n            transform: none;\n\n            &:before {\n              transform: translateZ(-1em);\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: fit-content;\n  height: fit-content;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}








var Text = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div(_templateObject(), function(p) {
    return p.fontWeight;
}, (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("secondary"));
var Label = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].label(_templateObject1(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .ifProp */ .fq)({
    disabled: true
}, "not-allowed", "pointer"), Text, (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .ifProp */ .fq)("disabled", (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black40"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("secondary")));
var Box = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div(_templateObject2(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("white"));
var CheckboxInput = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].input(_templateObject3(), Box, (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black40"));
var CheckboxWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div(_templateObject4(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .ifProp */ .fq)("withGutter", "24px", "0"), Box, function(p) {
    return (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)(p.color);
}, CheckboxInput, Box, Box, function(p) {
    return (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)(p.color);
}, Box, (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black20"));
var InputContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div(_templateObject5(), function(p) {
    return !p.checked ? (0,_styles_shadowStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)({
        color: p.color,
        outlined: true,
        length: 4,
        showOnHover: true
    }) : (0,_styles_shadowStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)({
        color: p.color,
        outlined: false,
        length: 4,
        showOnHover: true
    });
});
function Checkbox(_param) {
    var handleChange = function handleChange(e) {
        setChecked(e.target.checked);
    };
    var label = _param.label, center = _param.center, withGutter = _param.withGutter, _color = _param.color, color = _color === void 0 ? "secondary" : _color, _fontWeight = _param.fontWeight, fontWeight = _fontWeight === void 0 ? "600" : _fontWeight, props = _objectWithoutProperties(_param, [
        "label",
        "center",
        "withGutter",
        "color",
        "fontWeight"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), checked = ref[0], setChecked = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CheckboxWrapper, {
        withGutter: !!withGutter,
        color: color,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Label, {
            center: center,
            disabled: props.disabled,
            children: [
                !!label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                    fontWeight: fontWeight,
                    children: label
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InputContainer, {
                    checked: !!checked,
                    color: color,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CheckboxInput, _objectSpread({
                            type: "checkbox"
                        }, props, {
                            onChange: handleChange
                        })),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Box, {
                            checked: !!checked,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_CheckLineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                                color: props.disabled && props.checked ? _themes_theme__WEBPACK_IMPORTED_MODULE_6__/* ["default"].palette.black40 */ .Z.palette.black40 : _themes_theme__WEBPACK_IMPORTED_MODULE_6__/* ["default"].palette.white */ .Z.palette.white
                            })
                        })
                    ]
                })
            ]
        })
    });
};
function FormikCheckbox(props) {
    var ref = _slicedToArray(useField(props), 2), field = ref[0], meta = ref[1];
    var errorMsg = !!meta.touched && meta.error;
    return /*#__PURE__*/ _jsx(Checkbox, _objectSpread({}, field, props, {
        checked: field.value,
        errorMsg: errorMsg || undefined
    }));
}


/***/ }),

/***/ 56791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CleaveInput; },
/* harmony export */   "m": function() { return /* binding */ FormikCleaveInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var cleave_js_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52034);
/* harmony import */ var cleave_js_react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(cleave_js_react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59433);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(186);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41145);
/* harmony import */ var src_themes_theme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69431);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92469);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  height: 50px;\n  width: 100%;\n  font-size: 1rem;\n  font-weight: 600;\n  padding: 16px;\n\n  &:hover&:not(:disabled) {\n    outline: 1px solid ",
        ";\n  }\n\n  &:active,\n  &:focus {\n    border-width: 1px;\n    border-color: ",
        ";\n    outline: none !important;\n  }\n\n  &:disabled {\n    background-color: ",
        ";\n    border-color: ",
        ";\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var StyledCleaveInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])((cleave_js_react__WEBPACK_IMPORTED_MODULE_2___default()))(_templateObject(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_4__/* .palette */ .DG)("secondary"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_4__/* .palette */ .DG)("white"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_4__/* .palette */ .DG)("secondary"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_4__/* .palette */ .DG)("red"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_4__/* .palette */ .DG)("black5"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_4__/* .palette */ .DG)("black40"));
var InputWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div(_templateObject1(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_4__/* .ifProp */ .fq)({
    withGutter: true
}, "32px", "0"));
function CleaveInput(_param) {
    var errorMsg = _param.errorMsg, showError = _param.showError, props = _objectWithoutProperties(_param, [
        "errorMsg",
        "showError"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InputWrapper, {
        withGutter: props.withGutter,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_6__/* .InputLabel */ .AZ, {
                htmlFor: props.id,
                disabled: props.disabled,
                children: props.label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_6__/* .InputSleeve */ .bx, {
                showError: !!showError,
                errorMsg: errorMsg,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledCleaveInput, _objectSpread({
                    style: {
                        borderBottom: showError ? "4px solid ".concat(src_themes_theme__WEBPACK_IMPORTED_MODULE_5__/* ["default"].palette.error */ .Z.palette.error) : undefined
                    }
                }, props))
            })
        ]
    });
};
function FormikCleaveInput(props) {
    var ref = _slicedToArray((0,formik__WEBPACK_IMPORTED_MODULE_3__/* .useField */ .U$)(props), 2), field = ref[0], meta = ref[1];
    var errorMsg = !!meta.touched && meta.error;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CleaveInput, _objectSpread({
        errorMsg: errorMsg || undefined,
        showError: !!errorMsg
    }, field, props));
}


/***/ }),

/***/ 92469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oG": function() { return /* binding */ inputCommon; },
/* harmony export */   "AZ": function() { return /* binding */ InputLabel; },
/* harmony export */   "SP": function() { return /* binding */ InputWrapper; },
/* harmony export */   "bx": function() { return /* binding */ InputSleeve; },
/* harmony export */   "II": function() { return /* binding */ Input; }
/* harmony export */ });
/* unused harmony export InputField */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59433);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(186);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41145);
/* harmony import */ var remixicon_react_InformationLineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36796);
/* harmony import */ var remixicon_react_InformationLineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_InformationLineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_InformationFillIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(725);
/* harmony import */ var remixicon_react_InformationFillIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_InformationFillIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54572);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _themes_theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69431);
/* harmony import */ var _typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56795);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  height: 50px;\n  width: 100%;\n  font-size: 1rem;\n  font-weight: 600;\n  padding: 16px;\n  fo &:hover&:not(:disabled) {\n    outline: 1px solid ",
        ";\n  }\n\n  &:active,\n  &:focus {\n    border-width: 1px;\n    border-color: ",
        ";\n    outline: none !important;\n  }\n\n  &:disabled {\n    background-color: ",
        ";\n    border-color: ",
        ";\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  min-height: 150px;\n  resize: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  margin-top: 10px;\n  margin-left: 14px;\n  font-size: 0.875rem;\n  color: ",
        ";\n  text-align: left;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.125;\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 0;\n  top: 0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  margin-top: 10px;\n  max-width: 700px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  max-width: 700px;\n  position: relative;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 14px;\n  right: 14px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    width: 350px;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: -8px;\n  right: -8px;\n  width: 250px;\n  visibility: hidden;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  padding: 8px;\n  transform-style: preserve-3d;\n  z-index: 100;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    transition: transform 0.5s;\n    transform-style: preserve-3d;\n    transform: translateY(8px) translateX(-8px) translateZ(-1em);\n    background-color: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: right;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}










var inputCommon = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__.css)(_templateObject(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_3__/* .palette */ .DG)("secondary"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_3__/* .palette */ .DG)("white"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_3__/* .palette */ .DG)("secondary"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_3__/* .palette */ .DG)("red"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_3__/* .palette */ .DG)("black5"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_3__/* .palette */ .DG)("black40"));
var InputField = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].input(_templateObject1(), inputCommon);
var TextAreaField = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].textarea(_templateObject2(), inputCommon);
var Error = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject3(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_3__/* .palette */ .DG)("error"));
var InputLabel = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].label(_templateObject4(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_3__/* .ifProp */ .fq)("disabled", (0,styled_tools__WEBPACK_IMPORTED_MODULE_3__/* .palette */ .DG)("black40"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_3__/* .palette */ .DG)("secondary")));
var CharCounter = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject5());
var InputContainer = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject6());
var InputWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject7(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_3__/* .ifProp */ .fq)("withGutter", "32px", "0"));
var InputInfoWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject8());
var InfoBox = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject10(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_3__/* .palette */ .DG)("white"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_3__/* .palette */ .DG)("secondary"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_3__/* .palette */ .DG)("secondary"), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_6__.media.sm(_templateObject9()));
var InfoBoxInner = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject11());
var InfoIconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject12());
function InputInfo(param) {
    var info = param.info;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InputInfoWrapper, {
        style: {
            left: open ? "14px" : "inherit"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InfoIconWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_InformationLineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                    onClick: function() {
                        return setOpen(true);
                    },
                    style: {
                        cursor: "pointer"
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InfoBox, {
                style: {
                    visibility: open ? "visible" : "hidden"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InfoBoxInner, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InfoIconWrapper, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_InformationFillIcon__WEBPACK_IMPORTED_MODULE_5___default()), {
                                onClick: function() {
                                    return setOpen(false);
                                },
                                style: {
                                    cursor: "pointer"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_8__/* .PSmall */ .zK, {
                            style: {
                                padding: "8px"
                            },
                            children: info
                        })
                    ]
                })
            })
        ]
    });
}
function InputSleeve(param) {
    var errorMsg = param.errorMsg, showError = param.showError, children = param.children, info = param.info, icon = param.icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InputContainer, {
        children: [
            children,
            !!info && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputInfo, {
                info: info
            }),
            !!icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputInfoWrapper, {
                children: icon
            }),
            showError && !!errorMsg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Error, {
                children: errorMsg
            })
        ]
    });
}
var Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var errorMsg = _param.errorMsg, showError = _param.showError, type = _param.type, characterLimit = _param.characterLimit, charCount = _param.charCount, showCharCount = _param.showCharCount, props = _objectWithoutProperties(_param, [
        "errorMsg",
        "showError",
        "type",
        "characterLimit",
        "charCount",
        "showCharCount"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InputWrapper, {
        withGutter: props.withGutter,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputLabel, {
                htmlFor: props.id,
                disabled: props.disabled,
                children: props.label
            }),
            showCharCount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CharCounter, {
                children: [
                    charCount,
                    "/50"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputSleeve, {
                errorMsg: errorMsg,
                showError: !!showError,
                info: props.info,
                icon: props.icon,
                children: type === "textarea" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TextAreaField, _objectSpread({}, props, {
                    ref: ref
                })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InputField, _objectSpread({}, props, {
                    ref: ref,
                    style: {
                        borderBottom: showError ? "4px solid ".concat(_themes_theme__WEBPACK_IMPORTED_MODULE_7__/* ["default"].palette.error */ .Z.palette.error) : undefined
                    },
                    maxLength: characterLimit,
                    type: type
                }))
            })
        ]
    });
});

var FormikInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(props, ref) {
    var _$ref = _slicedToArray((0,formik__WEBPACK_IMPORTED_MODULE_1__/* .useField */ .U$)(props), 2), field = _$ref[0], meta = _$ref[1];
    var showError = !!(meta.error && meta.touched);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Input, _objectSpread({}, field, props, {
        showError: showError,
        errorMsg: meta.error,
        ref: ref,
        withGutter: true
    }));
});
/* harmony default export */ __webpack_exports__["ZP"] = (FormikInput);


/***/ }),

/***/ 39701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QtyPicker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(186);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41145);
/* harmony import */ var remixicon_react_AddLineIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69675);
/* harmony import */ var remixicon_react_AddLineIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_AddLineIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_SubtractLineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80207);
/* harmony import */ var remixicon_react_SubtractLineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_SubtractLineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _themes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52287);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  display: flex;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  cursor: pointer;\n  transition: background-color 0.15s;\n  padding: 0;\n  border-radius: 0;\n\n  .remixicon-icon {\n    transition: opacity 0.15s;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n\n    .remixicon-icon {\n      opacity: 0.2;\n    }\n  }\n\n  &:hover:not(:disabled) {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  font-size: 1rem;\n  width: 40px;\n  color: ",
        ";\n  border: 1px solid ",
        ";\n  outline: none;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var Box = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div(_templateObject(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("white"));
var Btn = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].button(_templateObject1(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black5"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("light"));
var BtnRight = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__["default"])(Btn)(_templateObject2());
var QtyNum = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].input(_templateObject3(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("blue"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black"));
function QtyPicker(param) {
    var qty = param.qty, onUpdate = param.onUpdate, _isMin = param.isMin, isMin = _isMin === void 0 ? qty === 1 : _isMin, isMax = param.isMax, isDisabled = param.isDisabled;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(qty.toString()), value = ref[0], setValue = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setValue(qty.toString());
    }, [
        qty
    ]);
    var handleDecrease = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        onUpdate(qty - 1);
    }, [
        qty,
        onUpdate
    ]);
    var handleIncrease = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        onUpdate(qty + 1);
    }, [
        qty,
        onUpdate
    ]);
    var handleBlur = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var newValue = parseInt(value, 10);
        if (Number.isNaN(newValue)) {
            setValue(qty.toString());
            return;
        }
        onUpdate(newValue);
    }, [
        onUpdate,
        qty,
        value
    ]);
    var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(ev) {
        var newValue = ev.target.value;
        setValue(newValue);
    }, []);
    var handleKeypress = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(ev) {
        if (ev.key === "Enter") {
            var newValue = parseInt(value, 10);
            if (ref1.current) {
                ref1.current.blur();
            }
            if (Number.isNaN(newValue)) {
                setValue(qty.toString());
                return;
            }
            onUpdate(newValue);
        }
    }, [
        onUpdate,
        qty,
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Box, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Btn, {
                type: "button",
                onClick: handleDecrease,
                disabled: isMin || isDisabled,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_SubtractLineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                    size: 16,
                    color: _themes__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.black */ .r.palette.black
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QtyNum, {
                value: value,
                ref: ref1,
                type: "text",
                pattern: "[0-9]*",
                onKeyPress: handleKeypress,
                onChange: handleChange,
                onBlur: handleBlur,
                disabled: isDisabled
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BtnRight, {
                type: "button",
                onClick: handleIncrease,
                disabled: isMax || isDisabled,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_AddLineIcon__WEBPACK_IMPORTED_MODULE_3___default()), {
                    size: 16,
                    color: _themes__WEBPACK_IMPORTED_MODULE_5__/* .theme.palette.black */ .r.palette.black
                })
            })
        ]
    });
};


/***/ }),

/***/ 15749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RadioButton; },
/* harmony export */   "u": function() { return /* binding */ FormikRadioButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(186);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41145);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59433);
/* harmony import */ var _styles_shadowStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23633);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  justify-content: flex-end;\n  position: relative;\n  cursor: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 600;\n  font-size: 1rem;\n  color: ",
        ";\n  line-height: 1.2;\n  margin-left: 12px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 20px;\n  min-width: 20px;\n  height: 20px;\n  min-height: 20px;\n  border: 1px solid ",
        ";\n  border-radius: 10px;\n  box-sizing: border-box;\n  background-color: ",
        ";\n  transition: transform 0.5s;\n\n  &:after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    height: 14px;\n    width: 14px;\n    border-radius: 7px;\n    background-color: ",
        ";\n    transform: scale(0);\n    transform-origin: 50% 50%;\n    transition: transform 0.15s ease-out;\n  }\n\n  &:before {\n    border-radius: 10px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  visibility: hidden;\n  position: absolute;\n  border-radius: 0;\n\n  &:checked ~ ",
        " {\n    &:after {\n      transform: scale(1);\n    }\n  }\n\n  &:disabled {\n    ~ ",
        " {\n      color: ",
        ";\n    }\n    ~ ",
        " {\n      border-color: ",
        ";\n      background-color: ",
        ";\n\n      &:hover {\n        transform: none;\n\n        &::before {\n          transform: translateZ(-1em);\n        }\n      }\n    }\n    &:checked {\n      ~ ",
        " {\n        background-color: ",
        ";\n\n        &:after {\n          background-color: ",
        ";\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: fit-content;\n  height: fit-content;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var Label = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].label(_templateObject(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .ifProp */ .fq)({
    disabled: true
}, "not-allowed", "pointer"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .ifProp */ .fq)("withGutter", "24px", "0"));
var Text = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject1(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("blue"));
var Circle = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject2(), function(p) {
    return (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)(p.color);
}, (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("white"), function(p) {
    return (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)(p.color);
});
var RadioInput = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].input(_templateObject3(), Circle, Text, (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black40"), Circle, (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black40"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black5"), Circle, (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black20"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black40"));
var InputContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject4(), function(p) {
    return (0,_styles_shadowStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)({
        color: p.color,
        outlined: false,
        length: 4,
        showOnHover: true,
        borderRadius: 10
    });
});
function RadioButton(_param) {
    var label = _param.label, disabled = _param.disabled, _withGutter = _param.withGutter, withGutter = _withGutter === void 0 ? false : _withGutter, _color = _param.color, color = _color === void 0 ? "primary" : _color, props = _objectWithoutProperties(_param, [
        "label",
        "disabled",
        "withGutter",
        "color"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Label, {
        withGutter: withGutter,
        disabled: !!disabled,
        children: [
            !!label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(InputContainer, {
                color: color,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RadioInput, _objectSpread({
                        type: "radio",
                        disabled: disabled
                    }, props)),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Circle, {
                        color: color
                    })
                ]
            })
        ]
    });
};
function FormikRadioButton(props) {
    var ref = _slicedToArray((0,formik__WEBPACK_IMPORTED_MODULE_3__/* .useField */ .U$)(props), 1), field = ref[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RadioButton, _objectSpread({}, field, props));
}


/***/ }),

/***/ 92970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hF": function() { return /* binding */ FormikSelect; }
/* harmony export */ });
/* unused harmony exports Select, MultiSelect */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var downshift__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(52753);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(186);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41145);
/* harmony import */ var remixicon_react_CheckLineIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19226);
/* harmony import */ var remixicon_react_CheckLineIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_CheckLineIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_ArrowUpSLineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92981);
/* harmony import */ var remixicon_react_ArrowUpSLineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_ArrowUpSLineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_ArrowDownSLineIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10076);
/* harmony import */ var remixicon_react_ArrowDownSLineIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_ArrowDownSLineIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59433);
/* harmony import */ var _typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56795);
/* harmony import */ var _themes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52287);
/* harmony import */ var _styles_scrollStyle__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58728);
/* harmony import */ var _styles_shadowStyles__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23633);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(92469);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  transition: box-shadow 0.15s;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  height: 18px;\n  margin-left: auto;\n  padding-left: 5px;\n  padding-right: 5px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  background-color: ",
        ";\n  z-index: 0;\n  font-weight: 500;\n  font-size: 1rem;\n  color: ",
        ";\n  text-align: left;\n  border: 0;\n  padding-left: 16px;\n\n  &.withBorder {\n    border: 1px solid ",
        ";\n    transition: border-color 0.15s;\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  right: ",
        ";\n  left: ",
        ";\n  margin-top: 12px;\n  min-width: ",
        ";\n  pointer-events: ",
        ";\n  padding-left: 4px;\n  padding-bottom: 4px;\n  transition: opacity 0.15s;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  z-index: 2;\n  list-style: none;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  ",
        ";\n  &:before {\n    z-index: -1;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: 350px;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  height: 50px;\n  width: 100%;\n  font-size: 1rem;\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  padding: 0 16px;\n  text-align: center;\n  cursor: pointer;\n  transition: border-color 0.15s, background-color 0.15s;\n\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  min-width: 18px;\n  height: 18px;\n  min-height: 18px;\n  transition: background-color 0.15s, border-color 0.15s;\n  margin-right: 8px;\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

/* eslint-disable react/no-unused-prop-types */ 













var SelectContainer = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].div(_templateObject());
var IconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].div(_templateObject1());
var SelectBtn = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].button(_templateObject2(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("white"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black"), _Input__WEBPACK_IMPORTED_MODULE_12__/* .inputCommon */ .oG);
var MenuWrapper = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].div(_templateObject3(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .ifProp */ .fq)({
    align: "right"
}, "0", "inherit"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .ifProp */ .fq)({
    align: "left"
}, "-5px", "inherit"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .ifProp */ .fq)({
    fit: true
}, "calc(100% + 6px)", "300px"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .ifProp */ .fq)({
    hidden: true
}, "none", "auto"));
var Menu = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].ul(_templateObject4(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("white"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black"), (0,_styles_shadowStyles__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)({
    color: "black",
    outlined: false,
    length: 4,
    showOnHover: false
}));
var MenuInner = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].div(_templateObject5(), (0,_styles_scrollStyle__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
    color: "black"
}));
var ListItem = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].li(_templateObject6(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black5"));
var Checkbox = styled_components__WEBPACK_IMPORTED_MODULE_13__["default"].div(_templateObject7(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_2__/* .palette */ .DG)("black"));
function Select(param) {
    var items = param.items, placeholder = param.placeholder, _align = param.align, align = _align === void 0 ? "left" : _align, initialSelectedItem = param.selectedItem, fit = param.fit, itemToString = param.itemToString, handleSelectedItemChange = param.handleSelectedItemChange, setTouched = param.setTouched, noBorder = param.noBorder;
    var ref = (0,downshift__WEBPACK_IMPORTED_MODULE_14__/* .useSelect */ .L7)({
        items: items,
        selectedItem: initialSelectedItem,
        itemToString: itemToString,
        onSelectedItemChange: handleSelectedItemChange
    }), isOpen = ref.isOpen, getToggleButtonProps = ref.getToggleButtonProps, getMenuProps = ref.getMenuProps, highlightedIndex = ref.highlightedIndex, getItemProps = ref.getItemProps, selectedItem = ref.selectedItem;
    var onBlur = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (!setTouched) {
            return;
        }
        setTouched(true);
    }, [
        setTouched
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SelectContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SelectBtn, _objectSpread({
                type: "button"
            }, getToggleButtonProps(), {
                className: classnames__WEBPACK_IMPORTED_MODULE_6___default()({
                    withBorder: !noBorder
                }),
                children: [
                    isOpen && !selectedItem && !placeholder && "Veldu m\xf6guleika",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_8__/* .PLarge */ .cG, {
                        children: placeholder
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, {
                        children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowUpSLineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                            size: 18
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowDownSLineIcon__WEBPACK_IMPORTED_MODULE_5___default()), {
                            size: 18
                        })
                    })
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MenuWrapper, {
                align: align,
                fit: fit,
                hidden: !isOpen,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Menu, _objectSpread({}, getMenuProps({
                    onBlur: onBlur
                }), {
                    style: {
                        opacity: isOpen ? 1 : 0,
                        pointerEvents: isOpen ? "unset" : "none"
                    },
                    children: items.map(function(item, index) {
                        var highlighted = highlightedIndex === index;
                        var selected = selectedItem === item;
                        var props = getItemProps({
                            item: item,
                            index: index
                        });
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListItem, _objectSpread({}, props, {
                            style: {
                                fontWeight: selected ? 700 : 400,
                                backgroundColor: highlighted ? _themes__WEBPACK_IMPORTED_MODULE_9__/* .theme.palette.black10 */ .r.palette.black10 : "transparent"
                            },
                            children: itemToString(item)
                        }), index);
                    })
                }))
            })
        ]
    });
}
function MultiSelect(param1) {
    var items = param1.items, placeholder = param1.placeholder, _align = param1.align, align = _align === void 0 ? "left" : _align, initialSelectedItems = param1.selectedItems, fit = param1.fit, itemToString = param1.itemToString, handleSelectedItemsChange = param1.handleSelectedItemsChange, noBorder = param1.noBorder;
    var ref = useMultipleSelection({
        selectedItems: initialSelectedItems,
        onSelectedItemsChange: handleSelectedItemsChange
    }), getDropdownProps = ref.getDropdownProps, addSelectedItem = ref.addSelectedItem, removeSelectedItem = ref.removeSelectedItem, selectedItems = ref.selectedItems;
    var ref1 = useSelect({
        selectedItem: null,
        defaultHighlightedIndex: 0,
        items: items,
        stateReducer: function(state, actionAndChanges) {
            var changes = actionAndChanges.changes, type = actionAndChanges.type;
            switch(type){
                case useSelect.stateChangeTypes.MenuKeyDownEnter:
                case useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
                case useSelect.stateChangeTypes.ItemClick:
                    return _objectSpread({}, changes, {
                        isOpen: true
                    });
                default:
            }
            return changes;
        },
        onStateChange: function(param) {
            var type = param.type, newSelectedItem = param.selectedItem;
            switch(type){
                case useSelect.stateChangeTypes.MenuKeyDownEnter:
                case useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
                case useSelect.stateChangeTypes.ItemClick:
                    if (!newSelectedItem) {
                        break;
                    }
                    if (!selectedItems.includes(newSelectedItem)) {
                        addSelectedItem(newSelectedItem);
                    } else {
                        removeSelectedItem(newSelectedItem);
                    }
                    break;
                default:
                    break;
            }
        }
    }), isOpen = ref1.isOpen, getToggleButtonProps = ref1.getToggleButtonProps, getMenuProps = ref1.getMenuProps, highlightedIndex = ref1.highlightedIndex, getItemProps = ref1.getItemProps;
    return /*#__PURE__*/ _jsxs(SelectContainer, {
        children: [
            /*#__PURE__*/ _jsxs(SelectBtn, _objectSpread({
                type: "button"
            }, getToggleButtonProps(getDropdownProps({
                preventKeyAction: isOpen
            })), {
                className: cn({
                    withBorder: !noBorder
                }),
                children: [
                    /*#__PURE__*/ _jsx(PLarge, {
                        children: placeholder
                    }),
                    /*#__PURE__*/ _jsx(IconWrapper, {
                        children: isOpen ? /*#__PURE__*/ _jsx(ArrowUpSLineIcon, {
                            size: 18
                        }) : /*#__PURE__*/ _jsx(ArrowDownSLineIcon, {
                            size: 18
                        })
                    })
                ]
            })),
            /*#__PURE__*/ _jsx(MenuWrapper, {
                align: align,
                fit: fit,
                children: /*#__PURE__*/ _jsx(Menu, _objectSpread({}, getMenuProps(), {
                    style: {
                        opacity: isOpen ? 1 : 0,
                        pointerEvents: isOpen ? "unset" : "none"
                    },
                    children: /*#__PURE__*/ _jsx(MenuInner, {
                        children: isOpen && items.map(function(item, index) {
                            var highlighted = highlightedIndex === index;
                            var selected = selectedItems.includes(item);
                            var props = getItemProps({
                                item: item,
                                index: index
                            });
                            return /*#__PURE__*/ _jsxs(ListItem, _objectSpread({}, props, {
                                style: {
                                    backgroundColor: highlighted ? theme.palette.black10 : "transparent"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Checkbox, {
                                        style: {
                                            backgroundColor: selected ? theme.palette.secondary : theme.palette.white
                                        },
                                        children: /*#__PURE__*/ _jsx(CheckLineIcon, {
                                            color: theme.palette.white
                                        })
                                    }),
                                    " ",
                                    itemToString(item)
                                ]
                            }), index);
                        })
                    })
                }))
            })
        ]
    });
}
function FormikSelect(props) {
    var ref = _slicedToArray((0,formik__WEBPACK_IMPORTED_MODULE_7__/* .useField */ .U$)(props), 3), _field = ref[0], meta = ref[1], helpers = ref[2];
    var setValue = helpers.setValue, setTouched = helpers.setTouched;
    var value = meta === null || meta === void 0 ? void 0 : meta.value;
    var errorMsg = !!meta.touched && meta.error;
    var onSelect = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(changes) {
        setValue(changes === null || changes === void 0 ? void 0 : changes.selectedItem);
    }, [
        setValue
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Input__WEBPACK_IMPORTED_MODULE_12__/* .InputWrapper */ .SP, {
        withGutter: props.withGutter,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_12__/* .InputLabel */ .AZ, {
                htmlFor: props.id,
                disabled: props.disabled,
                children: props.label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_12__/* .InputSleeve */ .bx, {
                errorMsg: errorMsg || undefined,
                showError: !!errorMsg,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Select, {
                    setTouched: setTouched,
                    itemToString: props.itemToString,
                    items: props.items,
                    selectedItem: value,
                    placeholder: props.itemToString(value) || props.placeholder,
                    handleSelectedItemChange: onSelect
                })
            })
        ]
    });
}


/***/ }),

/***/ 27618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "XZ": function() { return /* reexport */ Checkbox/* default */.Z; },
  "n7": function() { return /* reexport */ CleaveInput/* default */.Z; },
  "mR": function() { return /* reexport */ CleaveInput/* FormikCleaveInput */.m; },
  "jc": function() { return /* reexport */ Input/* default */.ZP; },
  "bF": function() { return /* reexport */ QtyPicker/* default */.Z; },
  "EU": function() { return /* reexport */ RadioButton/* default */.Z; },
  "gu": function() { return /* reexport */ RadioField; },
  "ZD": function() { return /* reexport */ Toggle; }
});

// UNUSED EXPORTS: Input, MultiSelect, SearchInput, Select

// EXTERNAL MODULE: ./src/components/form/Checkbox.tsx
var Checkbox = __webpack_require__(1771);
// EXTERNAL MODULE: ./src/components/form/Input.tsx
var Input = __webpack_require__(92469);
// EXTERNAL MODULE: ./src/components/form/CleaveInput.tsx
var CleaveInput = __webpack_require__(56791);
// EXTERNAL MODULE: ./src/components/form/QtyPicker.tsx
var QtyPicker = __webpack_require__(39701);
// EXTERNAL MODULE: ./src/components/form/RadioButton.tsx
var RadioButton = __webpack_require__(15749);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/styled-tools/dist/es/index.js + 6 modules
var es = __webpack_require__(41145);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 120 modules
var formik_esm = __webpack_require__(59433);
// EXTERNAL MODULE: ./src/themes/index.tsx
var themes = __webpack_require__(52287);
// EXTERNAL MODULE: ./src/styles/shadowStyles.ts
var shadowStyles = __webpack_require__(23633);
// EXTERNAL MODULE: ./src/components/typography/index.tsx + 1 modules
var typography = __webpack_require__(56795);
// EXTERNAL MODULE: ./src/components/products/index.tsx + 38 modules
var products = __webpack_require__(18254);
;// CONCATENATED MODULE: ./src/components/form/RadioField.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  justify-content: flex-end;\n  position: relative;\n  cursor: ",
        ";\n  margin-bottom: ",
        ";\n  padding: 10px;\n  padding-bottom: 14px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  width: 20px;\n  min-width: 20px;\n  height: 20px;\n  min-height: 20px;\n  border: 1px solid ",
        ";\n  border-radius: 10px;\n  box-sizing: border-box;\n  background-color: ",
        ";\n  transition: transform 0.5s;\n\n  &:after {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 2px;\n    left: 2px;\n    height: 14px;\n    width: 14px;\n    border-radius: 7px;\n    background-color: ",
        ";\n    transform: scale(0);\n    transform-origin: 50% 50%;\n    transition: transform 0.15s ease-out;\n  }\n\n  &:before {\n    border-radius: 10px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n  z-index: 1;\n  ",
        " {\n    width: inherit;\n    margin-right: 8px;\n    margin-left: 16px;\n  }\n  ",
        " {\n    line-height: 1.4;\n  }\n  ",
        " {\n    width: inherit;\n  }\n  @media (max-width: ",
        ") {\n    ",
        " {\n      font-size: 14px;\n      line-height: 1.4;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: fit-content;\n  height: fit-content;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  visibility: hidden;\n  position: absolute;\n  border-radius: 0;\n\n  ~ ",
        " {\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n  }\n\n  &:checked {\n    color: ",
        ";\n\n    ~ ",
        " {\n      > ",
        " {\n        &:after {\n          transform: scale(1);\n        }\n      }\n    }\n    ~ ",
        " {\n      background-color: ",
        ";\n      border-bottom: 4px solid ",
        ";\n    }\n    ~ ",
        " {\n      color: ",
        ";\n    }\n  }\n\n  &:disabled {\n    ~ ",
        " {\n      color: ",
        ";\n    }\n    ~ ",
        " {\n      > ",
        " {\n        border-color: ",
        ";\n        background-color: ",
        ";\n      }\n    }\n    ~ ",
        " {\n      background-color: ",
        ";\n      border: 1px solid ",
        ";\n    }\n    &:checked {\n      ~ ",
        " {\n        > ",
        " {\n          background-color: ",
        ";\n        }\n        &:after {\n          background-color: ",
        ";\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-end;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-left: 16px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: -20px;\n  right: 16px;\n  z-index: 1;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: line-through;\n  margin-left: auto;\n  margin-right: 12px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}









var Label = styled_components_browser_esm["default"].label(_templateObject(), (0,es/* ifProp */.fq)({
    disabled: true
}, "not-allowed", "pointer"), (0,es/* ifProp */.fq)("withGutter", "24px", "0"));
var Circle = styled_components_browser_esm["default"].div(_templateObject1(), function(p) {
    return (0,es/* palette */.DG)(p.color);
}, (0,es/* palette */.DG)("white"), function(p) {
    return (0,es/* palette */.DG)(p.color);
});
var Background = styled_components_browser_esm["default"].div(_templateObject2());
var Content = styled_components_browser_esm["default"].div(_templateObject3(), typography.H6, typography/* PSmall */.zK, typography/* Title6 */.L8, themes/* theme.screenSize.sizeSM */.r.screenSize.sizeSM, typography/* Title6 */.L8);
var ShadowContainer = styled_components_browser_esm["default"].div(_templateObject4(), function(p) {
    return (0,shadowStyles/* default */.ZP)({
        color: p.color,
        outlined: false,
        length: 4,
        showOnHover: true,
        borderRadius: 10
    });
});
var RadioInput = styled_components_browser_esm["default"].input(_templateObject5(), Background, (0,es/* palette */.DG)("white"), (0,es/* palette */.DG)("black"), (0,es/* palette */.DG)("white"), ShadowContainer, Circle, Background, (0,es/* palette */.DG)("secondary"), (0,es/* palette */.DG)("red"), Content, (0,es/* palette */.DG)("white"), Content, (0,es/* palette */.DG)("black40"), ShadowContainer, Circle, (0,es/* palette */.DG)("secondary"), (0,es/* palette */.DG)("background"), Background, (0,es/* palette */.DG)("background"), (0,es/* palette */.DG)("secondary"), ShadowContainer, Circle, (0,es/* palette */.DG)("background"), (0,es/* palette */.DG)("background"));
var LabelHead = styled_components_browser_esm["default"].div(_templateObject6());
var PriceSection = styled_components_browser_esm["default"].div(_templateObject7());
var Tag = styled_components_browser_esm["default"].div(_templateObject8());
var FormerPrice = (0,styled_components_browser_esm["default"])(typography/* Title6 */.L8)(_templateObject9(), (0,es/* palette */.DG)("red"));
function RadioField(_param) {
    var label = _param.label, disabled = _param.disabled, _withGutter = _param.withGutter, withGutter = _withGutter === void 0 ? false : _withGutter, _color = _param.color, color = _color === void 0 ? "primary" : _color, unitPrice = _param.unitPrice, originalPrice = _param.originalPrice, price = _param.price, numberOfUnits = _param.numberOfUnits, discount = _param.discount, props = _objectWithoutProperties(_param, [
        "label",
        "disabled",
        "withGutter",
        "color",
        "unitPrice",
        "originalPrice",
        "price",
        "numberOfUnits",
        "discount"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
        withGutter: withGutter,
        disabled: !!disabled,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                children: discount && /*#__PURE__*/ (0,jsx_runtime.jsx)(products/* ProductTag */.Sd, {
                    badgeVariant: products/* ProductBadgeVariant.Discount */.m.Discount,
                    title: discount
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioInput, _objectSpread({
                type: "radio",
                disabled: disabled
            }, props)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Background, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelHead, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H6, {
                                children: label
                            }),
                            numberOfUnits && /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PSmall */.zK, {
                                children: "(".concat(numberOfUnits, " stk.)")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceSection, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PSmall */.zK, {
                                children: unitPrice
                            }),
                            originalPrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FormerPrice, {
                                children: originalPrice
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title6 */.L8, {
                                children: price
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowContainer, {
                color: color,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Circle, {
                    color: color
                })
            })
        ]
    });
};
function FormikRadioButton(props) {
    var ref = _slicedToArray(useField(props), 1), field = ref[0];
    return /*#__PURE__*/ _jsx(RadioField, _objectSpread({}, field, props));
}

// EXTERNAL MODULE: ./node_modules/remixicon-react/SearchLineIcon.js
var remixicon_react_SearchLineIcon = __webpack_require__(26554);
;// CONCATENATED MODULE: ./src/components/form/SearchInput.tsx
function SearchInput_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SearchInput_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchInput_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SearchInput_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchInput_templateObject() {
    var data = SearchInput_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 50px;\n  color: ",
        ";\n\n  svg {\n    margin: 0 10px;\n  }\n"
    ]);
    SearchInput_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchInput_templateObject1() {
    var data = SearchInput_taggedTemplateLiteral([
        "\n  border: none;\n  height: 100%;\n  flex: 1;\n  background: transparent;\n\n  &:active,\n  &:focus {\n    outline: none !important;\n  }\n"
    ]);
    SearchInput_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var InputWrapper = styled_components_browser_esm["default"].div(SearchInput_templateObject(), (0,es/* palette */.DG)("black90"));
var SearchInput_Input = styled_components_browser_esm["default"].input(SearchInput_templateObject1());
function SearchInput(props) {
    return /*#__PURE__*/ _jsxs(InputWrapper, {
        border: true,
        children: [
            /*#__PURE__*/ _jsx(SearchLineIcon, {
                size: 20,
                color: theme.palette.red
            }),
            /*#__PURE__*/ _jsx(SearchInput_Input, SearchInput_objectSpread({}, props))
        ]
    });
};

// EXTERNAL MODULE: ./src/components/form/Select.tsx
var Select = __webpack_require__(92970);
;// CONCATENATED MODULE: ./src/components/form/Toggle.tsx
function Toggle_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Toggle_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Toggle_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Toggle_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Toggle_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Toggle_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Toggle_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Toggle_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Toggle_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Toggle_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Toggle_slicedToArray(arr, i) {
    return Toggle_arrayWithHoles(arr) || Toggle_iterableToArrayLimit(arr, i) || Toggle_unsupportedIterableToArray(arr, i) || Toggle_nonIterableRest();
}
function Toggle_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Toggle_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Toggle_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Toggle_arrayLikeToArray(o, minLen);
}
function Toggle_templateObject() {
    var data = Toggle_taggedTemplateLiteral([
        "\n  font-weight: 600;\n  font-size: 1rem;\n  color: ",
        ";\n  line-height: 1;\n"
    ]);
    Toggle_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Toggle_templateObject1() {
    var data = Toggle_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 40px;\n  height: 20px;\n  border-radius: 10px;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  transition: background-color 0.15s;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 2px;\n    left: ",
        ";\n    height: 14px;\n    width: 14px;\n    border-radius: 8px;\n    background-color: ",
        ";\n    transition: left 0.15s ease-out;\n  }\n"
    ]);
    Toggle_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Toggle_templateObject2() {
    var data = Toggle_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  justify-content: flex-end;\n  position: relative;\n  cursor: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    Toggle_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Toggle_templateObject3() {
    var data = Toggle_taggedTemplateLiteral([
        "\n  visibility: hidden;\n  position: absolute;\n  border-radius: 0;\n\n  &:disabled {\n    ~ ",
        " {\n      border-color: ",
        ";\n\n      &:after {\n        background-color: ",
        ";\n      }\n\n      &:hover {\n        transform: none;\n\n        &:before {\n          transform: translateZ(-1em);\n        }\n      }\n    }\n\n    &:checked {\n      ~ ",
        " {\n        background-color: ",
        ";\n\n        &:after {\n          background-color: ",
        ";\n        }\n      }\n    }\n  }\n"
    ]);
    Toggle_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Toggle_templateObject4() {
    var data = Toggle_taggedTemplateLiteral([
        "\n  width: fit-content;\n  height: fit-content;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  margin-right: 12px;\n  ",
        "\n"
    ]);
    Toggle_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var Text = styled_components_browser_esm["default"].div(Toggle_templateObject(), (0,es/* palette */.DG)("secondary"));
var Switch = styled_components_browser_esm["default"].div(Toggle_templateObject1(), (0,es/* ifProp */.fq)({
    checked: true
}, function(p) {
    return (0,es/* palette */.DG)(p.color);
}, (0,es/* palette */.DG)("white")), function(p) {
    return (0,es/* palette */.DG)(p.color);
}, (0,es/* ifProp */.fq)({
    checked: true
}, "22px", "2px"), (0,es/* ifProp */.fq)({
    checked: true
}, (0,es/* palette */.DG)("white"), function(p) {
    return (0,es/* palette */.DG)(p.color);
}));
var Toggle_Label = styled_components_browser_esm["default"].label(Toggle_templateObject2(), (0,es/* ifProp */.fq)({
    disabled: true
}, "not-allowed", "pointer"), (0,es/* ifProp */.fq)("withGutter", "24px", "0"));
var CheckboxInput = styled_components_browser_esm["default"].input(Toggle_templateObject3(), Switch, (0,es/* palette */.DG)("black40"), (0,es/* palette */.DG)("black40"), Switch, (0,es/* palette */.DG)("black40"), (0,es/* palette */.DG)("black20"));
var InputContainer = styled_components_browser_esm["default"].div(Toggle_templateObject4(), function(p) {
    return (0,shadowStyles/* default */.ZP)({
        color: p.color,
        outlined: p.checked,
        length: 4,
        showOnHover: true,
        borderRadius: 10
    });
});
function Toggle(_param) {
    var label = _param.label, _checked = _param.checked, checked = _checked === void 0 ? false : _checked, onToggle = _param.onToggle, disabled = _param.disabled, _color = _param.color, color = _color === void 0 ? "secondary" : _color, _withGutter = _param.withGutter, withGutter = _withGutter === void 0 ? false : _withGutter, props = Toggle_objectWithoutProperties(_param, [
        "label",
        "checked",
        "onToggle",
        "disabled",
        "color",
        "withGutter"
    ]);
    var handleChange = (0,react.useCallback)(function() {
        if (!onToggle) {
            return;
        }
        onToggle(!checked);
    }, [
        checked,
        onToggle
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toggle_Label, {
        disabled: disabled,
        withGutter: withGutter,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputContainer, {
                color: color,
                checked: checked,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxInput, Toggle_objectSpread({
                        name: label,
                        type: "checkbox",
                        disabled: disabled,
                        onChange: handleChange,
                        checked: checked
                    }, props)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch, {
                        checked: checked,
                        color: color
                    })
                ]
            })
        ]
    });
};
function FormikToggle(props) {
    var ref = Toggle_slicedToArray(useField(props), 1), field = ref[0];
    return /*#__PURE__*/ _jsx(Toggle, Toggle_objectSpread({}, field, props));
}

;// CONCATENATED MODULE: ./src/components/form/index.tsx












/***/ }),

/***/ 9262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54572);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(186);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41145);
/* harmony import */ var remixicon_react_PhoneFillIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60911);
/* harmony import */ var remixicon_react_PhoneFillIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_PhoneFillIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var remixicon_react_MapPinFillIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95114);
/* harmony import */ var remixicon_react_MapPinFillIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_MapPinFillIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var remixicon_react_MailFillIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81315);
/* harmony import */ var remixicon_react_MailFillIcon__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_MailFillIcon__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var remixicon_react_TimeFillIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11327);
/* harmony import */ var remixicon_react_TimeFillIcon__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_TimeFillIcon__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var src_context_PageContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11764);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52287);
/* harmony import */ var src_utils_strings__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8597);
/* harmony import */ var _typography__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(56795);
/* harmony import */ var _styles_shadowStyles__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(23633);
/* harmony import */ var _SpacingWrapper__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(22098);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: ",
        ";\n    margin: auto;\n    margin-top: 16px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 32px 0;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  line-height: 1.5;\n  margin: 16px 12px 0 21px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-bottom: 4px solid ",
        ";\n  padding: 20px 30px;\n  @media (max-width: ",
        ") {\n    padding: 10px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 60px 20px 24px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  padding: 40px 30px;\n  > div:first-child {\n    justify-content: space-between;\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    justify-content: center;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        " {\n      white-space: nowrap;\n    }\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-start;\n\n  ",
        "\n\n  ",
        " {\n    line-height: 1.5;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 16px;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 15px 0;\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 10px;\n  transition: color 0.15s;\n  cursor: pointer;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  ",
        " {\n    margin-bottom: 4px;\n  }\n  svg {\n    margin-right: 8px;\n    margin-bottom: 2px;\n    height: 20px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: 170px;\n    margin:auto;\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 32px;\n\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    flex-direction: row;\n    justify-content: center;\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: flex-start;\n  align-items: baseline;\n  text-align: center;\n  gap: 10px;\n  width: 100%;\n\n  a {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  column-gap: 10px;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: 5px;\n  color: ",
        ";\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  align-items: baseline;\n  width: 100%;\n  @media (max-width: ",
        ") {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n    margin-bottom: 40px;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n    max-height: 180px;\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: 120px;\n\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}

/* TODO: Fix those links */ /* eslint-disable @next/next/no-html-link-for-pages */ 














var FooterContainer = styled_components__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject1(), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.media.xl(_templateObject(), src_themes__WEBPACK_IMPORTED_MODULE_10__/* .theme.headerAndFooterSize.xLargeDesktop */ .r.headerAndFooterSize.xLargeDesktop));
var FooterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject2(), (0,_styles_shadowStyles__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP)({
    color: "red",
    outlined: false,
    length: 8,
    showOnHover: false
}));
var MainInfo = styled_components__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject3(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_4__/* .palette */ .DG)("white"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_4__/* .palette */ .DG)("red"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_4__/* .palette */ .DG)("red"), src_themes__WEBPACK_IMPORTED_MODULE_10__/* .theme.screenSize.sizeMD */ .r.screenSize.sizeMD);
var Details = styled_components__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject5(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_4__/* .palette */ .DG)("white"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_4__/* .palette */ .DG)("red"), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.media.md(_templateObject4()));
var FooterSection = styled_components__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject8(), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.media.sm(_templateObject6()), _typography__WEBPACK_IMPORTED_MODULE_12__/* .Title5 */ .IV, styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.media.sm(_templateObject7(), _typography__WEBPACK_IMPORTED_MODULE_12__/* .Title5 */ .IV));
var FooterSectionInner = styled_components__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject10(), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.media.md(_templateObject9()));
var PageLink = styled_components__WEBPACK_IMPORTED_MODULE_15__["default"].a(_templateObject11(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_4__/* .palette */ .DG)("red"));
var FooterTitle = styled_components__WEBPACK_IMPORTED_MODULE_15__["default"].a(_templateObject12(), _typography__WEBPACK_IMPORTED_MODULE_12__.H6, (0,styled_tools__WEBPACK_IMPORTED_MODULE_4__/* .palette */ .DG)("red"));
var DetailsSection = styled_components__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject14(), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.media.sm(_templateObject13()));
var FooterBottom = styled_components__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject16(), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.media.sm(_templateObject15()));
var TermLinks = (0,styled_components__WEBPACK_IMPORTED_MODULE_15__["default"])(_typography__WEBPACK_IMPORTED_MODULE_12__/* .PSmall */ .zK)(_templateObject17());
var Copyright = styled_components__WEBPACK_IMPORTED_MODULE_15__["default"].span(_templateObject18(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_4__/* .palette */ .DG)("black20"));
var LogoWrapper = styled_components__WEBPACK_IMPORTED_MODULE_15__["default"].div(_templateObject19(), src_themes__WEBPACK_IMPORTED_MODULE_10__/* .theme.screenSize.sizeSM */ .r.screenSize.sizeSM);
var AwardLogo = styled_components__WEBPACK_IMPORTED_MODULE_15__["default"].img(_templateObject21(), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.media.lg(_templateObject20()));
function Footer() {
    var ref = (0,src_context_PageContext__WEBPACK_IMPORTED_MODULE_9__/* .usePageContext */ .lO)(), footerData = ref.footerData, getPagesByCategory = ref.getPagesByCategory;
    var email = footerData.email, phoneNumber = footerData.phoneNumber, location = footerData.location, openingHours = footerData.openingHours, pageCategories = footerData.pageCategories, awards = footerData.awards;
    var featureFlag = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            showMenu: true,
            privacyPolicy: true,
            showDisclaimers: false
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterContainer, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MainInfo, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Container, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Row, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Col, {
                                    xs: 12,
                                    sm: 4,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterSection, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterSectionInner, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterTitle, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_PhoneFillIcon__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                            size: 18
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_12__.H6, {
                                                            children: "\xdej\xf3nustuver"
                                                        })
                                                    ]
                                                }),
                                                phoneNumber ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "tel:+354".concat(phoneNumber),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_12__/* .Title5 */ .IV, {
                                                        children: (0,src_utils_strings__WEBPACK_IMPORTED_MODULE_11__/* .formatPhoneNumber */ .un)(phoneNumber)
                                                    })
                                                }) : null
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Col, {
                                    xs: 12,
                                    sm: 4,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterSection, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterSectionInner, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterTitle, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_MapPinFillIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                            size: 18
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_12__.H6, {
                                                            children: "Sta\xf0setning"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "http://maps.google.com/?q=Rekstrarvorur ".concat(location),
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_12__/* .Title5 */ .IV, {
                                                        children: location
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Col, {
                                    xs: 12,
                                    sm: 4,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterSection, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterSectionInner, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterTitle, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_MailFillIcon__WEBPACK_IMPORTED_MODULE_7___default()), {
                                                            size: 18
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_12__.H6, {
                                                            children: "Netfang"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_12__/* .Title5 */ .IV, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "mailto:".concat(email),
                                                        children: email
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                }),
                featureFlag.showMenu ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Details, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Row, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Col, {
                                    xs: 12,
                                    sm: 6,
                                    md: 3,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DetailsSection, {
                                        children: openingHours === null || openingHours === void 0 ? void 0 : openingHours.map(function(openingHour) {
                                            return(// eslint-disable-next-line react/no-array-index-key
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SpacingWrapper__WEBPACK_IMPORTED_MODULE_14__/* .SpacingBottom */ .rR, {
                                                spacing: 30,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterTitle, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_TimeFillIcon__WEBPACK_IMPORTED_MODULE_8___default()), {
                                                                size: 14
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_12__.H6, {
                                                                children: openingHour.name
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_12__/* .Title5 */ .IV, {
                                                        children: openingHour.openingHours
                                                    })
                                                ]
                                            }, openingHour.id));
                                        })
                                    })
                                }),
                                pageCategories === null || pageCategories === void 0 ? void 0 : pageCategories.map(function(category) {
                                    var pages = getPagesByCategory(category.id);
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Col, {
                                        xs: 12,
                                        sm: 6,
                                        md: 3,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DetailsSection, {
                                            children: pages === null || pages === void 0 ? void 0 : pages.map(function(page) {
                                                return page.path ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                                    href: page.path,
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageLink, {
                                                        children: page.heading
                                                    })
                                                }, page.id) : null;
                                            })
                                        })
                                    }, category.id);
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Col, {
                                    xs: 12,
                                    sm: 6,
                                    md: 3,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoWrapper, {
                                        children: awards === null || awards === void 0 ? void 0 : awards.map(function(award) {
                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AwardLogo, {
                                                src: award.url,
                                                alt: (award === null || award === void 0 ? void 0 : award.alt) || "Award 2022"
                                            }, award.id);
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Row, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_3__.Col, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FooterBottom, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_12__/* .PSmall */ .zK, {
                                            color: "black40",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Copyright, {
                                                children: "\xa92022 Rekstrarv\xf6rur"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(TermLinks, {
                                            color: "black40",
                                            children: [
                                                featureFlag.privacyPolicy ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "/stefnur",
                                                    children: "Pers\xf3nuverndarstefna"
                                                }) : null,
                                                featureFlag.privacyPolicy && featureFlag.showDisclaimers ? "|" : null,
                                                featureFlag.showDisclaimers ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "/",
                                                    children: "Skilm\xe1lar"
                                                }) : null
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }) : null
            ]
        })
    });
};


/***/ }),

/***/ 78823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PageContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/styled-tools/dist/es/index.js + 6 modules
var es = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/context/OverlayContext.tsx
var OverlayContext = __webpack_require__(33906);
// EXTERNAL MODULE: ./src/context/UserContext.tsx + 1 modules
var UserContext = __webpack_require__(76336);
// EXTERNAL MODULE: ./src/themes/index.tsx
var themes = __webpack_require__(52287);
// EXTERNAL MODULE: ./node_modules/styled-bootstrap-grid/dist/index.js
var dist = __webpack_require__(54572);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js + 151 modules
var motion = __webpack_require__(87751);
// EXTERNAL MODULE: ./node_modules/remixicon-react/CloseLineIcon.js
var CloseLineIcon = __webpack_require__(46550);
var CloseLineIcon_default = /*#__PURE__*/__webpack_require__.n(CloseLineIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/LogoutBoxLineIcon.js
var LogoutBoxLineIcon = __webpack_require__(43120);
var LogoutBoxLineIcon_default = /*#__PURE__*/__webpack_require__.n(LogoutBoxLineIcon);
;// CONCATENATED MODULE: ./src/hooks/useTrap.ts

var useTrap = function(param) {
    var enabled = param.enabled, ref = param.ref;
    (0,react.useEffect)(function() {
        if (!enabled) {
            return function() {
            // Empty on purpose
            };
        }
        var el = ref.current;
        if (!el) {
            return function() {
            // Empty on purpose
            };
        }
        var getIsInstanceOfEl = function(node) {
            if (node === document.body) {
                return false;
            }
            if (node === el) {
                return true;
            }
            return getIsInstanceOfEl(node.parentElement);
        };
        var fn = function(event) {
            var isFocusable = getIsInstanceOfEl(event.target);
            if (!isFocusable) {
                var firstFocused = el.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                if (!firstFocused) {
                    event.target.blur();
                    throw new Error("No element to focus on. This should never happen");
                }
                firstFocused.focus();
            }
        };
        document.body.addEventListener("focus", fn, true);
        return function() {
            document.body.removeEventListener("focus", fn, true);
        };
    }, [
        enabled,
        ref
    ]);
};

// EXTERNAL MODULE: ./src/utils/isSSR.ts
var isSSR = __webpack_require__(28095);
;// CONCATENATED MODULE: ./src/utils/getScrollbarWidth.ts

var getScrollbarWidth = function() {
    var ref;
    if (isSSR/* isSSR */.y) {
        return 12;
    }
    var outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);
    var inner = document.createElement("div");
    outer.appendChild(inner);
    var scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    (ref = outer.parentNode) === null || ref === void 0 ? void 0 : ref.removeChild(outer);
    return scrollbarWidth;
};
var SCROLLBAR_WIDTH = getScrollbarWidth();

// EXTERNAL MODULE: ./src/hooks/useScrollTop.ts
var useScrollTop = __webpack_require__(38248);
;// CONCATENATED MODULE: ./src/hooks/useIsScrollbarActive.ts




var isShowingScrollbar = function() {
    return isSSR/* isSSR */.y ? false : document.documentElement.scrollHeight > window.innerHeight;
};
var useIsScrollbarActive = function() {
    var ref = (0,react.useState)(isShowingScrollbar()), isShowing = ref[0], setIsShowing = ref[1];
    var ref1 = (0,react.useState)(getScrollbarWidth()), width = ref1[0], setWidth = ref1[1];
    var top = (0,useScrollTop/* useScrollTop */.j)();
    var updateFn = (0,react.useCallback)(function() {
        if (isShowingScrollbar() !== isShowing) {
            setIsShowing(!isShowing);
            setWidth(getScrollbarWidth());
        }
    }, [
        isShowing
    ]);
    (0,react.useEffect)(function() {
        var resizeObserver = new ResizeObserver(updateFn);
        if (typeof resizeObserver !== "undefined" && resizeObserver) {
            resizeObserver.observe(document.body);
        }
        return function() {
            if (typeof resizeObserver !== "undefined" && resizeObserver) {
                resizeObserver.disconnect();
            }
        };
    }, [
        updateFn
    ]);
    return {
        active: isShowing,
        width: width,
        top: top
    };
};

// EXTERNAL MODULE: ./src/components/buttons/index.tsx + 6 modules
var buttons = __webpack_require__(31494);
// EXTERNAL MODULE: ./src/components/typography/index.tsx + 1 modules
var typography = __webpack_require__(56795);
;// CONCATENATED MODULE: ./src/components/common/SideDrawer.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  box-sizing: border-box;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 700;\n  pointer-events: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  top: 0;\n  left: 0;\n  overflow: hidden;\n  background-color: ",
        ";\n  transition: background-color 300ms;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  -webkit-overflow-scrolling: 'touch';\n  background-color: rgba(250, f 250, 252, 0.9);\n  outline: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  min-height: 100%;\n  backdrop-filter: blur(2px);\n  box-shadow: -8px 2px 150px 1px rgba(0, 0, 0, 0.75);\n  -webkit-box-shadow: -8px 2px 150px 1px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: -8px 2px 150px 1px rgba(0, 0, 0, 0.75);\n  z-index: 1;\n  max-width: 100%;\n  padding-top: ",
        "px;\n  pointer-events: ",
        ";\n  background-color: rgba(250, 250, 252, 0.9);\n  overflow-y: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 500px;\n  max-width: 100vw;\n  overflow: hidden;\n  position: fixed;\n  top: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    padding: 100px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 100px 22px;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin: 14px;\n  background-color: transparent;\n  border: none;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  .remixicon-icon {\n    margin-right: 6px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

/* eslint-disable unused-imports/no-unused-vars */ 











var DrawerWrapper = styled_components_browser_esm["default"].div(_templateObject());
var DrawerOverlay = (0,styled_components_browser_esm["default"])(motion/* motion.aside */.E.aside)(_templateObject1(), function(param) {
    var isClosed = param.isClosed;
    return isClosed ? "transparent" : "rgba(0, 0, 0, 0.1)";
});
var DrawerContent = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div)(_templateObject2(), function(param) {
    var top = param.top;
    return top;
}, function(param) {
    var isClosed = param.isClosed;
    return isClosed ? "none" : "all";
});
var DrawerInnerContent = styled_components_browser_esm["default"].div(_templateObject3());
var ContentContainer = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div)(_templateObject5(), dist.media.md(_templateObject4()));
var SignOutWrapper = styled_components_browser_esm["default"].button(_templateObject6());
var contentVariants = {
    initial: {
        x: 0,
        opacity: 0
    },
    active: {
        opacity: 1,
        transition: {
            duration: 0.4,
            delay: 0.25,
            ease: [
                0.42,
                0,
                0.58,
                1
            ]
        }
    }
};
function SideDrawer(param1) {
    var isOpen = param1.isOpen, setIsOpen = param1.setIsOpen, children = param1.children, inEmailStep = param1.inEmailStep, handleSignOut = param1.handleSignOut;
    var ref = (0,UserContext/* useUser */.aF)(), stopResetUser = ref.stopResetUser, resetSelectAccount = ref.resetSelectAccount;
    var ref1 = useIsScrollbarActive(), scrollIsActive = ref1.active, scrollWidth = ref1.width, scrollTop = ref1.top;
    var handleEnd = (0,react.useCallback)(function() {
        var nextEl = document.querySelector("#__next");
        nextEl.style.transform = "";
        nextEl.style.width = "";
    }, []);
    var handleStart = (0,react.useCallback)(function() {
        var nextEl = document.querySelector("#__next");
        var width = scrollIsActive ? scrollWidth : 0;
        nextEl.style.marginLeft = "calc(100vw - 100%)";
        nextEl.style.transform = "translateX(-".concat(width, "px)");
        nextEl.style.width = "calc(100vw + ".concat(width, "px)");
    }, [
        scrollIsActive,
        scrollWidth
    ]);
    // useLockBodyScroll({enable: !!isOpen, handleEnd, handleStart})
    var onKeyDown = (0,react.useCallback)(function(param) {
        var key = param.key;
        if (!isOpen || !setIsOpen) {
            return;
        }
        if (key === "Escape") {
            setIsOpen(false);
        }
    }, [
        setIsOpen,
        isOpen
    ]);
    var handleClose = (0,react.useCallback)(function() {
        if (!setIsOpen) {
            return;
        }
        setIsOpen(false);
        stopResetUser();
        resetSelectAccount();
    }, [
        resetSelectAccount,
        setIsOpen,
        stopResetUser
    ]);
    (0,react.useEffect)(function() {
        if (true) {
            window.addEventListener("keydown", onKeyDown);
            return function() {
                return window.removeEventListener("keydown", onKeyDown);
            };
        }
        return function() {
        // Empty on purpose
        };
    }, [
        onKeyDown
    ]);
    var shouldClose = (0,react.useCallback)(function(param) {
        var target = param.target;
        if ((target === null || target === void 0 ? void 0 : target.id) === "drawer-overlay" && !!setIsOpen) {
            setIsOpen(false);
        }
    }, [
        setIsOpen
    ]);
    var ref2 = (0,react.useRef)(null);
    useTrap({
        enabled: !!isOpen,
        ref: ref2
    });
    var animate = (0,react.useMemo)(function() {
        var transition = {
            type: "spring",
            damping: 40,
            stiffness: 400,
            delayChildren: 0.5,
            when: "beforeChildren"
        };
        if (isOpen) {
            return {
                width: "500px",
                transition: transition
            };
        }
        return {
            width: 0,
            transition: transition
        };
    }, [
        isOpen
    ]);
    (0,react.useEffect)(function() {
        var nextEl = document.querySelector("#__next");
        if (isOpen) {
            var width = scrollIsActive ? scrollWidth : 0;
            // nextEl.style.transform = `translateX(-${width / 2}px)`
            nextEl.style.width = "calc(100vw + ".concat(width, "px)");
        } else {
            requestAnimationFrame(function() {
                nextEl.style.transform = "";
                nextEl.style.width = "";
            });
        }
    }, [
        isOpen,
        scrollIsActive,
        scrollWidth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerOverlay, {
                    onClick: shouldClose,
                    initial: false,
                    isClosed: !isOpen
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerContent, {
                    animate: animate,
                    role: "dialog",
                    "aria-modal": true,
                    isClosed: !isOpen,
                    hidden: !isOpen,
                    top: scrollTop,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DrawerInnerContent, {
                        ref: ref2,
                        children: [
                            isOpen && inEmailStep ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SignOutWrapper, {
                                onClick: handleSignOut,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((LogoutBoxLineIcon_default()), {
                                        size: 24,
                                        color: themes/* theme.palette.primary */.r.palette.primary
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PSmall */.zK, {
                                        children: "\xdatskr\xe1ning"
                                    })
                                ]
                            }) : null,
                            isOpen && !inEmailStep ? /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* CornerButton */.gm, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((CloseLineIcon_default()), {
                                    size: 16
                                }),
                                onClick: handleClose
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer, {
                                variants: contentVariants,
                                initial: "initial",
                                animate: "active",
                                exit: "active",
                                children: children
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/account/LoginPage.tsx + 1 modules
var LoginPage = __webpack_require__(91541);
// EXTERNAL MODULE: ./src/components/layout/Footer.tsx
var Footer = __webpack_require__(9262);
// EXTERNAL MODULE: ./src/components/layout/index.ts + 8 modules
var layout = __webpack_require__(49012);
// EXTERNAL MODULE: ./src/components/search/index.tsx + 2 modules
var search = __webpack_require__(47347);
;// CONCATENATED MODULE: ./src/components/layout/PageContainer.tsx
function PageContainer_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PageContainer_templateObject() {
    var data = PageContainer_taggedTemplateLiteral([
        "\n  position: relative;\n  background-color: ",
        ";\n  z-index: 0;\n"
    ]);
    PageContainer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PageContainer_templateObject1() {
    var data = PageContainer_taggedTemplateLiteral([
        "\n  min-height: 80vh;\n  overflow: hidden;\n  padding-top: 175px;\n  @media (max-width: ",
        ") {\n    padding-top: 100px;\n  }\n"
    ]);
    PageContainer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PageContainer_templateObject2() {
    var data = PageContainer_taggedTemplateLiteral([
        "\n  position: fixed;\n  z-index: 999;\n  background-color: rgba(0, 0, 0, 0.5);\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: none;\n"
    ]);
    PageContainer_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PageContainer_templateObject3() {
    var data = PageContainer_taggedTemplateLiteral([
        "\n  display: block;\n  border-width: 2px;\n  border: 1px solid ",
        ";\n  margin: 0 15px 12px 15px;\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    PageContainer_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}













var Page = styled_components_browser_esm["default"].div(PageContainer_templateObject(), (0,es/* palette */.DG)("background"));
var PageContentSection = styled_components_browser_esm["default"].main(PageContainer_templateObject1(), themes/* theme.screenSize.sizeLG */.r.screenSize.sizeLG);
var Backdrop = styled_components_browser_esm["default"].div(PageContainer_templateObject2());
var SearchBarContainer = styled_components_browser_esm["default"].div(PageContainer_templateObject3(), (0,es/* palette */.DG)("red"), themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD);
function PageContainer(param) {
    var title = param.title, children = param.children;
    var ref = (0,OverlayContext/* useOverlay */.Ir)(), setSideDrawerIsOpen = ref.setSideDrawerIsOpen, sideDrawerIsOpen = ref.sideDrawerIsOpen;
    var ref1 = (0,UserContext/* useUser */.aF)(), user = ref1.user, userLoading = ref1.userLoading, missingEmail = ref1.missingEmail, showChooseCustomer = ref1.showChooseCustomer, userCompanies = ref1.userCompanies, userCompaniesLoading = ref1.userCompaniesLoading, handleSignOut = ref1.signOut, showRegistrationMsg = ref1.showRegistrationMsg;
    var inEmailStep = user && missingEmail;
    var isOpenIf = sideDrawerIsOpen && (!user || userLoading || showChooseCustomer || user && userCompaniesLoading || user && !missingEmail && !(userCompanies === null || userCompanies === void 0 ? void 0 : userCompanies.length) && !userCompaniesLoading && !showRegistrationMsg || showRegistrationMsg) || user && missingEmail;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: title || "Rekstrarv\xf6rur"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideDrawer, {
                    setIsOpen: setSideDrawerIsOpen,
                    isOpen: !!isOpenIf,
                    inEmailStep: !!inEmailStep,
                    handleSignOut: handleSignOut,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginPage/* default */.Z, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Backdrop, {
                id: "popup-backdrop"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* Header */.h4, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageContentSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBarContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search/* SearchBar */.E, {
                            border: true,
                            showDropdown: true
                        })
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};


/***/ }),

/***/ 22098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l2": function() { return /* binding */ FluidSpacing; },
/* harmony export */   "$3": function() { return /* binding */ SpacingWrapper; },
/* harmony export */   "rR": function() { return /* binding */ SpacingBottom; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(186);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41145);
/* harmony import */ var _utils_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3795);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        "px 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  padding-bottom: ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var FluidSpacing = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div(_templateObject(), function(props) {
    return (0,_utils_styles__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)(props.from, props.to);
});
var SpacingWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div(_templateObject1(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_0__/* .prop */ .vg)("spacing"));
var SpacingBottom = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div(_templateObject2(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_0__/* .prop */ .vg)("spacing"));


/***/ }),

/***/ 49012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bi": function() { return /* reexport */ BlockTitle; },
  "qm": function() { return /* reexport */ BlockWrapper; },
  "h4": function() { return /* reexport */ Header; },
  "_z": function() { return /* reexport */ PageContainer/* default */.Z; },
  "$3": function() { return /* reexport */ SpacingWrapper/* SpacingWrapper */.$3; }
});

// UNUSED EXPORTS: FluidSpacing, Footer, SpacingBottom

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useClickAway.js
var esm_useClickAway = __webpack_require__(69293);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/styled-bootstrap-grid/dist/index.js
var dist = __webpack_require__(54572);
// EXTERNAL MODULE: ./node_modules/styled-tools/dist/es/index.js + 6 modules
var es = __webpack_require__(41145);
// EXTERNAL MODULE: ./node_modules/remixicon-react/Menu4LineIcon.js
var Menu4LineIcon = __webpack_require__(81227);
var Menu4LineIcon_default = /*#__PURE__*/__webpack_require__.n(Menu4LineIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/PhoneFillIcon.js
var PhoneFillIcon = __webpack_require__(60911);
var PhoneFillIcon_default = /*#__PURE__*/__webpack_require__.n(PhoneFillIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/MailFillIcon.js
var MailFillIcon = __webpack_require__(81315);
var MailFillIcon_default = /*#__PURE__*/__webpack_require__.n(MailFillIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/CloseLineIcon.js
var CloseLineIcon = __webpack_require__(46550);
var CloseLineIcon_default = /*#__PURE__*/__webpack_require__.n(CloseLineIcon);
// EXTERNAL MODULE: ./src/context/PageContext.tsx
var PageContext = __webpack_require__(11764);
// EXTERNAL MODULE: ./src/themes/index.tsx
var themes = __webpack_require__(52287);
// EXTERNAL MODULE: ./src/utils/isNotNull.ts
var isNotNull = __webpack_require__(84403);
// EXTERNAL MODULE: ./src/hooks/useScrollTop.ts
var useScrollTop = __webpack_require__(38248);
// EXTERNAL MODULE: ./src/components/common/Link.tsx
var Link = __webpack_require__(5695);
// EXTERNAL MODULE: ./src/components/typography/Headings.tsx
var Headings = __webpack_require__(94540);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/remixicon-react/ArrowLeftLineIcon.js
var ArrowLeftLineIcon = __webpack_require__(4756);
var ArrowLeftLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowLeftLineIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/ArrowRightLineIcon.js
var ArrowRightLineIcon = __webpack_require__(94187);
var ArrowRightLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowRightLineIcon);
// EXTERNAL MODULE: ./src/api/saleor/generated/index.tsx
var generated = __webpack_require__(49554);
// EXTERNAL MODULE: ./src/utils/paths.ts
var paths = __webpack_require__(27827);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useWindowSize.js + 3 modules
var useWindowSize = __webpack_require__(72977);
// EXTERNAL MODULE: ./src/components/common/index.tsx + 15 modules
var common = __webpack_require__(69446);
// EXTERNAL MODULE: ./src/themes/theme.ts
var theme = __webpack_require__(69431);
// EXTERNAL MODULE: ./src/components/typography/index.tsx + 1 modules
var typography = __webpack_require__(56795);
// EXTERNAL MODULE: ./src/styles/scrollStyle.ts
var scrollStyle = __webpack_require__(58728);
;// CONCATENATED MODULE: ./src/components/layout/nav/SubCategories.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  max-width: 300px;\n  line-height: 20px;\n  &:hover {\n    cursor: pointer;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 5px 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var SubCategory = styled_components_browser_esm["default"].div(_templateObject(), (0,es/* palette */.DG)("red"));
var SubCategoryText = styled_components_browser_esm["default"].div(_templateObject1());
function SubCategories(param) {
    var category = param.category;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: category === null || category === void 0 ? void 0 : (ref = category.children) === null || ref === void 0 ? void 0 : ref.edges.map(function(subCategory) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Link */.rU, {
                href: (0,paths/* generatePath */.G)(paths/* paths.categories */.H.categories, subCategory.node.slug),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategory, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategoryText, {
                        children: subCategory.node.name
                    })
                })
            }, subCategory.node.id);
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./src/components/layout/nav/PageCategoryLinks.tsx





function PageCategoryLinks(param) {
    var category = param.category;
    var ref = (0,PageContext/* usePageContext */.lO)(), getPagesByCategory = ref.getPagesByCategory, getLinksBySlug = ref.getLinksBySlug;
    var pages = getPagesByCategory(category === null || category === void 0 ? void 0 : category.id) || [];
    var links = (category === null || category === void 0 ? void 0 : category.slug) ? getLinksBySlug(category === null || category === void 0 ? void 0 : category.slug) : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (pages.length ? pages : links).map(function(link) {
            return link.path ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: link.path,
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_NavBarLink, {
                    children: link.heading
                })
            }, link.heading) : null;
        })
    });
};

;// CONCATENATED MODULE: ./src/components/layout/nav/NavDropdown.tsx
function NavDropdown_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function NavDropdown_templateObject() {
    var data = NavDropdown_taggedTemplateLiteral([
        ""
    ]);
    NavDropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NavDropdown_templateObject1() {
    var data = NavDropdown_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  display: flex;\n  position: relative;\n  flex-direction: row;\n  border: 1px solid ",
        ";\n  max-height: calc(100vh - 135px);\n  overflow: hidden;\n\n  ",
        " {\n    text-transform: lowercase;\n    &::first-letter {\n      text-transform: capitalize;\n    }\n  }\n  @media (min-width: ",
        ") {\n    max-height: calc(100vh - 180px);\n  }\n"
    ]);
    NavDropdown_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = NavDropdown_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  padding-left: 15px;\n  border-right: 1px solid ",
        ";\n  flex-shrink: 0;\n  transition: transform 0.25s ease-in;\n  overflow: auto;\n  width: 100%;\n\n  @media (min-width: 768px) {\n    width: 350px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = NavDropdown_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  flex-shrink: 0;\n  transition: transform 0.25s ease-in;\n  padding: 0 20px;\n\n  a {\n    justify-content: flex-start;\n    font-weight: 600;\n  }\n\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = NavDropdown_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-shrink: 0;\n  flex-direction: column;\n  width: 100%;\n  padding: 20px;\n  @media (min-width: ",
        ") {\n    // display: block;\n    width: fit-content;\n    column-count: 1;\n    column-fill: auto;\n    height: 100%;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = NavDropdown_taggedTemplateLiteral([
        "\n  height: 100%;\n  margin: auto;\n  padding-right: 20px;\n  display: grid;\n  grid-gap: 15px;\n  grid-template-columns: repeat(3, 1fr);\n  justify-item: center;\n  align-items: center;\n  a {\n    border: 1px solid #93939391;\n    padding: 10px 5px;\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  a div {\n    height: 150px;\n    width: 150px;\n  }\n\n  @media screen and (max-width: 1700px) {\n    a div {\n      height: 100px;\n      width: 120px;\n    }\n  }\n\n  @media screen and (max-width: 1600px) {\n    a div {\n      height: 100px;\n      width: 85px;\n    }\n  }\n  @media screen and (max-width: 1400px) {\n    a div {\n      height: 100px;\n      width: 75px;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = NavDropdown_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n  svg {\n    margin-right: 10px;\n    width: ",
        ";\n    visibility: ",
        ";\n    transition: width 0.2s ease-in-out;\n  }\n\n  &:hover {\n    cursor: pointer;\n\n    svg {\n      visibility: visible;\n      width: 30px;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = NavDropdown_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 5px;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = NavDropdown_taggedTemplateLiteral([
        "\n  display: ",
        ";\n  align-items: center;\n  padding: 8px;\n  border-top: 1px solid ",
        ";\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = NavDropdown_taggedTemplateLiteral([
        "\n  display: flex;\n  transition: transform 0.25s ease-in;\n  transform: translateX(-",
        "00%);\n  width: 100%;\n\n  @media (min-width: ",
        ") {\n    transform: none;\n    width: 100%;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = NavDropdown_taggedTemplateLiteral([
        "\n  padding-right: 10px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = NavDropdown_taggedTemplateLiteral([
        "\n  color: gray;\n  margin-bottom: 0px;\n  font-size: 12px;\n\n  @media screen and (max-width: 1600px) {\n    font-size: 8px;\n    margin-bottom: 0px;\n    font-size: 10px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = NavDropdown_taggedTemplateLiteral([
        "\n  font-size: 15px;\n  line-height: 20px;\n  @media screen and (max-width: 1600px) {\n    font-size: 10px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = NavDropdown_taggedTemplateLiteral([
        "\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  ",
        " {\n    cursor: pointer;\n    &:hover {\n      color: ",
        ";\n    }\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


















var NavDropwDownContainer = styled_components_browser_esm["default"].div(NavDropdown_templateObject());
var DropdownWrapper = styled_components_browser_esm["default"].div(NavDropdown_templateObject1(), (0,es/* palette */.DG)("white"), (0,es/* palette */.DG)("red"), typography/* Title7 */.Mz, theme/* default.screenSize.sizeMD */.Z.screenSize.sizeMD);
var CategorySection = styled_components_browser_esm["default"].div(_templateObject2(), (0,es/* palette */.DG)("white"), (0,es/* palette */.DG)("red"));
var LinksSection = styled_components_browser_esm["default"].div(_templateObject3(), theme/* default.screenSize.sizeMD */.Z.screenSize.sizeMD);
var SubCategorySection = styled_components_browser_esm["default"].div(_templateObject4(), theme/* default.screenSize.sizeMD */.Z.screenSize.sizeMD, (0,scrollStyle/* default */.Z)({
    color: "red"
}));
var CatCoverImage = styled_components_browser_esm["default"].div(_templateObject5());
var Category = styled_components_browser_esm["default"].span(_templateObject6(), (0,es/* ifProp */.fq)("selected", "30px", "0"), (0,es/* ifProp */.fq)("selected", "visible", "hidden"));
var ProductInfo = styled_components_browser_esm["default"].div(_templateObject7());
var MobileNavigation = styled_components_browser_esm["default"].div(_templateObject8(), (0,es/* ifProp */.fq)({
    show: true
}, "flex", "none"), (0,es/* palette */.DG)("red"), theme/* default.screenSize.sizeMD */.Z.screenSize.sizeMD);
var MobileSlider = styled_components_browser_esm["default"].div(_templateObject9(), (0,es/* prop */.vg)("level"), theme/* default.screenSize.sizeMD */.Z.screenSize.sizeMD);
var BackLink = styled_components_browser_esm["default"].span(_templateObject10());
var Sku = styled_components_browser_esm["default"].p(_templateObject11());
var ProductName = styled_components_browser_esm["default"].p(_templateObject12());
var Section = styled_components_browser_esm["default"].div(_templateObject13(), typography/* Title7 */.Mz, (0,es/* palette */.DG)("red"), (0,scrollStyle/* default */.Z)({
    color: "red"
}));
var hideImg = 1300;
function NavDropdown(param) {
    var show = param.show, close = param.close, links = param.links;
    var ref9;
    var width = (0,useWindowSize/* default */.Z)().width;
    var navigationInfo = (0,PageContext/* usePageContext */.lO)().navigationInfo;
    var ref1 = (0,react.useState)(), categoryMap = ref1[0], setCategoryMap = ref1[1];
    var ref2 = (0,react.useState)(), categories = ref2[0], setCategories = ref2[1];
    var ref3 = (0,react.useState)(), navImages = ref3[0], setNavImages = ref3[1];
    (0,react.useEffect)(function() {
        var ref;
        var nav_images_map = {};
        var catArr = navigationInfo === null || navigationInfo === void 0 ? void 0 : (ref = navigationInfo.navBlocks) === null || ref === void 0 ? void 0 : ref.map(// eslint-disable-next-line no-return-assign
        function(block) {
            nav_images_map[block.slug] = block.productlist ? JSON.parse(block.productlist) : [];
            return block.slug;
        });
        setNavImages(nav_images_map);
        setCategories(catArr);
    }, [
        navigationInfo
    ]);
    var ref4 = (0,generated/* useNavigationCategoriesQuery */.nFH)(), categoriesData = ref4.data;
    (0,react.useEffect)(function() {
        var ref, ref10;
        var categories_map = {};
        categoriesData === null || categoriesData === void 0 ? void 0 : (ref = categoriesData.categories) === null || ref === void 0 ? void 0 : (ref10 = ref.edges) === null || ref10 === void 0 ? void 0 : ref10.forEach(function(cat) {
            var node = cat.node;
            categories_map[node.slug] = node;
        });
        setCategoryMap(categories_map);
    }, [
        categoriesData
    ]);
    var ref5 = (0,react.useState)(null), selectedCategory = ref5[0], setSelectedCategory = ref5[1];
    var ref6 = (0,react.useState)(), selectedPageCategory = ref6[0], setSelectedPageCategory = ref6[1];
    var ref7 = (0,react.useState)(0), level = ref7[0], setLevel = ref7[1];
    // eslint-disable-next-line unused-imports/no-unused-vars
    var ref8 = (0,react.useState)(), showDropdown = ref8[0], setShowDropdown = ref8[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        setShowDropdown(show);
    }, [
        show
    ]);
    var prev = (0,react.useCallback)(function() {
        setLevel(level - 1);
        setSelectedPageCategory(undefined);
    }, [
        setLevel,
        setSelectedPageCategory,
        level
    ]);
    var next = (0,react.useCallback)(function() {
        setLevel(level + 1);
    }, [
        setLevel,
        level
    ]);
    var selectPageCategoryMobile = (0,react.useCallback)(function(category) {
        next();
        setSelectedPageCategory(category);
    }, [
        next,
        setSelectedPageCategory
    ]);
    var selectCategory = (0,react.useCallback)(function() {
        close();
        setLevel(2);
    }, [
        close
    ]);
    // eslint-disable-next-line unused-imports/no-unused-vars
    var hoverCategory = (0,react.useCallback)(function(category) {
        setSelectedCategory(category);
    }, [
        setSelectedCategory
    ]);
    (0,react.useEffect)(function() {
        if (router) {
            router.events.on("routeChangeStart", close);
        }
    }, [
        router,
        close
    ]);
    var isMobile = (0,react.useMemo)(function() {
        var minScreenWidth = theme/* default.screenSize.sizeMD.slice */.Z.screenSize.sizeMD.slice(0, -2);
        return width < Number(minScreenWidth);
    }, [
        width
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropwDownContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Expandable */.Ak, {
            expanded: show,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileNavigation, {
                    show: level !== 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BackLink, {
                            onClick: function() {
                                return prev();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowLeftLineIcon_default()), {
                                color: theme/* default.palette.red */.Z.palette.red
                            })
                        }),
                        level === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H4, {
                            children: !selectedPageCategory ? "Vefverslun" : selectedPageCategory === null || selectedPageCategory === void 0 ? void 0 : selectedPageCategory.name
                        }),
                        level === 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H4, {
                            children: selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name
                        })
                    ]
                }),
                show && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileSlider, {
                            level: level,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinksSection, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_NavBarLink, {
                                                onClick: function() {
                                                    return next();
                                                },
                                                children: "Vefverslun"
                                            }),
                                            links.map(function(link) {
                                                if (link.__typename === "PageRecord") {
                                                    if (!link.path) {
                                                        return null;
                                                    }
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Link */.rU, {
                                                        href: link.path,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_NavBarLink, {
                                                            children: link.heading
                                                        })
                                                    }, link.id);
                                                }
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_NavBarLink, {
                                                    onClick: function() {
                                                        return selectPageCategoryMobile(link);
                                                    },
                                                    children: link.name
                                                }, link.id);
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CategorySection, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                                        children: [
                                            !selectedPageCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Link */.rU, {
                                                href: paths/* paths.categories */.H.categories,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title7 */.Mz, {
                                                    left: width < 768 ? 0 : 10,
                                                    bottom: 30,
                                                    top: 10,
                                                    children: "Allir v\xf6ruflokkar"
                                                })
                                            }),
                                            (!isMobile || !selectedPageCategory) && categoryMap && (categories === null || categories === void 0 ? void 0 : categories.length) ? categories.map(function(category) {
                                                return categoryMap[category] && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Link */.rU, {
                                                        href: (0,paths/* generatePath */.G)(paths/* paths.categories */.H.categories, categoryMap[category].slug, "landingPage=true"),
                                                        shallow: true,
                                                        children: width < 768 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Category, {
                                                            selected: selectedCategory === categoryMap[category],
                                                            onClick: function() {
                                                                return selectCategory();
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title7 */.Mz, {
                                                                children: categoryMap[category].name
                                                            })
                                                        }, categoryMap[category].id) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Category, {
                                                            selected: selectedCategory === categoryMap[category],
                                                            onClick: function() {
                                                                return selectCategory();
                                                            },
                                                            onMouseOver: function() {
                                                                return hoverCategory(categoryMap[category]);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightLineIcon_default()), {
                                                                    color: theme/* default.palette.red */.Z.palette.red
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title7 */.Mz, {
                                                                    children: categoryMap[category].name
                                                                })
                                                            ]
                                                        }, categoryMap[category].id)
                                                    })
                                                }, categoryMap[category].id);
                                            }) : selectedPageCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageCategoryLinks, {
                                                category: selectedPageCategory
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategorySection, {
                                    children: selectedCategory ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategories, {
                                        category: selectedCategory
                                    }) : null
                                })
                            ]
                        }),
                        width > hideImg && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: selectedCategory && navImages && ((ref9 = navImages[selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.slug]) === null || ref9 === void 0 ? void 0 : ref9.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CatCoverImage, {
                                children: navImages[selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.slug].map(function(item) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("a", {
                                        href: "/vara/".concat(item.slug),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Image */.Ee, {
                                                height: width > 1350 ? 200 : 150,
                                                width: width > 1350 ? 200 : 150,
                                                objectFit: "contain",
                                                layout: "fill",
                                                src: item.image_url.replace("https://saleor.rv.reon.is", "https://rv-backend.8h.roanuz.com" || 0),
                                                alt: selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name,
                                                useImg: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductInfo, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Sku, {
                                                        children: item.sku
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductName, {
                                                        children: item.name
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/styles/shadowStyles.ts
var shadowStyles = __webpack_require__(23633);
// EXTERNAL MODULE: ./node_modules/remixicon-react/ShoppingBasket2LineIcon.js
var ShoppingBasket2LineIcon = __webpack_require__(1051);
var ShoppingBasket2LineIcon_default = /*#__PURE__*/__webpack_require__.n(ShoppingBasket2LineIcon);
// EXTERNAL MODULE: ./src/context/CheckoutContext/index.tsx + 15 modules
var CheckoutContext = __webpack_require__(86771);
;// CONCATENATED MODULE: ./src/components/cart/HeaderCart.tsx
function HeaderCart_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function HeaderCart_templateObject() {
    var data = HeaderCart_taggedTemplateLiteral([
        "\n  margin-top: 3px;\n"
    ]);
    HeaderCart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HeaderCart_templateObject1() {
    var data = HeaderCart_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    HeaderCart_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HeaderCart_templateObject2() {
    var data = HeaderCart_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    HeaderCart_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HeaderCart_templateObject3() {
    var data = HeaderCart_taggedTemplateLiteral([
        "\n    display: flex;\n  "
    ]);
    HeaderCart_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HeaderCart_templateObject4() {
    var data = HeaderCart_taggedTemplateLiteral([
        "\n  display: none;\n  margin: 0 15px 0 10px;\n  font-size: 0.875rem;\n\n  ",
        "\n\n  @media screen and (max-width:1450px) {\n    display: none;\n  }\n"
    ]);
    HeaderCart_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HeaderCart_templateObject5() {
    var data = HeaderCart_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  z-index: 1;\n"
    ]);
    HeaderCart_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function HeaderCart_templateObject6() {
    var data = HeaderCart_taggedTemplateLiteral([
        "\n  position: 'relative';\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  z-index: 1;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: ",
        ";\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 24px;\n    height: 24px;\n    opacity: 0.9;\n    z-index: -1;\n    border-radius: 50%;\n    background-color: ",
        ";\n  }\n"
    ]);
    HeaderCart_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}








var ShoppingBasketLineIcon = (0,styled_components_browser_esm["default"])((ShoppingBasket2LineIcon_default()))(HeaderCart_templateObject());
var MiniCartWrapper = styled_components_browser_esm["default"].div(HeaderCart_templateObject1());
var MiniCartIcon = styled_components_browser_esm["default"].div(HeaderCart_templateObject2());
var NavBarIconText = styled_components_browser_esm["default"].span(HeaderCart_templateObject4(), dist.media.md(HeaderCart_templateObject3()));
var CartStatusIcon = styled_components_browser_esm["default"].div(HeaderCart_templateObject5());
var CartQuantity = styled_components_browser_esm["default"].div(HeaderCart_templateObject6(), (0,es/* palette */.DG)("black"), (0,es/* palette */.DG)("background"));
function HeaderCart() {
    var checkout = (0,CheckoutContext/* useCheckout */.Mg)().checkout;
    var cartQty = checkout === null || checkout === void 0 ? void 0 : checkout.quantity;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiniCartWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiniCartIcon, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShoppingBasketLineIcon, {
                        color: themes/* theme.palette.red */.r.palette.red,
                        size: 28
                    }),
                    !!cartQty && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartStatusIcon, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CartQuantity, {
                            children: cartQty
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBarIconText, {
                children: "Karfan m\xedn"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/account/AccountNav.tsx
var AccountNav = __webpack_require__(12391);
// EXTERNAL MODULE: ./src/components/search/index.tsx + 2 modules
var search = __webpack_require__(47347);
;// CONCATENATED MODULE: ./src/components/layout/nav/NavPageDropdown.tsx
function NavPageDropdown_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function NavPageDropdown_templateObject() {
    var data = NavPageDropdown_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    NavPageDropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NavPageDropdown_templateObject1() {
    var data = NavPageDropdown_taggedTemplateLiteral([
        "\n  position: absolute;\n  left: -14px;\n  height: 0;\n"
    ]);
    NavPageDropdown_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function NavPageDropdown_templateObject2() {
    var data = NavPageDropdown_taggedTemplateLiteral([
        "\n    max-height: 50vh;\n  "
    ]);
    NavPageDropdown_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function NavPageDropdown_templateObject3() {
    var data = NavPageDropdown_taggedTemplateLiteral([
        "\n  ",
        ";\n  border-right: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  background-color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  margin-left: 8px;\n  margin-bottom: 8px;\n  width: 200px;\n  padding-top: 10px;\n\n  a {\n    justify-content: flex-start;\n  }\n\n  ",
        "\n"
    ]);
    NavPageDropdown_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function NavPageDropdown_templateObject4() {
    var data = NavPageDropdown_taggedTemplateLiteral([
        "\n  margin: 5px 10px;\n  line-height: 24px;\n\n  &:hover {\n    color: ",
        ";\n    cursor: pointer;\n  }\n"
    ]);
    NavPageDropdown_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}











var Wrapper = styled_components_browser_esm["default"].div(NavPageDropdown_templateObject());
var NavPageDropdown_DropdownWrapper = styled_components_browser_esm["default"].div(NavPageDropdown_templateObject1());
var LinksWrapper = styled_components_browser_esm["default"].div(NavPageDropdown_templateObject3(), (0,shadowStyles/* default */.ZP)({
    color: "red",
    outlined: false,
    length: 8,
    showOnHover: false
}), (0,es/* palette */.DG)("red"), (0,es/* palette */.DG)("red"), (0,es/* palette */.DG)("white"), dist.media.lg(NavPageDropdown_templateObject2()));
var DropdownLink = styled_components_browser_esm["default"].a(NavPageDropdown_templateObject4(), (0,es/* palette */.DG)("red"));
function NavPageDropdown(param) {
    var show = param.show, links = param.links;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavPageDropdown_DropdownWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Expandable */.Ak, {
            expanded: show,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinksWrapper, {
                children: links === null || links === void 0 ? void 0 : links.map(function(link) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: link.path,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownLink, {
                            children: link.heading
                        })
                    }, link.heading);
                })
            })
        })
    });
}
function NavCategoryLink(param) {
    var id = param.id, name = param.name, links = param.links;
    var close = function close() {
        closeDropdown();
    };
    var toggleDropdown = function toggleDropdown() {
        if (isOpen) {
            closeDropdown();
        } else {
            setOpenDropdown(id);
        }
    };
    var ref = usePageContext(), currentOpenDropdown = ref.currentOpenDropdown, setOpenDropdown = ref.setOpenDropdown, closeDropdown = ref.closeDropdown;
    var isOpen = currentOpenDropdown === id;
    var dropdownRef = useRef(null);
    useClickAway(dropdownRef, function() {
        close();
    });
    return /*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            /*#__PURE__*/ _jsx(NavBarLink, {
                onClick: toggleDropdown,
                style: {
                    fontWeight: isOpen ? 700 : 400
                },
                text: name,
                children: name
            }),
            /*#__PURE__*/ _jsx(NavPageDropdown, {
                links: links,
                show: isOpen
            })
        ]
    });
}
function NavDatoCategoryLink(param) {
    var category = param.category;
    var close = function close() {
        closeDropdown();
    };
    var toggleDropdown = function toggleDropdown() {
        if (isOpen) {
            closeDropdown();
        } else {
            setOpenDropdown(category.id);
        }
    };
    var ref = (0,PageContext/* usePageContext */.lO)(), getPagesByCategory = ref.getPagesByCategory, getLinksBySlug = ref.getLinksBySlug, currentOpenDropdown = ref.currentOpenDropdown, setOpenDropdown = ref.setOpenDropdown, closeDropdown = ref.closeDropdown;
    var isOpen = currentOpenDropdown === category.id;
    var dropdownRef = (0,react.useRef)(null);
    (0,esm_useClickAway/* default */.Z)(dropdownRef, function() {
        close();
    });
    var links = (0,react.useMemo)(function() {
        var id = category === null || category === void 0 ? void 0 : category.id;
        if (!getPagesByCategory || !id) {
            return null;
        }
        var pages = (getPagesByCategory(id) || []).map(function(page) {
            return {
                path: page.path,
                heading: page.heading
            };
        }).filter(function(e) {
            return e.path != null && e.heading != null;
        });
        if (category === null || category === void 0 ? void 0 : category.slug) {
            var newLinks = getLinksBySlug(category === null || category === void 0 ? void 0 : category.slug).map(function(page) {
                return {
                    path: page.path,
                    heading: page.heading
                };
            });
            if (!pages.length) {
                return newLinks;
            }
        }
        if (pages) {
            return pages;
        }
        return null;
    }, [
        category === null || category === void 0 ? void 0 : category.id,
        category === null || category === void 0 ? void 0 : category.slug,
        getLinksBySlug,
        getPagesByCategory
    ]);
    if (!links) {
        return null;
    }
    var _name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_NavBarLink, {
                onClick: toggleDropdown,
                style: {
                    fontWeight: isOpen ? 700 : 400
                },
                text: (_name = category.name) !== null && _name !== void 0 ? _name : "",
                children: category.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavPageDropdown, {
                links: links,
                show: isOpen
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/layout/nav/Header.tsx
function Header_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Header_templateObject() {
    var data = Header_taggedTemplateLiteral([
        "\n  margin-top: 1px;\n"
    ]);
    Header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_templateObject1() {
    var data = Header_taggedTemplateLiteral([
        "\n    max-width: ",
        ";\n    margin: auto;\n  "
    ]);
    Header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Header_templateObject2() {
    var data = Header_taggedTemplateLiteral([
        "\n  position: sticky;\n  top: 0px;\n  left: 0;\n  right: 0;\n  width: 100%;\n  z-index: ",
        ";\n  ",
        "\n\n  @media screen and (max-width:786px) {\n    top: ",
        ";\n    transition: all 0.3s;\n  }\n"
    ]);
    Header_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Header_templateObject3() {
    var data = Header_taggedTemplateLiteral([
        "\n  position: absolute;\n  width: 100%;\n"
    ]);
    Header_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Header_templateObject4() {
    var data = Header_taggedTemplateLiteral([
        "\n    margin-top: 0px;\n  "
    ]);
    Header_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Header_templateObject5() {
    var data = Header_taggedTemplateLiteral([
        "\n  max-width: 100%;\n  margin: 16px 12px 0 21px;\n  border: 1px solid ",
        ";\n  height: 100%;\n  background-color: ",
        ";\n  ",
        "\n\n  ",
        "\n"
    ]);
    Header_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Header_templateObject6() {
    var data = Header_taggedTemplateLiteral([
        "\n    width: 53px;\n    margin-top: -43px;\n  "
    ]);
    Header_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Header_templateObject7() {
    var data = Header_taggedTemplateLiteral([
        "\n  width: 28px;\n  margin-top: -8px;\n  margin-right: 8px;\n\n  ",
        "\n"
    ]);
    Header_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Header_templateObject8() {
    var data = Header_taggedTemplateLiteral([
        "\n    padding-right: 16px;\n  "
    ]);
    Header_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Header_templateObject9() {
    var data = Header_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding-left: 0;\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    Header_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function Header_templateObject10() {
    var data = Header_taggedTemplateLiteral([
        "\n  position: relative;\n  align-items: end;\n  margin-top: -1px;\n"
    ]);
    Header_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function Header_templateObject11() {
    var data = Header_taggedTemplateLiteral([
        "\n    height: 80px;\n  "
    ]);
    Header_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function Header_templateObject12() {
    var data = Header_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 60px;\n  padding: 0 45px;\n\n  @media (max-width: ",
        ") {\n    padding-left: 30px;\n    padding-right: 14px;\n  }\n\n  ",
        "\n"
    ]);
    Header_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function Header_templateObject13() {
    var data = Header_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content:space-between;\n  "
    ]);
    Header_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = Header_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content:flex-start;\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = Header_taggedTemplateLiteral([
        "\n  display: none;\n  justify-content: flex-start;\n  width: 100%;\n  border-top: 1px solid ",
        ";\n  padding: 0 45px;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = Header_taggedTemplateLiteral([
        "\n    margin-right: 0px;\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = Header_taggedTemplateLiteral([
        "\n    margin-right: 50px;\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = Header_taggedTemplateLiteral([
        "\n  display: inline-block;\n  margin: 5px 40px 5px 0;\n  font-size: 1rem;\n  color: inherit;\n  cursor: pointer;\n  transition: color 0.15s;\n  line-height: 1.8;\n  font-weight: 400;\n  ",
        "\n  ",
        "\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  &::before {\n    display: block;\n    content: '",
        "';\n    font-weight: 700;\n    height: 0;\n    overflow: hidden;\n    visibility: hidden;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = Header_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n  @media (max-width: ",
        "px) {\n    width: 100%;\n    margin-left: auto;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = Header_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  white-space: nowrap;\n  position: relative;\n  cursor: pointer;\n  transition: transform 0.15s;\n  padding: 8px;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = Header_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = Header_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = Header_taggedTemplateLiteral([
        "\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = Header_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = Header_taggedTemplateLiteral([
        "\n  font-size: 1.5rem;\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = Header_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  box-shadow: inset 0px -3px 0px #e8e8e8;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = Header_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  background-color: ",
        ";\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = Header_taggedTemplateLiteral([
        "\n    display: flex;\n  "
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = Header_taggedTemplateLiteral([
        "\n  display: none;\n  font-size: 0.875rem;\n  padding: 10px;\n\n  svg {\n    margin-right: 10px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = Header_taggedTemplateLiteral([
        "\n  width: 100%;\n  background-color: ",
        ";\n\n  &:before {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    content: '';\n    height: 60px;\n    background-color: ",
        ";\n    z-index: -1;\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
























var Header_Menu4LineIcon = (0,styled_components_browser_esm["default"])((Menu4LineIcon_default()))(Header_templateObject());
var HeaderContainer = styled_components_browser_esm["default"].div(Header_templateObject2(), (0,es/* theme */.rS)("zIndex.header"), dist.media.xl(Header_templateObject1(), theme/* default.headerAndFooterSize.xLargeDesktop */.Z.headerAndFooterSize.xLargeDesktop), function(props) {
    return props.scroll ? "-100%" : "0";
});
var HeaderInnerContainer = styled_components_browser_esm["default"].div(Header_templateObject3());
var NavBarWrapper = styled_components_browser_esm["default"].div(Header_templateObject5(), (0,es/* palette */.DG)("red"), (0,es/* palette */.DG)("white"), (0,shadowStyles/* default */.ZP)({
    color: "red",
    outlined: false,
    length: 8,
    showOnHover: false
}), dist.media.lg(Header_templateObject4()));
var NavBrandLogo = styled_components_browser_esm["default"].img(Header_templateObject7(), dist.media.lg(Header_templateObject6()));
var NavBrand = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(Header_templateObject9(), dist.media.lg(Header_templateObject8()));
var NavBarContentWrapper = styled_components_browser_esm["default"].div(Header_templateObject10());
var NavBar = styled_components_browser_esm["default"].div(Header_templateObject12(), theme/* default.screenSize.sizeMD */.Z.screenSize.sizeMD, dist.media.lg(Header_templateObject11()));
var NavBarLinkWrapper = styled_components_browser_esm["default"].div(_templateObject15(), (0,es/* palette */.DG)("black10"), dist.media.md(Header_templateObject13()), dist.media.lg(_templateObject14()));
var Header_NavBarLink = styled_components_browser_esm["default"].div(_templateObject18(), dist.media.md(_templateObject16()), dist.media.lg(_templateObject17()), (0,es/* palette */.DG)("red"), function(props) {
    return props.text;
});
var NavBarFunctions = styled_components_browser_esm["default"].div(_templateObject19(), themes/* gridTheme.breakpoints.lg */.k.breakpoints.lg - 1);
var iconLinkStyles = (0,styled_components_browser_esm.css)(_templateObject20(), (0,es/* palette */.DG)("primary"));
var NavBarIconLink = styled_components_browser_esm["default"].div(_templateObject21(), iconLinkStyles);
var MenuIconLink = styled_components_browser_esm["default"].div(_templateObject23(), iconLinkStyles, dist.media.md(_templateObject22()));
var CartIconLink = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(_templateObject24(), iconLinkStyles);
var NavBrandText = styled_components_browser_esm["default"].div(_templateObject25(), Headings/* headingsCommonStyle */.m);
var SearchWrapper = styled_components_browser_esm["default"].div(_templateObject26(), (0,es/* palette */.DG)("background"));
var Info = styled_components_browser_esm["default"].div(_templateObject27(), (0,es/* palette */.DG)("background"));
var InfoItem = styled_components_browser_esm["default"].div(_templateObject29(), dist.media.lg(_templateObject28()));
var InfoWrapper = styled_components_browser_esm["default"].div(_templateObject30(), (0,es/* palette */.DG)("background"), (0,es/* palette */.DG)("background"));
function Header() {
    var toggleDropdown = function toggleDropdown() {
        if (showDropdown) {
            closeDropdown();
        } else {
            setOpenDropdown(dropdownId);
        }
    };
    var ref = (0,PageContext/* usePageContext */.lO)(), headerData = ref.headerData, currentOpenDropdown = ref.currentOpenDropdown, setOpenDropdown = ref.setOpenDropdown, closeDropdown = ref.closeDropdown;
    var ref1 = (0,react.useState)(false), scroll = ref1[0], setScroll = ref1[1];
    var ref2 = (0,react.useState)(0), scrollValue = ref2[0], setScrollValue = ref2[1];
    var scrollTop = (0,useScrollTop/* useScrollTop */.j)();
    (0,react.useEffect)(function() {
        if (scrollValue < scrollTop) {
            setScroll(true);
        } else {
            setScroll(false);
        }
        setScrollValue(scrollTop);
    }, [
        scrollTop,
        scrollValue
    ]);
    var dropdownId = "main";
    var showDropdown = currentOpenDropdown === dropdownId;
    var menuRef = (0,react.useRef)(null);
    var links = headerData.links;
    (0,esm_useClickAway/* default */.Z)(menuRef, function() {
        closeDropdown();
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContainer, {
        className: "header-container",
        scroll: scroll,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderInnerContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((PhoneFillIcon_default()), {
                                            size: 14
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "tel:+520 6666",
                                            children: "520 6666"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((MailFillIcon_default()), {
                                            size: 14
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "mailto:sala@rv.is",
                                            children: "sala@rv.is"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavBarWrapper, {
                    ref: menuRef,
                    className: "navbar-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavBar, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavBrand, {
                                    href: paths/* paths.home */.H.home,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBrandLogo, {
                                            src: "/assets/rv-logo-solid.png"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBrandText, {
                                            children: "Rekstrarv\xf6rur"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search/* SearchBar */.E, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBarContentWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavBarFunctions, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountNav/* AccountNav */.f, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartIconLink, {
                                                href: paths/* paths.cart */.H.cart,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderCart, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuIconLink, {
                                                onClick: toggleDropdown,
                                                children: [
                                                    !showDropdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Menu4LineIcon, {
                                                        color: theme/* default.palette.red */.Z.palette.red,
                                                        size: 28
                                                    }),
                                                    showDropdown && /*#__PURE__*/ (0,jsx_runtime.jsx)((CloseLineIcon_default()), {
                                                        color: theme/* default.palette.red */.Z.palette.red,
                                                        size: 28
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavBarLinkWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_NavBarLink, {
                                    onClick: toggleDropdown,
                                    style: {
                                        fontWeight: showDropdown ? 700 : 400
                                    },
                                    text: "Vefverslun",
                                    children: "Vefverslun"
                                }),
                                links.filter(isNotNull/* isNotNull */.K).map(function(link) {
                                    if (link.__typename === "PageRecord") {
                                        if (!link.path || !link.id || !link.heading) {
                                            return null;
                                        }
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            href: link.path,
                                            shallow: link.path.startsWith(paths/* paths.categories */.H.categories),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_NavBarLink, {
                                                text: link.heading,
                                                children: link.heading
                                            })
                                        }, link.id);
                                    }
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDatoCategoryLink, {
                                        category: link
                                    }, link.id);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavDropdown, {
                            show: showDropdown,
                            close: closeDropdown,
                            links: links
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/layout/Footer.tsx
var Footer = __webpack_require__(9262);
// EXTERNAL MODULE: ./src/components/layout/PageContainer.tsx + 4 modules
var PageContainer = __webpack_require__(78823);
// EXTERNAL MODULE: ./src/components/layout/SpacingWrapper.tsx
var SpacingWrapper = __webpack_require__(22098);
;// CONCATENATED MODULE: ./src/components/layout/BlockWrapper.tsx
function BlockWrapper_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function BlockWrapper_templateObject() {
    var data = BlockWrapper_taggedTemplateLiteral([
        "\n  max-width: ",
        "px;\n  margin: auto;\n  img {\n    max-width: 90% !important;\n    margin-left: auto !important;\n    margin-right: auto !important;\n    height: auto !important;\n    object-fit: contain;\n  }\n"
    ]);
    BlockWrapper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var BlockContainer = styled_components_browser_esm["default"].div(BlockWrapper_templateObject(), (0,es/* prop */.vg)("customWidth"));
function BlockWrapper(param) {
    var backgroundColor = param.backgroundColor, children = param.children, _customWidth = param.customWidth, customWidth = _customWidth === void 0 ? themes/* gridTheme.breakpoints.xl */.k.breakpoints.xl : _customWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SpacingWrapper/* FluidSpacing */.l2, {
        from: 30,
        to: 30,
        style: {
            backgroundColor: backgroundColor
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockContainer, {
            customWidth: customWidth,
            children: children
        })
    });
};

;// CONCATENATED MODULE: ./src/components/layout/BlockTitle.tsx
function BlockTitle_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function BlockTitle_templateObject() {
    var data = BlockTitle_taggedTemplateLiteral([
        "\n    flex-direction: row-reverse;\n    justify-content: flex-end;\n    margin-left: -70px;\n  "
    ]);
    BlockTitle_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BlockTitle_templateObject1() {
    var data = BlockTitle_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n\n  ",
        "\n"
    ]);
    BlockTitle_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BlockTitle_templateObject2() {
    var data = BlockTitle_taggedTemplateLiteral([
        "\n    max-width: 54px;\n    margin: 0 16px 4px 0;\n  "
    ]);
    BlockTitle_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BlockTitle_templateObject3() {
    var data = BlockTitle_taggedTemplateLiteral([
        "\n  height: 2px;\n  margin: 0 24px;\n  background-color: ",
        ";\n  width: 0;\n  flex-grow: 1;\n\n  ",
        "\n"
    ]);
    BlockTitle_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var BlockTitleWrapper = styled_components_browser_esm["default"].div(BlockTitle_templateObject1(), dist.media.lg(BlockTitle_templateObject()));
var BlockLine = styled_components_browser_esm["default"].div(BlockTitle_templateObject3(), (0,es/* palette */.DG)("red"), dist.media.lg(BlockTitle_templateObject2()));
function BlockTitle(param) {
    var h1 = param.h1, title = param.title;
    var Typography = h1 ? typography.H1 : typography.H2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlockTitleWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockLine, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/layout/index.ts








/***/ }),

/***/ 80489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ProductCard": function() { return /* binding */ ProductCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
;// CONCATENATED MODULE: ./src/components/products/ProductCard/components/container.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: 100%;\n  padding: 15px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ProductCardContainer = styled_components_browser_esm["default"].div(_templateObject());

// EXTERNAL MODULE: ./src/utils/isTouch.ts
var isTouch = __webpack_require__(20619);
;// CONCATENATED MODULE: ./src/components/products/ProductCard/components/FavoriteButton.tsx
function FavoriteButton_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function FavoriteButton_templateObject() {
    var data = FavoriteButton_taggedTemplateLiteral([
        "\n  opacity: ",
        ";\n  transition: opacity 0.15s;\n  z-index: 2;\n  position: absolute;\n  top: 0;\n  right: 0;\n  &.selected {\n    opacity: 1;\n  }\n"
    ]);
    FavoriteButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var FavoriteButton = styled_components_browser_esm["default"].div(FavoriteButton_templateObject(), isTouch/* isTouchDevice */.b ? 1 : 0);

;// CONCATENATED MODULE: ./src/components/products/ProductCard/components/ProductTags.tsx
function ProductTags_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProductTags_templateObject() {
    var data = ProductTags_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: -8px;\n  left: 10px;\n  display: flex;\n  z-index: 2;\n"
    ]);
    ProductTags_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ProductTags = styled_components_browser_esm["default"].div(ProductTags_templateObject());

// EXTERNAL MODULE: ./node_modules/styled-tools/dist/es/index.js + 6 modules
var es = __webpack_require__(41145);
;// CONCATENATED MODULE: ./src/components/products/ProductCard/components/wrapper.tsx
function wrapper_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function wrapper_templateObject() {
    var data = wrapper_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  max-width: 500px;\n  padding: 16px;\n  padding-top: 30px;\n  transition: border 0.15s;\n  background-color: ",
        ";\n  border: 1px solid\n    ",
        ";\n\n  &:after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 4px;\n    opacity: 0;\n    transition: opacity 0.15s;\n    background-color: ",
        ";\n  }\n\n  &:hover {\n    &:after {\n      opacity: 1;\n    }\n\n    ",
        " {\n      opacity: 1;\n      cursor: pointer;\n    }\n  }\n"
    ]);
    wrapper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ProductCardWrapper = styled_components_browser_esm["default"].div(wrapper_templateObject(), (0,es/* palette */.DG)("white"), function(p) {
    return p.recommended ? (0,es/* palette */.DG)("red") : (0,es/* palette */.DG)("black20");
}, (0,es/* palette */.DG)("red"), FavoriteButton);

;// CONCATENATED MODULE: ./src/components/products/ProductCard/components/FlexBetween.ts
function FlexBetween_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function FlexBetween_templateObject() {
    var data = FlexBetween_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    FlexBetween_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var FlexBetween = styled_components_browser_esm["default"].div(FlexBetween_templateObject());

// EXTERNAL MODULE: ./src/components/typography/index.tsx + 1 modules
var typography = __webpack_require__(56795);
// EXTERNAL MODULE: ./src/themes/index.tsx
var themes = __webpack_require__(52287);
;// CONCATENATED MODULE: ./src/components/products/ProductCard/components/Description.ts
function Description_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Description_templateObject() {
    var data = Description_taggedTemplateLiteral([
        "\n  ",
        "\n  margin-bottom: 24px;\n  display: none;\n  @media (min-width: ",
        "px) {\n    display: block;\n  }\n"
    ]);
    Description_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Description = styled_components_browser_esm["default"].div(Description_templateObject(), typography/* paragraphStyles */.c, themes/* gridTheme.breakpoints.lg */.k.breakpoints.lg);

;// CONCATENATED MODULE: ./src/components/products/ProductCard/components/FormerPrice.ts
function FormerPrice_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function FormerPrice_templateObject() {
    var data = FormerPrice_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: line-through;\n"
    ]);
    FormerPrice_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var FormerPrice = styled_components_browser_esm["default"].div(FormerPrice_templateObject(), (0,es/* palette */.DG)("red"));

;// CONCATENATED MODULE: ./src/components/products/ProductCard/components/index.ts








// EXTERNAL MODULE: ./src/components/products/ProductCard/context.ts
var context = __webpack_require__(62341);
// EXTERNAL MODULE: ./src/components/products/index.tsx + 38 modules
var products = __webpack_require__(18254);
;// CONCATENATED MODULE: ./src/components/products/ProductCard/CardProductCardTags.tsx




var CardProductTags = function() {
    var product = (0,context/* useProductCardContext */.I)().product;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTags, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(products/* ProductTagsWrapper */.S4, {
            labels: product.labels,
            isAvailable: product.isAvailable
        })
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductCard/CardWrapper.tsx


var CardWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardWrapper, {
        recommended: false,
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/buttons/index.tsx + 6 modules
var buttons = __webpack_require__(31494);
// EXTERNAL MODULE: ./node_modules/remixicon-react/HeartFillIcon.js
var HeartFillIcon = __webpack_require__(38385);
var HeartFillIcon_default = /*#__PURE__*/__webpack_require__.n(HeartFillIcon);
// EXTERNAL MODULE: ./src/context/UserContext.tsx + 1 modules
var UserContext = __webpack_require__(76336);
;// CONCATENATED MODULE: ./src/components/products/ProductCard/CardProductUser.tsx









var CardProductUser = function() {
    var user = (0,UserContext/* useUser */.aF)().user;
    var ref = (0,context/* useProductCardContext */.I)(), setShowModal = ref.setShowModal, itemInShoppingList = ref.itemInShoppingList;
    var handleClick = (0,react.useCallback)(function() {
        return setShowModal(true);
    }, [
        setShowModal
    ]);
    if (!user) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteButton, {
        className: classnames_default()({
            selected: !!itemInShoppingList.length
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* CornerButton */.gm, {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((HeartFillIcon_default()), {
                color: itemInShoppingList.length ? themes/* theme.palette.primary */.r.palette.primary : themes/* theme.palette.black20 */.r.palette.black20,
                size: 16
            }),
            onClick: handleClick
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./src/components/common/index.tsx + 15 modules
var common = __webpack_require__(69446);
// EXTERNAL MODULE: ./src/styles/imageStyles.ts
var imageStyles = __webpack_require__(42521);
// EXTERNAL MODULE: ./src/utils/paths.ts
var paths = __webpack_require__(27827);
;// CONCATENATED MODULE: ./src/components/products/ProductCard/utils/cutText.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var cutText = function(text) {
    var limit = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        limit: 150
    }).limit;
    var words = text.split(/(?=[ ,.!-]+)/);
    return words.reduce(function(a, b) {
        if (a.lastSkipped) {
            return a;
        }
        var currentLength = a.length;
        var valueLength = b.length;
        var newLength = currentLength + valueLength;
        var newString = "".concat(a.value).concat(b);
        if (newLength >= limit) {
            var oldValue = a.value.replace(/[ ,.!-]+$/, "");
            return _objectSpread({}, a, {
                value: "".concat(oldValue, " \u2026"),
                lastSkipped: true
            });
        }
        return _objectSpread({}, a, {
            length: newLength,
            value: newString
        });
    }, {
        value: "",
        length: 0,
        lastSkipped: false
    }).value;
};

;// CONCATENATED MODULE: ./src/components/products/ProductCard/CardTitle.tsx
function CardTitle_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CardTitle_templateObject() {
    var data = CardTitle_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  @media (max-width: ",
        ") {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n"
    ]);
    CardTitle_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = CardTitle_taggedTemplateLiteral([
        "\n  @media (max-width: ",
        ") {\n    display: flex;\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = CardTitle_taggedTemplateLiteral([
        "\n  height: 180px;\n  width: 100%;\n  margin-bottom: 24px;\n  position: relative;\n  @media (max-width: ",
        ") {\n    height: 100px;\n    width: 100%;\n    max-width: 140px;\n    margin-bottom: 0;\n    margin-right: 16px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

// REASON: Href gets added by NextJS
/* eslint-disable jsx-a11y/anchor-is-valid */ 











var CardTitle_CardWrapper = styled_components_browser_esm["default"].div(CardTitle_templateObject(), themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD);
var CardText = styled_components_browser_esm["default"].div(_templateObject1(), themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD);
var ProductImage = styled_components_browser_esm["default"].div(_templateObject2(), themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD);
var CardTitle = function() {
    var ref;
    var product = (0,context/* useProductCardContext */.I)().product;
    var data = (0,react.useMemo)(function() {
        return {
            __html: cutText(product.description)
        };
    }, [
        product.description
    ]);
    var _url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: "".concat(paths/* paths.product */.H.product, "/").concat(product.slug),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTitle_CardWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardText, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBetween, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PSmall */.zK, {
                                    color: "black40",
                                    children: product.sku
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title6 */.L8, {
                                children: product.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                                withGutter: true,
                                children: product.categoryName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage, {
                        children: ((ref = product.thumbnail) === null || ref === void 0 ? void 0 : ref.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(imageStyles/* BackgroundImageContain */.r, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                layout: "fill",
                                objectFit: "contain",
                                objectPosition: "center",
                                src: (_url = product.thumbnail.url) !== null && _url !== void 0 ? _url : ""
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* NoImage */.Dy, {
                            size: 64
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        dangerouslySetInnerHTML: data
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/styled-bootstrap-grid/dist/index.js
var dist = __webpack_require__(54572);
// EXTERNAL MODULE: ./src/components/products/ProductCartPicker/interfaces.ts
var interfaces = __webpack_require__(64474);
;// CONCATENATED MODULE: ./src/components/products/ProductCard/CardShop.tsx
function CardShop_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CardShop_templateObject() {
    var data = CardShop_taggedTemplateLiteral([
        "\n    heigth: 115px;\n  "
    ]);
    CardShop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CardShop_templateObject1() {
    var data = CardShop_taggedTemplateLiteral([
        "\n  height: 105px;\n  display: flex;\n  align-items: flex-end;\n\n  ",
        "\n"
    ]);
    CardShop_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var LoaderWrapper = styled_components_browser_esm["default"].div(CardShop_templateObject1(), dist.media.md(CardShop_templateObject()));
var CardShop = function() {
    var ref = (0,context/* useProductCardContext */.I)(), product = ref.product, setShowPopup = ref.setShowPopup;
    var handleClick = (0,react.useCallback)(function() {
        setShowPopup(function(value) {
            return !value;
        });
    }, [
        setShowPopup
    ]);
    if (product.pricing === null) {
        return null;
    }
    var ref1;
    var price = (product === null || product === void 0 ? void 0 : product.pricing) ? (ref1 = product.pricing.find(function(param) {
        var unitType = param.unitType;
        return unitType === interfaces/* ProductTypeBox */.TW;
    })) !== null && ref1 !== void 0 ? ref1 : product.pricing[0] : undefined;
    var ref2;
    var piecePrice = (product === null || product === void 0 ? void 0 : product.pricing) ? (ref2 = product.pricing.find(function(param) {
        var unitType = param.unitType;
        return unitType === interfaces/* ProductTypePiece */.Ji;
    })) !== null && ref2 !== void 0 ? ref2 : product.pricing[0] : undefined;
    if (piecePrice === undefined) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Loader */.aN, {})
        });
    }
    var specialOrder = product.labels.some(function(s) {
        return s.name === "S\xe9rp\xf6ntun";
    });
    var cartButtonText = specialOrder && "Setja v\xf6ru \xed k\xf6rfu" || !product.isAvailable && "Vara v\xe6ntanleg" || product.hidePrice && "Senda fyrirspurn" || "Setja v\xf6ru \xed k\xf6rfu";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                !(product === null || product === void 0 ? void 0 : product.hidePrice) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormerPrice, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography.H6, {
                                children: [
                                    piecePrice.grossOriginalPriceFormatted || null,
                                    " "
                                ]
                            })
                        }),
                        price ? /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H4, {
                            withGutter: true,
                            children: price.grossUnitPriceFormatted
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H4, {
                            withGutter: true,
                            children: piecePrice.grossUnitPriceFormatted
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* CartButton */.WE, {
                    color: !product.isAvailable ? "black40" : "secondary",
                    fill: true,
                    disabled: !product.isAvailable,
                    showIcon: !product.hidePrice,
                    onClick: handleClick,
                    children: cartButtonText
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/shoppingLists/index.tsx + 4 modules
var shoppingLists = __webpack_require__(53220);
;// CONCATENATED MODULE: ./src/components/products/ProductCard/CardProductModel.tsx




var CardProductModal = function() {
    var ref;
    var ref1 = (0,context/* useProductCardContext */.I)(), product = ref1.product, setShowModal = ref1.setShowModal, showModal = ref1.showModal, itemInShoppingList = ref1.itemInShoppingList, shoppingListProductId = ref1.shoppingListProductId, shoppingListId = ref1.shoppingListId, shoppingList = ref1.shoppingList;
    if (shoppingList) {
        if (!shoppingListProductId || !shoppingListId) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Modal */.u_, {
            setShow: setShowModal,
            show: showModal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shoppingLists/* DeleteShoppingListItem */.sm, {
                id: shoppingListProductId,
                listId: shoppingListId,
                setShowModal: setShowModal
            })
        });
    }
    if (!product.variantId) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Modal */.u_, {
        setShow: setShowModal,
        show: showModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shoppingLists/* AddItemToShoppingList */.$b, {
            title: product.name,
            image: (ref = product.thumbnail) === null || ref === void 0 ? void 0 : ref.url,
            id: product.variantId,
            itemInShoppingList: itemInShoppingList
        })
    });
};

// EXTERNAL MODULE: ./src/api/local/useLocalProduct.ts + 1 modules
var useLocalProduct = __webpack_require__(84348);
// EXTERNAL MODULE: ./src/context/DataContext.tsx
var DataContext = __webpack_require__(48435);
// EXTERNAL MODULE: ./src/context/ShoppingListContext.tsx
var ShoppingListContext = __webpack_require__(44339);
// EXTERNAL MODULE: ./src/utils/products.ts
var utils_products = __webpack_require__(5979);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/products/ProductCard/hooks/useShoppingListId.ts

var useShoppingListId = function() {
    var router = (0,next_router.useRouter)();
    return typeof router.query.listId === "string" ? router.query.listId : null;
};

;// CONCATENATED MODULE: ./src/components/products/ProductCard/hooks/useProductValue.ts






var useProductValue = function(param) {
    var slug = param.slug, shallow = param.shallow, shoppingList = param.shoppingList, injected = param.injected, shoppingListProductId = param.shoppingListProductId;
    var shoppingLists = (0,ShoppingListContext/* useShoppingList */.B9)().shoppingLists;
    var shoppingListId = useShoppingListId();
    var ref4 = (0,react.useState)(false), showModal = ref4[0], setShowModal = ref4[1];
    var ref1 = (0,react.useState)(false), showPopup = ref1[0], setShowPopup = ref1[1];
    var ref2;
    var ssrProduct = (ref2 = (0,DataContext/* useDataContext */.f)(slug)) !== null && ref2 !== void 0 ? ref2 : null;
    var ref3 = (0,useLocalProduct/* useLocalProduct */.F)({
        slug: slug,
        injected: injected
    }), localData = ref3.data, error = ref3.error, loading = ref3.loading;
    var data = (0,react.useMemo)(function() {
        if (ssrProduct && !(localData === null || localData === void 0 ? void 0 : localData.productBySlug)) {
            return ssrProduct;
        }
        var ref;
        return (ref = localData === null || localData === void 0 ? void 0 : localData.productBySlug) !== null && ref !== void 0 ? ref : null;
    }, [
        ssrProduct,
        localData
    ]);
    var value = (0,react.useMemo)(function() {
        if (error) {
            return null;
        }
        // Partial return. Pricing might still be loading.
        // Pricing will be empty on SSR
        if (!data && loading) {
            return null;
        }
        if (!data) {
            return null;
        }
        var variantId = data.variantId;
        var itemInShoppingList = variantId ? (0,utils_products/* findItemInShoppingList */.NX)({
            variantId: variantId,
            shoppingLists: shoppingLists !== null && shoppingLists !== void 0 ? shoppingLists : []
        }) : [];
        return {
            shallow: !!shallow,
            product: data,
            shoppingList: shoppingList,
            shoppingListProductId: shoppingListProductId !== null && shoppingListProductId !== void 0 ? shoppingListProductId : null,
            itemInShoppingList: itemInShoppingList,
            shoppingListId: shoppingListId,
            setShowPopup: setShowPopup,
            showPopup: showPopup,
            setShowModal: setShowModal,
            showModal: showModal
        };
    }, [
        data,
        error,
        loading,
        shallow,
        shoppingList,
        shoppingListId,
        shoppingListProductId,
        shoppingLists,
        showModal,
        showPopup, 
    ]);
    return value;
};

// EXTERNAL MODULE: ./node_modules/react-use/esm/useClickAway.js
var useClickAway = __webpack_require__(69293);
// EXTERNAL MODULE: ./node_modules/remixicon-react/CloseLineIcon.js
var CloseLineIcon = __webpack_require__(46550);
var CloseLineIcon_default = /*#__PURE__*/__webpack_require__.n(CloseLineIcon);
;// CONCATENATED MODULE: ./src/components/products/ProductCard/CardPopOver.tsx
function CardPopOver_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CardPopOver_templateObject() {
    var data = CardPopOver_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  width: calc(100% + 2px);\n  height: calc(100% + 2px);\n  opacity: ",
        ";\n  z-index: ",
        ";\n  transition: opacity 0.2s ease-in\n    ",
        ";\n"
    ]);
    CardPopOver_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CardPopOver_templateObject1() {
    var data = CardPopOver_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  height: 100%;\n"
    ]);
    CardPopOver_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CardPopOver_templateObject2() {
    var data = CardPopOver_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  backdrop-filter: blur(1px);\n  background-color: rgba(0, 0, 0, 0.25);\n  @media (max-width: ",
        ") {\n  }\n"
    ]);
    CardPopOver_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = CardPopOver_taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  z-index: 2;\n  margin-top: auto;\n  padding: 20px 0px 20px;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  height: 100%;\n  @media (max-width: ",
        ") {\n    box-shadow: rgba(59, 64, 69, 0.721) 0px 20px 30px -10px;\n    padding: 20px 10px;\n    height: auto;\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 9px;\n    border-top: 1px solid ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = CardPopOver_taggedTemplateLiteral([
        "\n  height: 100%;\n  width: 100%;\n  padding: 0px 20px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  z-index: 1;\n  @media (max-width: ",
        ") {\n    padding: 10px 15px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}










var CartPopover = styled_components_browser_esm["default"].div(CardPopOver_templateObject(), (0,es/* ifProp */.fq)({
    open: true
}, 1, 0), (0,es/* ifProp */.fq)({
    open: true
}, 3, -1), (0,es/* ifProp */.fq)({
    open: true
}, "", ", z-index 0.2s step-end"));
var CartPopoverContainer = styled_components_browser_esm["default"].div(CardPopOver_templateObject1());
var PopoverBackgroundBlur = styled_components_browser_esm["default"].div(CardPopOver_templateObject2(), themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD);
var PickerContainer = styled_components_browser_esm["default"].div(_templateObject3(), (0,es/* palette */.DG)("white"), (0,es/* palette */.DG)("black"), themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD, (0,es/* palette */.DG)("black"), (0,es/* palette */.DG)("red"));
var ProductCartContainer = styled_components_browser_esm["default"].div(_templateObject4(), themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD);
var CardPopOver = function() {
    var ref = (0,context/* useProductCardContext */.I)(), setShowPopup = ref.setShowPopup, showPopup = ref.showPopup, product = ref.product;
    var drawerRef = (0,react.useRef)(null);
    (0,useClickAway/* default */.Z)(drawerRef, function() {
        setShowPopup(false);
    });
    if (!showPopup) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CartPopover, {
        open: showPopup,
        ref: drawerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartPopoverContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverBackgroundBlur, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PickerContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* CornerButton */.gm, {
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((CloseLineIcon_default()), {
                                size: 15
                            }),
                            onClick: function() {
                                return setShowPopup(false);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCartContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(products/* ProductCartPicker */.Iw, {
                                product: product,
                                drawer: true
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductCard/ProductCard.tsx












var ProductCard = function(param) {
    var render = param.render, slug = param.slug, selectedVariant = param.selectedVariant, selectedType = param.selectedType, injected = param.injected, shoppingList = param.shoppingList, shoppingListProductId = param.shoppingListProductId, shallow = param.shallow;
    var value = useProductValue({
        slug: slug,
        selectedType: selectedType,
        injected: injected,
        selectedVariant: selectedVariant,
        shoppingList: shoppingList,
        shoppingListProductId: shoppingListProductId,
        shallow: shallow
    });
    var components = (0,react.useMemo)(function() {
        var child = /*#__PURE__*/ (0,jsx_runtime.jsxs)(context/* ProductCardContext.Provider */.z.Provider, {
            value: value,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductCardContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardProductTags, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardProductUser, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitle, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardShop, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardPopOver, {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardProductModal, {})
            ]
        });
        if (render) {
            return render(child);
        }
        return child;
    }, [
        value,
        render
    ]);
    if (value == null) {
        // TODO: Add loader
        return null;
    }
    return components;
};


/***/ }),

/***/ 62341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ ProductCardContext; },
/* harmony export */   "I": function() { return /* binding */ useProductCardContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var ProductCardContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var useProductCardContext = function() {
    var data = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ProductCardContext);
    if (!data) {
        throw new Error("Only to use inside provider");
    }
    return data;
};


/***/ }),

/***/ 56603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* reexport safe */ _ProductCard__WEBPACK_IMPORTED_MODULE_0__.ProductCard; }
/* harmony export */ });
/* harmony import */ var _ProductCard__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80489);



/***/ }),

/***/ 18254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Oo": function() { return /* reexport */ Breadcrumbs; },
  "m": function() { return /* reexport */ ProductBadgeVariant; },
  "Il": function() { return /* reexport */ ProductCard/* ProductCard */.I; },
  "Iw": function() { return /* reexport */ ProductCartPicker; },
  "cF": function() { return /* reexport */ ProductMediaGallery; },
  "uE": function() { return /* reexport */ ProductStock; },
  "ch": function() { return /* reexport */ ProductTabs_ProductTabs; },
  "Sd": function() { return /* reexport */ ProductTag; },
  "S4": function() { return /* reexport */ ProductTagsWrapper; }
});

// UNUSED EXPORTS: Certifications, ProductLabelVariant, SecurityDocs

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/styled-tools/dist/es/index.js + 6 modules
var es = __webpack_require__(41145);
// EXTERNAL MODULE: ./src/components/common/Link.tsx
var Link = __webpack_require__(5695);
// EXTERNAL MODULE: ./src/components/typography/index.tsx + 1 modules
var typography = __webpack_require__(56795);
;// CONCATENATED MODULE: ./src/components/products/Breadcrumbs.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline;\n  font-weight: 600;\n  overflow: scroll;\n\n  &.current {\n    font-weight: 400;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0 8px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var Wrapper = styled_components_browser_esm["default"].div(_templateObject());
var BreadWrapper = styled_components_browser_esm["default"].div(_templateObject1());
var BreadLink = (0,styled_components_browser_esm["default"])(typography/* PSmall */.zK)(_templateObject2(), (0,es/* palette */.DG)("black60"));
var Seperator = styled_components_browser_esm["default"].span(_templateObject3());
function Breadcrumbs(param) {
    var breadcrumbs = param.breadcrumbs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: breadcrumbs.map(function(bread, i) {
            return !!bread.title && /*#__PURE__*/ (0,jsx_runtime.jsxs)(BreadWrapper, {
                children: [
                    !!i && /*#__PURE__*/ (0,jsx_runtime.jsx)(Seperator, {
                        children: "/"
                    }),
                    bread.href ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        href: bread.href,
                        shallow: bread.shallow,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadLink, {
                            className: classnames_default()({
                                current: i === breadcrumbs.length - 1
                            }),
                            children: bread.title
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadLink, {
                        className: classnames_default()({
                            current: i === breadcrumbs.length - 1
                        }),
                        children: bread.title
                    })
                ]
            }, bread.href);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductTabs/Certifications/styles.tsx
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  padding: 8px;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  margin-bottom: 16px;\n  align-items: center;\n  font-size: 1rem;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  margin-right: 6px;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  margin-left: 8px;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  margin-right: 12px;\n  position: relative;\n  overflow: hidden;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  opacity: 0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var styles_Wrapper = styled_components_browser_esm["default"].div(styles_templateObject());
var LabelWrapper = styled_components_browser_esm["default"].div(styles_templateObject1());
var CertTitle = styled_components_browser_esm["default"].div(styles_templateObject2(), (0,es/* palette */.DG)("black90"));
var CertText = styled_components_browser_esm["default"].div(styles_templateObject3(), (0,es/* palette */.DG)("black40"));
var CircleImage = styled_components_browser_esm["default"].div(_templateObject4(), (0,es/* palette */.DG)("black"), (0,es/* palette */.DG)("white"));
var NoImage = (0,styled_components_browser_esm["default"])(CircleImage)(_templateObject5());

// EXTERNAL MODULE: ./src/styles/imageStyles.ts
var imageStyles = __webpack_require__(42521);
// EXTERNAL MODULE: ./src/utils/removeNonAsciiCharacters.ts
var removeNonAsciiCharacters = __webpack_require__(7209);
;// CONCATENATED MODULE: ./src/components/products/ProductTabs/Certifications/EcoCertImage.tsx
function EcoCertImage_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function EcoCertImage_templateObject() {
    var data = EcoCertImage_taggedTemplateLiteral([
        "\n  object-fit: auto;\n  width: 40px;\n  height: auto;\n  &.image-astma-og-ofnmisvotta {\n    width: 35px;\n  }\n  &.image-endurunni-plast {\n    width: 35px;\n  }\n  &.image-verndum-regnskga {\n    width: 46px;\n  }\n  &.image-bioware {\n    width: 32px;\n  }\n  &.image-pefc {\n    width: 26px;\n  }\n  &.image-ecologo {\n    width: 25px;\n  }\n"
    ]);
    EcoCertImage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EcoCertImage_templateObject1() {
    var data = EcoCertImage_taggedTemplateLiteral([
        "\n  display: grid;\n  place-items: center;\n"
    ]);
    EcoCertImage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Image = styled_components_browser_esm["default"].img(EcoCertImage_templateObject());
var Container = (0,styled_components_browser_esm["default"])(imageStyles/* BackgroundImageContain */.r)(EcoCertImage_templateObject1());
var EcoCertImage = function(param) {
    var imageSrc = param.imageSrc, _alt = param.alt, alt = _alt === void 0 ? "" : _alt, slug = param.slug;
    if (imageSrc == null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoImage, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleImage, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                alt: alt,
                src: imageSrc,
                className: slug ? "image-".concat((0,removeNonAsciiCharacters/* removeNonAsciiCharacters */.H)(slug)) : undefined
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductTabs/Certifications/EcoCert.tsx



var EcoCert = function(param) {
    var title = param.title, imageSrc = param.imageSrc, slug = param.slug;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EcoCertImage, {
                imageSrc: imageSrc,
                alt: title,
                slug: slug
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CertTitle, {
                children: title
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductTabs/Certifications/EcoCerts.tsx



var EcoCerts = function() {
    var product = useProductTabContext().product;
    var value = product.ecoCerts;
    if (value == null) {
        return null;
    }
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: value.map(function(item) {
            var ref1;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(EcoCert, {
                slug: item.slug,
                title: item.name,
                imageSrc: (ref = (ref1 = item.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.url) !== null && ref !== void 0 ? ref : null
            }, item.id);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductTabs/Certifications/Certifications.tsx




function Certifications() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EcoCerts, {})
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductTabs/Certifications/index.ts


// EXTERNAL MODULE: ./node_modules/styled-bootstrap-grid/dist/index.js
var dist = __webpack_require__(54572);
// EXTERNAL MODULE: ./node_modules/remixicon-react/ArrowRightUpLineIcon.js
var ArrowRightUpLineIcon = __webpack_require__(28698);
var ArrowRightUpLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowRightUpLineIcon);
// EXTERNAL MODULE: ./src/themes/theme.ts
var theme = __webpack_require__(69431);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(8597);
;// CONCATENATED MODULE: ./src/components/products/ProductTabs/Docs/Docs.tsx
function Docs_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Docs_templateObject() {
    var data = Docs_taggedTemplateLiteral([
        "\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    Docs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Docs_templateObject1() {
    var data = Docs_taggedTemplateLiteral([
        "\n  width: 100%;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  margin-bottom: 8px;\n"
    ]);
    Docs_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Docs_templateObject2() {
    var data = Docs_taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    Docs_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Docs_templateObject3() {
    var data = Docs_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n\n  svg {\n    margin-left: 16px;\n  }\n"
    ]);
    Docs_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Docs_templateObject4() {
    var data = Docs_taggedTemplateLiteral([
        "\n  font-size: 1rem;\n  color: ",
        ";\n"
    ]);
    Docs_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Docs_templateObject5() {
    var data = Docs_taggedTemplateLiteral([
        "\n    display: block;\n    font-size: 0.875rem;\n    font-style: italic;\n    color: ",
        ";\n  "
    ]);
    Docs_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = Docs_taggedTemplateLiteral([
        "\n  display: none;\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}









var Docs_Wrapper = styled_components_browser_esm["default"].div(Docs_templateObject());
var Card = styled_components_browser_esm["default"].a(Docs_templateObject1(), (0,es/* palette */.DG)("white"), (0,es/* palette */.DG)("secondary"));
var ContentWrapper = styled_components_browser_esm["default"].div(Docs_templateObject2());
var FlexWrapper = styled_components_browser_esm["default"].div(Docs_templateObject3());
var CardTitle = styled_components_browser_esm["default"].div(Docs_templateObject4(), (0,es/* palette */.DG)("black90"));
var CardText = styled_components_browser_esm["default"].div(_templateObject6(), dist.media.sm(Docs_templateObject5(), (0,es/* palette */.DG)("black40")));
function Docs() {
    var product = useProductTabContext().product;
    var secDocs = product.infoDocs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Docs_Wrapper, {
        children: secDocs === null || secDocs === void 0 ? void 0 : secDocs.map(function(doc) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
                href: doc.url,
                target: "_blank",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardTitle, {
                            children: (0,strings/* removeFileExt */._h)(doc.name)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardText, {
                                    children: "Opna \xed n\xfdjum vafra"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightUpLineIcon_default()), {
                                    color: theme/* default.palette.primary */.Z.palette.primary,
                                    size: 20
                                })
                            ]
                        })
                    ]
                })
            }, doc.slug);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductTabs/Docs/index.ts


;// CONCATENATED MODULE: ./src/components/content/SaleorRichTextContent.tsx
function SaleorRichTextContent_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SaleorRichTextContent_templateObject() {
    var data = SaleorRichTextContent_taggedTemplateLiteral([
        "\n  p {\n    line-height: 1.8;\n    max-width: 60ch;\n  }\n"
    ]);
    SaleorRichTextContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var RichTextContainer = styled_components_browser_esm["default"].div(SaleorRichTextContent_templateObject());
function SaleorRichTextContent(param) {
    var jsonString = param.jsonString;
    var data = (0,react.useMemo)(function() {
        return {
            __html: jsonString
        };
    }, [
        jsonString
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextContainer, {
        dangerouslySetInnerHTML: data
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductTabs/ProductDescription/MiscInfoTags/MiscInfoTags.tsx
function MiscInfoTags_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function MiscInfoTags_templateObject() {
    var data = MiscInfoTags_taggedTemplateLiteral([
        "\n  margin: 16px 0;\n"
    ]);
    MiscInfoTags_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MiscInfoTags_templateObject1() {
    var data = MiscInfoTags_taggedTemplateLiteral([
        "\n  font-weight: bolder;\n  margin: 16px 0;\n"
    ]);
    MiscInfoTags_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var MiscInfoTags_Wrapper = styled_components_browser_esm["default"].div(MiscInfoTags_templateObject());
var Title = styled_components_browser_esm["default"].div(MiscInfoTags_templateObject1());
var MiscInfoTags = function() {
    var product = useProductTabContext().product;
    var value = product.miscTags.filter(function(v) {
        return v.thumbnail !== null;
    });
    if (value == null || value.length === 0) {
        return null;
    }
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiscInfoTags_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: "Merki"
            }),
            value.map(function(item) {
                var ref1;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(EcoCert, {
                    imageSrc: (ref = (ref1 = item.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.url) !== null && ref !== void 0 ? ref : null,
                    title: item.name,
                    slug: item.slug
                }, item.id);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductTabs/ProductDescription/ProductDescription.tsx




var ProductDescription = function() {
    var product = useProductTabContext().product;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SaleorRichTextContent, {
                jsonString: product.fullDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MiscInfoTags, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductTabs/ProductDescription/index.ts


;// CONCATENATED MODULE: ./src/components/products/ProductTabs/SecurityDocs/SecurityDocs.tsx
function SecurityDocs_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SecurityDocs_templateObject() {
    var data = SecurityDocs_taggedTemplateLiteral([
        "\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    SecurityDocs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SecurityDocs_templateObject1() {
    var data = SecurityDocs_taggedTemplateLiteral([
        "\n  width: 100%;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  margin-bottom: 8px;\n"
    ]);
    SecurityDocs_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SecurityDocs_templateObject2() {
    var data = SecurityDocs_taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    SecurityDocs_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SecurityDocs_templateObject3() {
    var data = SecurityDocs_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n\n  svg {\n    margin-left: 16px;\n  }\n"
    ]);
    SecurityDocs_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SecurityDocs_templateObject4() {
    var data = SecurityDocs_taggedTemplateLiteral([
        "\n  font-size: 1rem;\n  color: ",
        ";\n"
    ]);
    SecurityDocs_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SecurityDocs_templateObject5() {
    var data = SecurityDocs_taggedTemplateLiteral([
        "\n    display: block;\n    font-size: 0.875rem;\n    font-style: italic;\n    color: ",
        ";\n  "
    ]);
    SecurityDocs_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SecurityDocs_templateObject6() {
    var data = SecurityDocs_taggedTemplateLiteral([
        "\n  display: none;\n\n  ",
        "\n"
    ]);
    SecurityDocs_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}









var SecurityDocs_Wrapper = styled_components_browser_esm["default"].div(SecurityDocs_templateObject());
var SecurityDocs_Card = styled_components_browser_esm["default"].a(SecurityDocs_templateObject1(), (0,es/* palette */.DG)("white"), (0,es/* palette */.DG)("secondary"));
var SecurityDocs_ContentWrapper = styled_components_browser_esm["default"].div(SecurityDocs_templateObject2());
var SecurityDocs_FlexWrapper = styled_components_browser_esm["default"].div(SecurityDocs_templateObject3());
var SecurityDocs_CardTitle = styled_components_browser_esm["default"].div(SecurityDocs_templateObject4(), (0,es/* palette */.DG)("black90"));
var SecurityDocs_CardText = styled_components_browser_esm["default"].div(SecurityDocs_templateObject6(), dist.media.sm(SecurityDocs_templateObject5(), (0,es/* palette */.DG)("black40")));
function SecurityDocs() {
    var product = useProductTabContext().product;
    var secDocs = product.securityDocs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SecurityDocs_Wrapper, {
        children: secDocs === null || secDocs === void 0 ? void 0 : secDocs.map(function(doc) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SecurityDocs_Card, {
                href: doc.url,
                target: "_blank",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecurityDocs_ContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecurityDocs_CardTitle, {
                            children: (0,strings/* removeFileExt */._h)(doc.name)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecurityDocs_FlexWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecurityDocs_CardText, {
                                    children: "Opna \xed n\xfdjum vafra"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightUpLineIcon_default()), {
                                    color: theme/* default.palette.primary */.Z.palette.primary,
                                    size: 20
                                })
                            ]
                        })
                    ]
                })
            }, doc.slug);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductTabs/SecurityDocs/index.ts


;// CONCATENATED MODULE: ./src/components/products/ProductTabs/ProductTabContext.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}






var ProductDescriptionLabel = "L\xfdsing";
var SecurityDocsLabel = "\xd6ryggisskj\xf6l";
var CertificationsLabel = "Vottanir";
var DocsLabel = "Uppl\xfdsingar";
var ProductTabLabels = [
    ProductDescriptionLabel,
    SecurityDocsLabel,
    CertificationsLabel,
    DocsLabel, 
];
var _obj;
var ProductTabComponents = (_obj = {}, _defineProperty(_obj, ProductDescriptionLabel, ProductDescription), _defineProperty(_obj, SecurityDocsLabel, SecurityDocs), _defineProperty(_obj, CertificationsLabel, Certifications), _defineProperty(_obj, DocsLabel, Docs), _obj);
var _obj1;
var ProductTabComponentsIsVisible = (_obj1 = {}, _defineProperty(_obj1, ProductDescriptionLabel, function() {
    return true;
}), _defineProperty(_obj1, SecurityDocsLabel, function(product) {
    return !!product.securityDocs.length;
}), _defineProperty(_obj1, CertificationsLabel, function(product) {
    return !!product.ecoCerts.length;
}), _defineProperty(_obj1, DocsLabel, function(product) {
    return !!product.infoDocs.length;
}), _obj1);
var ProviderContext = /*#__PURE__*/ (0,react.createContext)(null);
var useProductTabContext = function() {
    var value = (0,react.useContext)(ProviderContext);
    if (value == null) {
        throw new Error("Invalid usage");
    }
    return value;
};
var ProductTabContextProvider = function(param) {
    var children = param.children, product = param.product;
    var ref = (0,react.useState)(ProductTabLabels[0]), activeTab = ref[0], setActiveTab = ref[1];
    // This never changes, since the array is a const that should never change.
    var tabs = ProductTabLabels.map(function(key) {
        return {
            label: key,
            Component: ProductTabComponents[key],
            visible: ProductTabComponentsIsVisible[key](product)
        };
    });
    var value = {
        tabs: tabs,
        product: product,
        setActiveTab: setActiveTab,
        activeTab: activeTab
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderContext.Provider, {
        value: value,
        children: children
    });
};

// EXTERNAL MODULE: ./src/themes/index.tsx
var themes = __webpack_require__(52287);
;// CONCATENATED MODULE: ./src/components/products/ProductTabs/ProductTabContent.tsx
function ProductTabContent_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProductTabContent_templateObject() {
    var data = ProductTabContent_taggedTemplateLiteral([
        ""
    ]);
    ProductTabContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductTabContent_templateObject1() {
    var data = ProductTabContent_taggedTemplateLiteral([
        "\n  position: relative;\n  font-size: 1rem;\n  font-weight: 500;\n  text-align: center;\n  padding: 8px;\n  color: ",
        ";\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n  transition: color 0.15s;\n  cursor: pointer;\n  @media (max-width: ",
        ") {\n    padding: 8px 4px;\n    margin-right: 10px;\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: -3px;\n    display: block;\n    width: 100%;\n    height: 5px;\n    opacity: 0;\n    transition: opacity 0.2s;\n    background-color: ",
        ";\n  }\n\n  &.isActive {\n    font-weight: bold;\n\n    &:after {\n      opacity: 1;\n    }\n  }\n\n  &:hover {\n    &:after {\n      opacity: 1 !important;\n    }\n  }\n\n  @media (min-width: ",
        ") {\n    &:not(:last-child) {\n      margin-right: 40px;\n    }\n  }\n"
    ]);
    ProductTabContent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductTabContent_templateObject2() {
    var data = ProductTabContent_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-start;\n  width: 100%;\n  margin-bottom: 20px;\n  border-bottom: 1px solid ",
        ";\n\n  &:hover {\n    & ",
        ".isActive:after {\n      opacity: 0;\n    }\n  }\n"
    ]);
    ProductTabContent_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductTabContent_templateObject3() {
    var data = ProductTabContent_taggedTemplateLiteral([
        "\n  display: none;\n  color: ",
        ";\n\n  &.isActive {\n    display: block;\n    heigth: 'fit-content';\n  }\n"
    ]);
    ProductTabContent_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

/* eslint-disable react/no-array-index-key */ 






var ProductTabContent_Wrapper = styled_components_browser_esm["default"].div(ProductTabContent_templateObject());
var Tab = styled_components_browser_esm["default"].button(ProductTabContent_templateObject1(), (0,es/* palette */.DG)("black"), themes/* theme.screenSize.sizeSM */.r.screenSize.sizeSM, (0,es/* palette */.DG)("primary"), themes/* theme.screenSize.sizeSM */.r.screenSize.sizeSM);
var TabsWrapper = styled_components_browser_esm["default"].div(ProductTabContent_templateObject2(), (0,es/* palette */.DG)("black"), Tab);
var TabContent = (0,styled_components_browser_esm["default"])(typography.P)(ProductTabContent_templateObject3(), (0,es/* palette */.DG)("black"));
function ProductTabs() {
    var ref = useProductTabContext(), activeTab = ref.activeTab, setActiveTab = ref.setActiveTab, tabs = ref.tabs;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductTabContent_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsWrapper, {
                children: tabs.filter(function(value) {
                    return value.visible;
                }).map(function(param) {
                    var label = param.label;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab, {
                        className: classnames_default()({
                            isActive: activeTab === label
                        }),
                        onClick: function() {
                            return setActiveTab(label);
                        },
                        children: label
                    }, label);
                })
            }),
            tabs.map(function(param) {
                var label = param.label, Component = param.Component;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabContent, {
                    className: classnames_default()({
                        isActive: activeTab === label
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {})
                }, label);
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductTabs/ProductTabs.tsx



function ProductTabs_ProductTabs(param) {
    var product = param.product;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTabContextProvider, {
        product: product,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTabs, {})
    });
}

;// CONCATENATED MODULE: ./src/components/products/ProductTabs/index.ts


// EXTERNAL MODULE: ./node_modules/remixicon-react/CheckLineIcon.js
var CheckLineIcon = __webpack_require__(19226);
var CheckLineIcon_default = /*#__PURE__*/__webpack_require__.n(CheckLineIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/CloseLineIcon.js
var CloseLineIcon = __webpack_require__(46550);
var CloseLineIcon_default = /*#__PURE__*/__webpack_require__.n(CloseLineIcon);
;// CONCATENATED MODULE: ./src/components/products/ProductStock.tsx
function ProductStock_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProductStock_templateObject() {
    var data = ProductStock_taggedTemplateLiteral([
        "\n  display: block;\n"
    ]);
    ProductStock_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductStock_templateObject1() {
    var data = ProductStock_taggedTemplateLiteral([
        "\n  padding-bottom: 10px;\n  margin-bottom: 20px;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    ProductStock_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductStock_templateObject2() {
    var data = ProductStock_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding-bottom: 5px;\n"
    ]);
    ProductStock_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductStock_templateObject3() {
    var data = ProductStock_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  padding-left: 6px;\n"
    ]);
    ProductStock_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var ProductStock_Wrapper = styled_components_browser_esm["default"].div(ProductStock_templateObject());
var TitleWrapper = styled_components_browser_esm["default"].div(ProductStock_templateObject1(), (0,es/* palette */.DG)("black"));
var StockItem = styled_components_browser_esm["default"].div(ProductStock_templateObject2());
var StockStatus = styled_components_browser_esm["default"].div(ProductStock_templateObject3(), (0,es/* palette */.DG)("black"));
function ProductStock(param) {
    var isAvailable = param.isAvailable;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductStock_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title6 */.L8, {
                    children: "Lagersta\xf0a"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StockItem, {
                children: isAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((CheckLineIcon_default()), {
                            color: themes/* theme.palette.success */.r.palette.success
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StockStatus, {
                            children: "Til \xe1 lager"
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((CloseLineIcon_default()), {
                            color: themes/* theme.palette.error */.r.palette.error
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StockStatus, {
                            children: "Uppselt"
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/styles/shadowStyles.ts
var shadowStyles = __webpack_require__(23633);
;// CONCATENATED MODULE: ./src/components/products/ProductTag.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function ProductTag_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function ProductTag_templateObject() {
    var data = ProductTag_taggedTemplateLiteral([
        "\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n  padding: 8px;\n  margin-left: 8px;\n  ",
        "\n"
    ]);
    ProductTag_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ProductBadgeVariant;
(function(ProductBadgeVariant) {
    ProductBadgeVariant["OutOfStock"] = "outOfStock";
    ProductBadgeVariant["ComingSoon"] = "v\xe6ntanlegt";
    ProductBadgeVariant["NewProduct"] = "n\xfd-vara";
    ProductBadgeVariant["Recommended"] = "rv-m\xe6lir-me\xf0";
    ProductBadgeVariant["Discount"] = "discount";
    ProductBadgeVariant["OnSaleStock"] = "lagerhreinsun";
    ProductBadgeVariant["SpecialOffer"] = "tilbo\xf0";
})(ProductBadgeVariant || (ProductBadgeVariant = {}));
var ProductLabelVariant;
(function(ProductLabelVariant) {
    ProductLabelVariant["EcoLabel"] = "umhverfisvottu\xf0-vara";
    ProductLabelVariant["NordicSwan"] = "svansmerkt";
})(ProductLabelVariant || (ProductLabelVariant = {}));
var _color;
var ProductTagBox = styled_components_browser_esm["default"].div(ProductTag_templateObject(), function(p) {
    return p.color ? (0,es/* palette */.DG)(p.color) : "inherit";
}, (0,es/* palette */.DG)("white"), (0,es/* palette */.DG)("secondary"), function(p) {
    return (0,shadowStyles/* default */.ZP)({
        color: (_color = p.color) !== null && _color !== void 0 ? _color : "inherit",
        outlined: false,
        length: 4,
        showOnHover: false
    });
});
var badgeVariantMap = {
    outOfStock: [
        "Vara uppseld",
        "black20"
    ],
    væntanlegt: [
        "Vara v\xe6ntanleg",
        "black20"
    ],
    "n\xfd-vara": [
        "N\xfd vara",
        "green"
    ],
    "rv-m\xe6lir-me\xf0": [
        "RV m\xe6lir me\xf0",
        "primary"
    ],
    discount: [
        "",
        "green"
    ],
    lagerhreinsun: [
        "Lagerhreinsun",
        "yellow"
    ],
    tilboð: [
        "Tilbo\xf0",
        "green"
    ]
};
var labelVariantMap = {
    sérpöntun: [
        "S\xe9rp\xf6ntun",
        "primary"
    ],
    lagerhreinsun: [
        "Lagerhreinsun",
        "yellow"
    ],
    tilboð: [
        "Tilbo\xf0",
        "green"
    ],
    sjúkratryggingar: [
        "Sj\xfakratryggingar",
        "blue"
    ],
    sjúkratrygginar: [
        "Sj\xfakratrygginar",
        "blue"
    ]
};
function Badges(param) {
    var badgeVariant = param.badgeVariant, title = param.title;
    if (badgeVariant == null) {
        return null;
    }
    var _badgeVariant = _slicedToArray(badgeVariantMap[badgeVariant], 2), badgeTitle = _badgeVariant[0], badgeColor = _badgeVariant[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTagBox, {
        color: badgeColor,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H6, {
            children: badgeTitle || title
        })
    });
}
function Labels(param) {
    var labelVariant = param.labelVariant, labelImage = param.labelImage, title = param.title, slug = param.slug;
    if (labelVariant == null) {
        return null;
    }
    if (!labelImage) {
        var labelTitle = "";
        var labelColor = "";
        if (labelVariantMap[labelVariant]) {
            var ref;
            ref = _slicedToArray(labelVariantMap[labelVariant], 2), labelTitle = ref[0], labelColor = ref[1], ref;
        } else {
            labelTitle = labelVariant;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTagBox, {
            color: labelColor,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H6, {
                children: labelTitle || title
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EcoCertImage, {
        imageSrc: labelImage,
        slug: slug
    });
}
function ProductTag(param) {
    var badgeVariant = param.badgeVariant, labelVariant = param.labelVariant, labelImage = param.labelImage, slug = param.slug, _title = param.title, title = _title === void 0 ? "" : _title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Badges, {
                badgeVariant: badgeVariant,
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels, {
                labelVariant: labelVariant,
                labelImage: labelImage,
                title: title,
                slug: slug
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 120 modules
var formik_esm = __webpack_require__(59433);
// EXTERNAL MODULE: ./src/components/form/Input.tsx
var Input = __webpack_require__(92469);
// EXTERNAL MODULE: ./src/components/buttons/index.tsx + 6 modules
var buttons = __webpack_require__(31494);
;// CONCATENATED MODULE: ./src/components/products/ProductCartPicker/context.ts

var ProductCartPickerContext = (0,react.createContext)(null);
var useProductCartPickerContext = function() {
    var data = (0,react.useContext)(ProductCartPickerContext);
    if (data == null) {
        throw new Error("invalid usage of context");
    }
    return data;
};

// EXTERNAL MODULE: ./src/components/products/ProductCartPicker/interfaces.ts
var interfaces = __webpack_require__(64474);
// EXTERNAL MODULE: ./src/context/CheckoutContext/index.tsx + 15 modules
var CheckoutContext = __webpack_require__(86771);
;// CONCATENATED MODULE: ./src/components/products/ProductCartPicker/hooks/useQtyInCart.tsx

var useQtyInCart = function(param) {
    var product = param.product;
    var ref;
    var checkout = (0,CheckoutContext/* useCheckout */.Mg)().checkout;
    var id = checkout === null || checkout === void 0 ? void 0 : (ref = checkout.lines) === null || ref === void 0 ? void 0 : ref.find(function(line) {
        return (line === null || line === void 0 ? void 0 : line.variant.sku) === product.sku;
    });
    var ref1;
    return (ref1 = id === null || id === void 0 ? void 0 : id.quantity) !== null && ref1 !== void 0 ? ref1 : 0;
};

;// CONCATENATED MODULE: ./src/components/products/ProductCartPicker/hooks/useCartPickerValue.ts



var useCartPickerValue = function(param) {
    var product = param.product;
    var ref5;
    var qtyInCart = useQtyInCart({
        product: product
    });
    var ref1;
    var ref2 = (0,react.useState)((ref1 = (ref5 = product.defaultUnitType) === null || ref5 === void 0 ? void 0 : ref5.name) !== null && ref1 !== void 0 ? ref1 : interfaces/* ProductTypePiece */.Ji), type = ref2[0], setType = ref2[1];
    var ref3 = (0,react.useState)(1), currentQuantity = ref3[0], setCurrentQuantity = ref3[1];
    (0,react.useEffect)(function() {
        var ref;
        var ref4;
        var typeVal = (ref4 = (ref = product.defaultUnitType) === null || ref === void 0 ? void 0 : ref.name) !== null && ref4 !== void 0 ? ref4 : interfaces/* ProductTypePiece */.Ji;
        setType(typeVal);
        var currentItem = product.unitTypes.find(function(unitType) {
            return unitType.name === typeVal;
        });
        if (!currentItem) {
            throw new Error("Invalid type");
        }
        setCurrentQuantity(1);
    }, [
        product.defaultUnitType,
        product.unitTypes
    ]);
    return (0,react.useMemo)(function() {
        return {
            currentQuantity: currentQuantity,
            setCurrentQuantity: setCurrentQuantity,
            type: type,
            setType: setType,
            qtyInCart: qtyInCart,
            product: product
        };
    }, [
        currentQuantity,
        product,
        qtyInCart,
        type
    ]);
};

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/icelandicQuantity.ts
var icelandicQuantity = __webpack_require__(90844);
// EXTERNAL MODULE: ./src/components/form/QtyPicker.tsx
var QtyPicker = __webpack_require__(39701);
// EXTERNAL MODULE: ./src/components/products/ProductCard/context.ts
var context = __webpack_require__(62341);
;// CONCATENATED MODULE: ./src/components/products/ProductCartPicker/ProductCartAdd.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ProductCartAdd_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductCartAdd_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function ProductCartAdd_templateObject() {
    var data = ProductCartAdd_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-bottom: 16px;\n\n  ",
        " {\n    margin-left: 16px;\n  }\n"
    ]);
    ProductCartAdd_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var QtyWrapper = styled_components_browser_esm["default"].div(ProductCartAdd_templateObject(), typography.P);
var ProductCartAdd = function() {
    var ref = useProductCartPickerContext(), currentQuantity = ref.currentQuantity, setCurrentQuantity = ref.setCurrentQuantity, qtyInCart = ref.qtyInCart, type = ref.type, product = ref.product;
    var isAvailable = product;
    var productContext = (0,react.useContext)(context/* ProductCardContext */.z);
    var cartUpdate = (0,CheckoutContext/* useCheckout */.Mg)().cartUpdate;
    var cartIsUpdating = (0,CheckoutContext/* useIsCheckoutLoading */.uT)();
    var checkoutLoading = (0,CheckoutContext/* useIsInitialLoad */.QH)();
    var currentItem = (0,react.useMemo)(function() {
        var item = product.unitTypes.find(function(unitType) {
            return unitType.name === type;
        });
        if (!item) {
            var _type = type === "STK" ? "KS" : "STK";
            item = product.unitTypes.find(function(unitType) {
                return unitType.name === _type;
            });
            if (!item) {
                throw new Error("Invalid type");
            }
        }
        return item;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        product.name,
        product.unitTypes,
        type
    ]);
    var itemQuantity = (0,react.useMemo)(function() {
        return currentItem.quantityPerUnit * currentQuantity + qtyInCart;
    }, [
        currentItem.quantityPerUnit,
        currentQuantity,
        qtyInCart
    ]);
    var addToCart = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (product.variantId) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    _ctx.next = 4;
                    return cartUpdate(ProductCartAdd_defineProperty({}, product.variantId, itemQuantity));
                case 4:
                    if (productContext && productContext.setShowPopup) {
                        productContext.setShowPopup(false);
                    }
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        cartUpdate,
        itemQuantity,
        product.variantId,
        productContext
    ]);
    var name = (0,react.useMemo)(function() {
        return (0,icelandicQuantity/* getPluralOrSingular */.e)({
            singular: currentItem.displayNameSingular,
            plural: currentItem.displayNamePlural,
            value: currentQuantity,
            showQuantity: false
        });
    }, [
        currentItem.displayNamePlural,
        currentItem.displayNameSingular,
        currentQuantity, 
    ]);
    var handleChange = (0,react.useCallback)(function(value) {
        setCurrentQuantity(value);
        return false;
    }, [
        setCurrentQuantity
    ]);
    var specialOrder = product.labels.some(function(s) {
        return s.name === "S\xe9rp\xf6ntun";
    });
    var cartButtonText = "Setja \xed k\xf6rfu";
    if (!isAvailable) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !specialOrder && /*#__PURE__*/ (0,jsx_runtime.jsxs)(QtyWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QtyPicker/* default */.Z, {
                        qty: currentQuantity,
                        onUpdate: handleChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* CartButton */.WE, {
                color: "red",
                fill: true,
                onClick: addToCart,
                loading: cartIsUpdating,
                disabled: checkoutLoading,
                children: cartButtonText
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/form/index.tsx + 3 modules
var components_form = __webpack_require__(27618);
;// CONCATENATED MODULE: ./src/components/products/ProductCartPicker/ProductCartObject.tsx




var ProductCartObject = function(param) {
    var item = param.item;
    var ref = useProductCartPickerContext(), type = ref.type, setType = ref.setType, _product = ref.product, slug = _product.slug, isAvailable = _product.isAvailable, pricing = _product.pricing;
    var pricingItem = pricing === null || pricing === void 0 ? void 0 : pricing.find(function(value) {
        return value.unitType === item.name;
    });
    var handleChange = (0,react.useCallback)(function() {
        setType(item.name);
    }, [
        item.name,
        setType
    ]);
    if (!pricingItem) {
        return null;
    }
    var _discountFormatted;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_form/* RadioField */.gu, {
        onChange: handleChange,
        "aria-checked": type === item.name,
        checked: type === item.name,
        label: item.displayNameSingular,
        name: slug,
        value: item.name,
        color: "primary",
        numberOfUnits: item.quantityPerUnit > 1 ? item.quantityPerUnit : undefined,
        originalPrice: pricingItem.grossOriginalPriceFormatted,
        price: pricingItem.grossFormatted,
        unitPrice: "".concat(pricingItem.grossUnitPriceFormatted, "/stk."),
        discount: (_discountFormatted = pricingItem.discountFormatted) !== null && _discountFormatted !== void 0 ? _discountFormatted : undefined,
        withGutter: true,
        disabled: !isAvailable
    });
};

// EXTERNAL MODULE: ./node_modules/react-use/esm/useWindowSize.js + 3 modules
var useWindowSize = __webpack_require__(72977);
;// CONCATENATED MODULE: ./src/components/products/ProductCartPicker/ProductCartOfferingPieceOrBox.tsx
function ProductCartOfferingPieceOrBox_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProductCartOfferingPieceOrBox_templateObject() {
    var data = ProductCartOfferingPieceOrBox_taggedTemplateLiteral([
        "\n  &::first-letter {\n    text-transform: capitalize;\n  }\n"
    ]);
    ProductCartOfferingPieceOrBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductCartOfferingPieceOrBox_templateObject1() {
    var data = ProductCartOfferingPieceOrBox_taggedTemplateLiteral([
        "\n  margin-top: 48px;\n"
    ]);
    ProductCartOfferingPieceOrBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var Sentance = (0,styled_components_browser_esm["default"])(typography.P)(ProductCartOfferingPieceOrBox_templateObject());
var Spacer = styled_components_browser_esm["default"].div(ProductCartOfferingPieceOrBox_templateObject1());
var ProductCartOfferingPieceOrBox = function() {
    var product = useProductCartPickerContext().product;
    var width = (0,useWindowSize/* default */.Z)().width;
    if (!product.offerString) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Spacer, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Sentance, {
        withGutter: true,
        color: !product.isAvailable ? "black40" : undefined,
        children: [
            width > themes/* gridTheme.breakpoints.sm */.k.breakpoints.sm ? "M\xe1 bj\xf3\xf0a \xfe\xe9r " : null,
            product.offerString,
            "?"
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductCartPicker/ProductCartPicker.tsx
function ProductCartPicker_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProductCartPicker_templateObject() {
    var data = ProductCartPicker_taggedTemplateLiteral([
        ""
    ]);
    ProductCartPicker_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductCartPicker_templateObject1() {
    var data = ProductCartPicker_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  max-width: 400px;\n  .form-header {\n    font-weight: bold;\n    line-height: 1.5;\n    font-size: 18px;\n    margin-right: 25px;\n    margin-bottom: 5px;\n  }\n  .text-area {\n    min-height: 60px;\n    margin-bottom: 10px;\n  }\n  div {\n    margin: 0px;\n  }\n\n  @media (max-width: ",
        ") {\n    input {\n      font-weight: 400;\n    }\n  }\n"
    ]);
    ProductCartPicker_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProductCartPicker_templateObject2() {
    var data = ProductCartPicker_taggedTemplateLiteral([
        "\n  margin-top: 40px;\n  padding: 10px;\n  line-height: 25px;\n  border: 1px solid ",
        ";\n  .success_text {\n    font-weight: 800;\n  }\n"
    ]);
    ProductCartPicker_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProductCartPicker_templateObject3() {
    var data = ProductCartPicker_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-weight: 800;\n  font-size: 12px;\n  position: absolute;\n  bottom: 5px;\n  left: 0px;\n"
    ]);
    ProductCartPicker_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProductCartPicker_templateObject4() {
    var data = ProductCartPicker_taggedTemplateLiteral([
        "\n  position: relative;\n  input {\n    margin-top: 0px;\n    margin-bottom: 20px;\n    font-size: ",
        ";\n    line-height: ",
        ";\n    padding: ",
        ";\n    height: auto;\n  }\n  .text-area {\n    height: 60px;\n    margin-bottom: 20px;\n  }\n  .text-area + p {\n    position: absolute;\n    bottom: 20px;\n  }\n\n  @media (max-width: ",
        ") {\n    input {\n      font-weight: 400;\n    }\n  }\n"
    ]);
    ProductCartPicker_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

/* eslint-disable no-console */ 












var numberRegExp = /\d+/;
var FormContainer = styled_components_browser_esm["default"].div(ProductCartPicker_templateObject());
var Form = styled_components_browser_esm["default"].form(ProductCartPicker_templateObject1(), themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD);
var SuccessBox = styled_components_browser_esm["default"].div(ProductCartPicker_templateObject2(), (0,es/* palette */.DG)("red"));
var ErrorText = styled_components_browser_esm["default"].p(ProductCartPicker_templateObject3(), (0,es/* palette */.DG)("red"));
var InputContainer = styled_components_browser_esm["default"].div(ProductCartPicker_templateObject4(), function(param) {
    var drawer = param.drawer;
    return drawer ? "14px" : "16px";
}, function(param) {
    var drawer = param.drawer;
    return drawer ? "20px" : "22px";
}, function(param) {
    var drawer = param.drawer;
    return drawer ? "6px 10px" : "10px";
}, themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD);
var ProductRequestForm = function(param) {
    var product = param.product, drawer = param.drawer;
    var ref10 = (0,react.useState)(true), showForm = ref10[0], setShowForm = ref10[1];
    var ref1 = (0,react.useState)(false), disableButton = ref1[0], setDisableButton = ref1[1];
    // eslint-disable-next-line unused-imports/no-unused-vars
    var ref2 = (0,react.useState)(""), error = ref2[0], setError = ref2[1];
    var ref3 = (0,react.useState)(""), nameError = ref3[0], setNameError = ref3[1];
    var ref4 = (0,react.useState)(""), emailError = ref4[0], setEmailError = ref4[1];
    var ref5 = (0,react.useState)(""), phoneError = ref5[0], setPhoneError = ref5[1];
    var ref6 = (0,react.useState)(""), postError = ref6[0], setPostError = ref6[1];
    var ref7 = (0,react.useState)(""), messageError = ref7[0], setMessageError = ref7[1];
    var ref8 = (0,react.useState)(""), employeeError = ref8[0], setEmployeeError = ref8[1];
    var ref9 = (0,react.useState)(""), companyNameError = ref9[0], setCompanyNameError = ref9[1];
    var initialValues = {
        name: "",
        email: "",
        message: "",
        companyName: "",
        phone: "",
        post: "",
        employees: ""
    };
    var submitForm = function(values) {
        var ref;
        if (!values.name) {
            setError("Sl\xe1\xf0u inn gilt nafn");
            setNameError("Sl\xe1\xf0u inn gilt nafn");
        } else {
            setError("");
            setNameError("");
        }
        if (!values.companyName) {
            setError("Sl\xe1\xf0u inn gilt nafn fyrirt\xe6kis/stofnunar");
            setCompanyNameError("Sl\xe1\xf0u inn gilt nafn fyrirt\xe6kis/stofnunar");
        } else {
            setError("");
            setCompanyNameError("");
        }
        if (!values.message) {
            setError("Sl\xe1\xf0u inn gilt fyrirspurn");
            setMessageError("Sl\xe1\xf0u inn gilt fyrirspurn");
        } else {
            setError("");
            setMessageError("");
        }
        if (!values.email || !strings/* emailRegExp.test */.LD.test(values.email)) {
            setError("Sl\xe1\xf0u inn gilt netfang");
            setEmailError("Sl\xe1\xf0u inn gilt netfang");
        } else {
            setError("");
            setEmailError("");
        }
        if (!strings/* phoneRegExp.test */.Oj.test(values.phone)) {
            setError("Sl\xe1\xf0u inn gilt s\xedman\xfamer");
            setPhoneError("Sl\xe1\xf0u inn gilt s\xedman\xfamer");
        } else {
            setError("");
            setPhoneError("");
        }
        if (!numberRegExp.test(values.employees)) {
            setError("Sl\xe1\xf0u inn gilt starfsmannafj\xf6ldi");
            setEmployeeError("Sl\xe1\xf0u inn gilt starfsmannafj\xf6ldi");
        } else {
            setError("");
            setEmployeeError("");
        }
        if (!strings/* postRegExp.test */.Gp.test(values.post)) {
            setError("Sl\xe1\xf0u inn gilt p\xf3stn\xfamer");
            setPostError("Sl\xe1\xf0u inn gilt p\xf3stn\xfamer");
        } else {
            setError("");
            setPostError("");
        }
        if (!values.name || !strings/* phoneRegExp.test */.Oj.test(values.phone) || !values.email || !strings/* emailRegExp.test */.LD.test(values.email) || !strings/* postRegExp.test */.Gp.test(values.post) || !values.message || !values.companyName || !numberRegExp.test(values.employees)) return;
        setDisableButton(false);
        var url = (ref = product.thumbnail) === null || ref === void 0 ? void 0 : ref.url.split("/media/");
        var convertMedia = (url === null || url === void 0 ? void 0 : url.length) ? "".concat("https://rv-backend.8h.roanuz.com", "/media/").concat(url[1]) : "";
        var Inputdata = {
            userName: values.name,
            userEmail: values.email,
            message: values.message,
            comapanyName: values.companyName,
            phone: values.phone,
            post: values.post,
            employees: values.employees,
            ProductInfo: {
                productId: product.id,
                productSlug: product.slug,
                category: product.categoryName,
                productName: product.name,
                image: convertMedia
            }
        };
        var kaffi_skus = [
            "ZIA8124A",
            "NIO202",
            "30001",
            "30500",
            "25001",
            "101.G",
            "ZIA8224AL", 
        ];
        var data = {
            receiver_email: (product === null || product === void 0 ? void 0 : product.sku) && kaffi_skus.includes(product.sku) ? "kaffi@rv.is" : "",
            event_name: "Notify special order",
            event_data: Inputdata
        };
        fetch("".concat("https://rv-backend.8h.roanuz.com", "/api-klavio/"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                accept: "application/json"
            },
            body: JSON.stringify(data)
        }).then(function(resp) {
            if (resp && resp.status === 200) {
                setShowForm(false);
            }
            if (resp && resp.type === "error") {
                setDisableButton(false);
                setError("Gat ekki sent t\xf6lvup\xf3st, Vinsamlegast reyndu aftur!");
                console.log("error", {
                    resp: resp
                });
            }
        }).catch(function(err) {
            setDisableButton(false);
            setError("Gat ekki sent t\xf6lvup\xf3st, Vinsamlegast reyndu aftur!");
            console.log("error", err);
        });
    };
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: initialValues,
        validateOnChange: false,
        onSubmit: function(values) {
            return submitForm(values);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormContainer, {
        children: showForm ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form, {
            onSubmit: formik.handleSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "form-header",
                    children: "Fyrirspurn um ver\xf0"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputContainer, {
                    drawer: drawer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.II, {
                            placeholder: "Nafn",
                            name: "name",
                            type: "text",
                            onChange: formik.handleChange,
                            showError: !!formik.errors.name,
                            errorMsg: nameError
                        }),
                        nameError && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
                            children: nameError
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputContainer, {
                    drawer: drawer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.II, {
                            placeholder: "Nafn Fyrirt\xe6kis/Stofnunar",
                            type: "text",
                            name: "companyName",
                            onChange: formik.handleChange
                        }),
                        companyNameError && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
                            children: companyNameError
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputContainer, {
                    drawer: drawer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.II, {
                            placeholder: "P\xf3stn\xfamer",
                            name: "post",
                            type: "text",
                            onChange: formik.handleChange,
                            showError: !!formik.errors.post,
                            errorMsg: postError
                        }),
                        postError && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
                            children: postError
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputContainer, {
                    drawer: drawer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.II, {
                            placeholder: "Netfang",
                            name: "email",
                            type: "email",
                            onChange: formik.handleChange,
                            showError: !!formik.errors.email,
                            errorMsg: emailError
                        }),
                        emailError && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
                            children: emailError
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputContainer, {
                    drawer: drawer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.II, {
                            placeholder: "Starfsmannafj\xf6ldi",
                            type: "text",
                            name: "employees",
                            onChange: formik.handleChange
                        }),
                        employeeError && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
                            children: employeeError
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputContainer, {
                    drawer: drawer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.II, {
                            placeholder: "S\xedman\xfamer",
                            type: "text",
                            name: "phone",
                            onChange: formik.handleChange,
                            showError: !!formik.errors.phone,
                            errorMsg: phoneError
                        }),
                        phoneError && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
                            children: phoneError
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputContainer, {
                    drawer: drawer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.II, {
                            placeholder: "Fyrirspurn",
                            type: "textarea",
                            className: "text-area",
                            name: "message",
                            onChange: formik.handleChange
                        }),
                        messageError && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
                            children: messageError
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                    fill: true,
                    withGutter: true,
                    disabled: disableButton,
                    type: "submit",
                    children: "Senda"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessBox, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "success_text",
                children: "T\xf6lvup\xf3stur hefur veri\xf0 sendur. Li\xf0 okkar mun hafa samband vi\xf0 \xfeig flj\xf3tlega."
            })
        })
    });
};
var ProductCartPicker = function(param) {
    var product = param.product, drawer = param.drawer;
    var value = useCartPickerValue({
        product: product
    });
    if (product.pricing == null || product.pricing.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCartPickerContext.Provider, {
        value: value,
        children: product.hidePrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductRequestForm, {
            product: product,
            drawer: drawer
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCartOfferingPieceOrBox, {}),
                        value.product.unitTypes.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCartObject, {
                                item: item
                            }, item.id);
                        })
                    ]
                }),
                value.product.isAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCartAdd, {})
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductCartPicker/index.ts


// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./src/components/layout/index.ts + 8 modules
var layout = __webpack_require__(49012);
// EXTERNAL MODULE: ./src/components/common/index.tsx + 15 modules
var common = __webpack_require__(69446);
;// CONCATENATED MODULE: ./src/components/products/styles.tsx
function products_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function products_styles_templateObject() {
    var data = products_styles_taggedTemplateLiteral([
        ""
    ]);
    products_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function products_styles_templateObject1() {
    var data = products_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  @media (max-width: ",
        ") {\n    justify-content: center;\n  }\n"
    ]);
    products_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function products_styles_templateObject2() {
    var data = products_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  margin-right: 16px;\n  gap: 20px;\n  height: 100%;\n  width: 100px;\n\n  .slick-track {\n    height: auto !important;\n  }\n  @media (max-width: ",
        ") {\n    display: none;\n  } ;\n"
    ]);
    products_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function products_styles_templateObject3() {
    var data = products_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 96%;\n  height: 80px;\n  padding: 0 8px;\n  margin: 0 4px 4px;\n  border: 1px solid\n    ",
        ";\n  transition: border-color 0.15s;\n  background-color: ",
        ";\n  cursor: pointer;\n\n  ",
        "\n\n  &:focus {\n    outline: none !important;\n  }\n  @media (max-width: ",
        ") {\n    display: none;\n  } ;\n"
    ]);
    products_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = products_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: auto;\n  display: flex;\n  justify-content: center;\n  &:before {\n    content: '';\n    display: block;\n    padding-bottom: 100%;\n  }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = products_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: calc(100% - 120px);\n  width: 100%;\n  max-width: 320px;\n  min-height: 400px;\n  padding: 20px 0;\n  margin: 0 auto;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  @media (max-width: ",
        ") {\n    min-height: 200px;\n  }\n  .main-slider {\n    max-width: 320px;\n    min-width: calc(90%);\n    width: 90% !important;\n    height: 200px;\n    margin: auto;\n    @media (min-width: ",
        ") {\n      height: 100% !important;\n    }\n    @media (max-width: ",
        ") {\n      min-width: calc(100% - 20px);\n    }\n  }\n\n  .slick-list {\n    height: 100% !important;\n  }\n\n  .slick-track {\n    height: 100% !important;\n  }\n  .slick-slide {\n    height: 100% !important;\n    > div {\n      position: relative;\n      max-width: 400px;\n      display: flex;\n      margin: 0 auto;\n      place-items: center;\n      height: 100% !important;\n    }\n  }\n\n  .slick-dots {\n    bottom: 0;\n\n    li {\n      width: auto;\n\n      button {\n        width: 24px;\n        padding: 0;\n\n        &:before {\n          content: '';\n          top: 8px;\n          width: 24px;\n          height: 3px;\n          background-color: ",
        ";\n        }\n      }\n    }\n\n    li.slick-active button:before {\n      top: 8px;\n      height: 3px;\n      background-color: ",
        ";\n    }\n  }\n\n  @media (max-width: ",
        ") {\n    .main-slider {\n      max-width: unset;\n    }\n  }\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = products_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 100%;\n  padding: 16px;\n  cursor: pointer;\n  &:focus {\n    outline: none !important;\n  }\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = products_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  > span {\n    position: absolute !important;\n    top: 50% !important;\n    left: 50% !important;\n    transform: translate(-50%, -50%);\n    transition: opacity 400ms;\n  }\n  .hidden {\n    > span {\n      opacity: 0;\n    }\n  }\n  .shown {\n    > span {\n      opacity: 1;\n    }\n  }\n  img {\n  }\n  &:before {\n    content: '';\n    display: block;\n    padding-bottom: 100%;\n  }\n\n  @media (max-width: ",
        ") {\n    &:before {\n      padding-bottom: 110%;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = products_styles_taggedTemplateLiteral([
        "\n  position: fixed;\n  z-index: 1000;\n  top: 100px;\n  left: 30px;\n  padding: 10px;\n  margin: auto;\n  width: 95vw;\n  height: 80vh;\n  background-color: ",
        ";\n  box-shadow: 5px 5px 5px ",
        ";\n  border-radius: 10px;\n  .popup-wrapper {\n    height: 100%;\n    width: 100%;\n    position: relative;\n    display: grid;\n    grid-direction: row;\n    grid-gap: 20px;\n    grid-template-columns: 3fr 1fr;\n  }\n  .popup-image {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    img {\n      width: 300px;\n    }\n    span {\n      max-width: 70vw;\n      max-height: 80vh;\n    }\n  }\n  .video-iframe {\n    width: 100%;\n    height: 77vh;\n  }\n  H4 {\n    margin-right: 20px;\n  }\n  .sku-text {\n    margin-top: 30px;\n  }\n  @media (max-width: ",
        ") {\n    left: 10px;\n    .popup-wrapper {\n      display: grid;\n      grid-direction: column;\n      justify-content: center;\n      grid-template-columns: 100%;\n    }\n    H4 {\n      display: none !important;\n    }\n    .sku-text {\n      display: none !important;\n    }\n    .video-iframe {\n      width: 100%;\n      height: 300px;\n    }\n    .slide-box {\n      align-self: end;\n      margin: auto;\n      margin-bottom: 15px;\n    }\n    .popup-media {\n      align-self: end;\n    }\n    .popup-image {\n      align-self: center;\n      span {\n        max-width: 90vw;\n        max-height: 65vh;\n      }\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = products_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 10;\n  width: 25px;\n  height: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: transparent !important;\n  border: 2px solid ",
        ";\n  border-radius: 5px;\n  right: 2px;\n  cursor: pointer;\n  &:hover {\n    border: 2px solid ",
        ";\n    svg {\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = products_styles_taggedTemplateLiteral([
        "\n  margin-top: 50px;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = products_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 80px;\n  height: 80px;\n  padding: 0 8px;\n  margin: 0 4px 4px;\n  border: 1px solid\n    ",
        ";\n  transition: border-color 0.15s;\n  background-color: ",
        ";\n  cursor: pointer;\n\n  ",
        "\n\n  &:focus {\n    outline: none !important;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = products_styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}




var products_styles_Wrapper = styled_components_browser_esm["default"].div(products_styles_templateObject());
var MediaGallery = styled_components_browser_esm["default"].div(products_styles_templateObject1(), themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD);
var MiniContainer = styled_components_browser_esm["default"].div(products_styles_templateObject2(), themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD);
var MiniSlide = styled_components_browser_esm["default"].div(products_styles_templateObject3(), (0,es/* ifProp */.fq)({
    selected: true
}, (0,es/* palette */.DG)("primary"), (0,es/* palette */.DG)("black")), (0,es/* palette */.DG)("white"), (0,es/* ifProp */.fq)({
    selected: true
}, (0,shadowStyles/* default */.ZP)({
    color: "red",
    outlined: false,
    length: 4,
    showOnHover: false
})), themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD);
var MiniImage = styled_components_browser_esm["default"].div(styles_templateObject4());
var MainContainer = styled_components_browser_esm["default"].div(styles_templateObject5(), (0,es/* palette */.DG)("white"), (0,es/* palette */.DG)("black80"), themes/* theme.screenSize.sizeSM */.r.screenSize.sizeSM, themes/* theme.screenSize.sizeSM */.r.screenSize.sizeSM, themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD, (0,es/* palette */.DG)("black20"), (0,es/* palette */.DG)("red"), themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD);
var MainSlide = styled_components_browser_esm["default"].div(styles_templateObject6());
var MainImage = styled_components_browser_esm["default"].div(_templateObject7(), themes/* theme.screenSize.sizeSM */.r.screenSize.sizeSM);
var MediaPopUpContainer = styled_components_browser_esm["default"].div(_templateObject8(), themes/* theme.palette.white */.r.palette.white, themes/* theme.palette.black60 */.r.palette.black60, themes/* theme.screenSize.sizeSM */.r.screenSize.sizeSM);
var CloseButton = styled_components_browser_esm["default"].div(_templateObject9(), themes/* theme.palette.black */.r.palette.black, themes/* theme.palette.error */.r.palette.error, themes/* theme.palette.error */.r.palette.error);
var SlideBox = styled_components_browser_esm["default"].div(_templateObject10());
var PopUpMiniSlide = styled_components_browser_esm["default"].div(_templateObject11(), (0,es/* ifProp */.fq)({
    selected: true
}, (0,es/* palette */.DG)("primary"), (0,es/* palette */.DG)("black")), (0,es/* palette */.DG)("white"), (0,es/* ifProp */.fq)({
    selected: true
}, (0,shadowStyles/* default */.ZP)({
    color: "red",
    outlined: false,
    length: 4,
    showOnHover: false
})));
var VideoContainer = styled_components_browser_esm["default"].iframe(_templateObject12());

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./src/components/products/ProductMediaYoutubeImage.tsx



var ProductMediaYoutubeImage = function(param) {
    var value = param.value, isSelected = param.isSelected;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(products_styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniSlide, {
            selected: isSelected,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniImage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    alt: "",
                    src: value.thumbnail.url,
                    layout: "fill",
                    objectFit: "contain",
                    objectPosition: "top",
                    unoptimized: true
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/products/interfaces.ts
var typeIsVideo = function(type) {
    return type.__typename === "Video";
};

;// CONCATENATED MODULE: ./src/components/products/ProductMediaMiniSlide.tsx





var ProductMediaMiniSlide = function(param) {
    var value = param.value, isSelected = param.isSelected;
    if (typeIsVideo(value)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMediaYoutubeImage, {
            value: value,
            isSelected: isSelected
        });
    }
    var url = value.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(products_styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniSlide, {
            selected: isSelected,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                alt: "",
                src: url,
                layout: "fill",
                objectFit: "contain",
                objectPosition: "center"
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/typography/Headings.tsx
var Headings = __webpack_require__(94540);
// EXTERNAL MODULE: ./src/components/typography/P.tsx
var P = __webpack_require__(85351);
;// CONCATENATED MODULE: ./src/components/products/ProductMediaVideo.tsx
function ProductMediaVideo_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductMediaVideo_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ProductMediaVideo_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProductMediaVideo_templateObject() {
    var data = ProductMediaVideo_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"
    ]);
    ProductMediaVideo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var VideoFrame = styled_components_browser_esm["default"].iframe(ProductMediaVideo_templateObject());
var ProductMediaVideo = function(param) {
    var value = param.value, width = param.width, height = param.height, _styledProps = param.styledProps, styledProps = _styledProps === void 0 ? {} : _styledProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainSlide, {
        style: _objectSpread({
            width: width !== null && width !== void 0 ? width : "100%",
            height: height !== null && height !== void 0 ? height : "100%"
        }, styledProps),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainImage, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoFrame, {
                src: value.embedURL
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductMediaPopup.tsx










var ProductMediaPopUp = function(param) {
    var value = param.value;
    var width = (0,useWindowSize/* default */.Z)().width;
    if (typeIsVideo(value)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "popup-media",
            children: width <= 600 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMediaVideo, {
                value: value,
                height: "300px",
                styledProps: {
                    marginTop: "20px"
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMediaVideo, {
                value: value,
                width: "75%"
            })
        });
    }
    var url = value.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "popup-image",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
            alt: "",
            src: url,
            objectFit: "contain",
            layout: "fill",
            objectPosition: "center"
        })
    });
};
var PopUpSlide = function(param) {
    var value = param.value, isSelected = param.isSelected, index = param.index, toggleIndex = param.toggleIndex;
    if (typeIsVideo(value)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpMiniSlide, {
            className: "popup-slide",
            selected: isSelected,
            onClick: function() {
                toggleIndex(index);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniImage, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    alt: "",
                    src: value.thumbnail.url,
                    layout: "fill",
                    objectFit: "contain",
                    objectPosition: "top",
                    unoptimized: true
                })
            })
        });
    }
    var url = value.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpMiniSlide, {
            selected: isSelected,
            onClick: function() {
                toggleIndex(index);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                alt: "",
                src: url,
                layout: "fill",
                objectFit: "contain",
                objectPosition: "center"
            })
        })
    });
};
var MediaPopUp = function(param) {
    var prodMedia = param.prodMedia, proName = param.proName, proSku = param.proSku, currentSlide = param.currentSlide, toggleMediaPopUp = param.toggleMediaPopUp;
    var ref1 = (0,react.useState)(0), slide = ref1[0], setCurrentSlide = ref1[1];
    var popUpRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        setCurrentSlide(currentSlide);
    }, [
        currentSlide
    ]);
    var handleClose = function() {
        var popUpEle = document.getElementById("popup-backdrop");
        if (popUpEle === null || popUpEle === void 0 ? void 0 : popUpEle.style) {
            popUpEle.style.display = "none";
            document.body.style.overflow = "scroll";
        }
        toggleMediaPopUp(false);
    };
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", function(event) {
            var ref;
            if (popUpRef.current && !(popUpRef === null || popUpRef === void 0 ? void 0 : (ref = popUpRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target))) {
                handleClose();
            }
        });
    });
    var toggleIndex = function(index) {
        return setCurrentSlide(index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaPopUpContainer, {
        className: "pop-up",
        ref: popUpRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "popup-wrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                    onClick: handleClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((CloseLineIcon_default()), {
                        size: 14
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMediaPopUp, {
                    value: prodMedia[slide]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "slide-box",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(P/* PSmall */.zK, {
                            color: "black60",
                            className: "sku-text",
                            children: proSku
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings.H4, {
                            children: proName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideBox, {
                            children: prodMedia.map(function(value, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopUpSlide, {
                                    toggleIndex: toggleIndex,
                                    index: index,
                                    value: value,
                                    isSelected: index === slide
                                }, value.id);
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductMediaMain.tsx






var ProductMediaMain = function(param) {
    var value = param.value;
    var ref = (0,react.useRef)(null);
    if (typeIsVideo(value)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMediaVideo, {
            value: value
        });
    }
    var url = value.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainSlide, {
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
            alt: "",
            src: url,
            objectFit: "contain",
            layout: "fill",
            objectPosition: "center"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/products/ProductMediaGallery.tsx
function ProductMediaGallery_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductMediaGallery_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductMediaGallery_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









function ProductMediaGallery(param) {
    var prodMedia = param.prodMedia, proName = param.proName, proSku = param.proSku;
    var ref4 = (0,react.useState)(0), currSlide = ref4[0], setCurrSlide = ref4[1];
    var ref1 = (0,react.useState)(undefined), miniSlider = ref1[0], setMiniSlider = ref1[1];
    var ref2 = (0,react.useState)(false), showMediaPopUp = ref2[0], setShowMediaPopUp = ref2[1];
    var ref3 = (0,react.useState)(undefined), mainSlider = ref3[0], setMainSlider = ref3[1];
    (0,react.useEffect)(function() {
        if (showMediaPopUp) {
            var popUpEle = document.getElementById("popup-backdrop");
            if (popUpEle === null || popUpEle === void 0 ? void 0 : popUpEle.style) {
                popUpEle.style.display = "block";
                document.body.style.overflow = "hidden";
            }
        }
    }, [
        showMediaPopUp
    ]);
    var toggleMediaPopUp = function(value) {
        setShowMediaPopUp(value);
    };
    var miniSettings = {
        dots: false,
        infinite: false,
        arrows: false,
        speed: 400,
        verticalSwiping: true,
        swipeToSlide: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        waitForAnimate: false,
        vertical: true,
        focusOnSelect: true
    };
    var mainSettings = {
        dots: true,
        infinite: false,
        arrows: false,
        speed: 400,
        swipeToSlide: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        waitForAnimate: false,
        beforeChange: function(_, index) {
            return setCurrSlide(Math.ceil(index));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showMediaPopUp && /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaPopUp, {
                prodMedia: prodMedia,
                proName: proName,
                proSku: proSku,
                currentSlide: currSlide,
                toggleMediaPopUp: toggleMediaPopUp
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MediaGallery, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, ProductMediaGallery_objectSpread({
                            ref: function(ref) {
                                return setMiniSlider(ref);
                            },
                            asNavFor: mainSlider !== null && mainSlider !== void 0 ? mainSlider : undefined
                        }, miniSettings, {
                            children: prodMedia.map(function(value, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMediaMiniSlide, {
                                    value: value,
                                    isSelected: index === currSlide
                                }, value.id);
                            })
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MainContainer, {
                        onClick: function() {
                            setShowMediaPopUp(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, ProductMediaGallery_objectSpread({
                            ref: function(ref) {
                                return setMainSlider(ref);
                            },
                            asNavFor: miniSlider !== null && miniSlider !== void 0 ? miniSlider : undefined,
                            className: "main-slider"
                        }, mainSettings, {
                            children: prodMedia.length ? prodMedia === null || prodMedia === void 0 ? void 0 : prodMedia.map(function(value) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMediaMain, {
                                    value: value
                                }, value.id);
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MainSlide, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* SpacingWrapper */.$3, {
                                    spacing: 16,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* NoImage */.Dy, {
                                        size: 72,
                                        textSize: "1.25rem",
                                        withPadding: true
                                    })
                                })
                            })
                        }))
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/products/ProductCard/index.tsx
var ProductCard = __webpack_require__(56603);
;// CONCATENATED MODULE: ./src/components/products/ProductTagsWrapper.tsx
function ProductTagsWrapper_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProductTagsWrapper_templateObject() {
    var data = ProductTagsWrapper_taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    ProductTagsWrapper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductTagsWrapper_templateObject1() {
    var data = ProductTagsWrapper_taggedTemplateLiteral([
        "\n  display: flex;\n  margin-left: 12px;\n"
    ]);
    ProductTagsWrapper_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var ProductBadges = styled_components_browser_esm["default"].div(ProductTagsWrapper_templateObject());
var ProductLabels = styled_components_browser_esm["default"].div(ProductTagsWrapper_templateObject1());
function ProductTagsWrapper(param) {
    var isAvailable = param.isAvailable, _labels = param.labels, labels = _labels === void 0 ? [] : _labels, _badges = param.badges, badges = _badges === void 0 ? [] : _badges;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductBadges, {
                children: [
                    !isAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTag, {
                        badgeVariant: ProductBadgeVariant.ComingSoon
                    }),
                    badges === null || badges === void 0 ? void 0 : badges.map(function(badge) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTag, {
                            slug: badge.slug,
                            badgeVariant: badge.slug
                        }, badge.id);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLabels, {
                children: labels === null || labels === void 0 ? void 0 : labels.map(function(label) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductTag, {
                        slug: label.slug,
                        labelVariant: label.slug,
                        labelImage: (ref = label.thumbnail) === null || ref === void 0 ? void 0 : ref.url,
                        title: label.name
                    }, label.id);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/products/index.tsx












/***/ }),

/***/ 8134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ ShowEnd; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(186);
/* harmony import */ var remixicon_react_CheckboxCircleFillIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12127);
/* harmony import */ var remixicon_react_CheckboxCircleFillIcon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_CheckboxCircleFillIcon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52287);
/* harmony import */ var _typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56795);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 12px;\n  white-space: pre-wrap;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div(_templateObject());
var Block = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_typography__WEBPACK_IMPORTED_MODULE_3__.P)(_templateObject1());
var TEXT = "Bei\xf0ni m\xf3ttekin og ver\xf0ur afgreidd innan s\xf3lahrings. Ef fyrirt\xe6kinu \xfe\xednu liggur \xe1 kaupum \xfe\xe1 bendum vi\xf0 \xe1 a\xf0 hafa samband vi\xf0 okkur \xed s\xedma 520\u20116666.";
var ShowEnd = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_CheckboxCircleFillIcon__WEBPACK_IMPORTED_MODULE_1___default()), {
                color: src_themes__WEBPACK_IMPORTED_MODULE_2__/* .theme.palette.success */ .r.palette.success
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Block, {
                withGutter: true,
                children: TEXT
            })
        ]
    });
};


/***/ }),

/***/ 47347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* reexport */ SearchBar; },
  "s": function() { return /* reexport */ SearchResults; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-bootstrap-grid/dist/index.js
var dist = __webpack_require__(54572);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useWindowSize.js + 3 modules
var useWindowSize = __webpack_require__(72977);
// EXTERNAL MODULE: ./node_modules/styled-tools/dist/es/index.js + 6 modules
var es = __webpack_require__(41145);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/remixicon-react/ArrowRightLineIcon.js
var ArrowRightLineIcon = __webpack_require__(94187);
var ArrowRightLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowRightLineIcon);
// EXTERNAL MODULE: ./node_modules/algoliasearch/dist/algoliasearch-lite.umd.js
var algoliasearch_lite_umd = __webpack_require__(70290);
var algoliasearch_lite_umd_default = /*#__PURE__*/__webpack_require__.n(algoliasearch_lite_umd);
// EXTERNAL MODULE: ./src/components/layout/index.ts + 8 modules
var layout = __webpack_require__(49012);
// EXTERNAL MODULE: ./src/components/products/index.tsx + 38 modules
var products = __webpack_require__(18254);
// EXTERNAL MODULE: ./src/components/buttons/index.tsx + 6 modules
var buttons = __webpack_require__(31494);
// EXTERNAL MODULE: ./src/components/form/Checkbox.tsx
var Checkbox = __webpack_require__(1771);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectStats.js
var connectStats = __webpack_require__(89473);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectPagination.js
var connectPagination = __webpack_require__(73396);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectInfiniteHits.js
var connectInfiniteHits = __webpack_require__(66658);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectRefinementList.js
var connectRefinementList = __webpack_require__(75805);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/connectors/connectSortBy.js
var connectSortBy = __webpack_require__(72558);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-core/dist/es/widgets/InstantSearch.js + 6 modules
var InstantSearch = __webpack_require__(4793);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-dom/dist/es/widgets/SearchBox.js + 3 modules
var SearchBox = __webpack_require__(95861);
// EXTERNAL MODULE: ./src/components/common/Loader.tsx
var Loader = __webpack_require__(965);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(8597);
// EXTERNAL MODULE: ./src/themes/index.tsx
var themes = __webpack_require__(52287);
;// CONCATENATED MODULE: ./src/components/search/SearchResults.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      margin-top: 75px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 20px;\n  .ais-SearchBox {\n    display: none;\n  }\n  .large {\n    height: 95%;\n  }\n  .small {\n    margin-right: 15px;\n  }\n  .title-block {\n    margin-left: 40px;\n    margin-top: 30px;\n  }\n  .stats-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  .env-checkbox {\n    margin-left: 20px;\n    ",
        "\n  }\n  .filter-box {\n    width: 280px;\n    margin-bottom: 10px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 15px;\n  border: 1px solid #19191b;\n  background-color: #fefefe;\n  font-size: 16px;\n  font-family: Inter, sans-serif;\n  overflow-y: scroll;\n  label {\n    margin-top: 2px;\n  }\n  ::-webkit-scrollbar {\n    width: 0px;\n  }\n  input[type='checkbox'] {\n    accent-color: rgb(239, 63, 87);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  height: 50px;\n  padding: 0 16px;\n  margin-bottom: 4px;\n  border: 1px solid #19191b;\n  background-color: #fefefe;\n  font-family: Inter, sans-serif;\n  font-size: 22px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  svg {\n    margin-right: 8px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  height: 50px;\n  padding: 0 16px;\n  margin-bottom: 4px;\n  border: 1px solid #19191b;\n  background-color: #fefefe;\n  font-family: 'LetterboardLite';\n  font-weight: 700;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  .loader {\n    margin: auto;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 600;\n  margin-top: 24px;\n  margin-bottom: 14px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    position: relative;\n    top: 0;\n    border-top: border-top: 1px solid ",
        ";\n    border-bottom: none !important;\n    border-left: none !important;\n    border-right: none;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  top: -50px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  top: 20px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\nposition: relative;\nwidth: 220px;\ndisplay: flex;\nflex-direction: column;\njustify-content: center;\nalign-items: center;\nbackground-color: ",
        ";\nborder-radius: 5px;\nborder: 1.5px solid ",
        ";\n  .sort-button {\n    background-color: transparent;\n    border: none !important;\n    outline: none !important;\n    width: 100%;\n    height: 40px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    span {\n      font-size: 16px;\n      flex-grow: 1;\n      display: flex;\n      justify-content: flex-start;\n    }\n  }\n}\n.options {\n  width: 100%;\n  position: absolute;\n  top: 40px;\n  z-index: 10;\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n  ",
        "\n  li {\n    padding: 5px;\n    button {\n    width: 100%;\n    text-align: left;\n    background-color: transparent;\n    border: none !important;\n    font-size: 16px;\n    &:hover {\n      color: ",
        ";\n    }\n    .selected {\n      button {\n        color: ",
        ";\n      }\n    }\n    }\n    &:hover {\n      cursor: pointer;\n    }\n  }\n}\nposition: absolute;\nz-index: 10;\nright: 20px;\ntop: -30px;\n",
        "\n",
        "\nalign-self: flex-end;\nmargin-bottom: 10px;\n.arrow {\n  border: solid black;\n  border-width: 0 3px 3px 0;\n  display: inline-block;\n  padding: 3px;\n}\n.up {\n  transform: rotate(-135deg);\n  -webkit-transform: rotate(-135deg);\n}\n.down {\n  transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n}\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
















var SearchResultContainer = styled_components_browser_esm["default"].div(_templateObject1(), dist.media.xs(_templateObject()));
var FilterContainer = styled_components_browser_esm["default"].div(_templateObject2());
var FilterTitle = styled_components_browser_esm["default"].div(_templateObject3(), (0,es/* palette */.DG)("red"));
var FilterHead = styled_components_browser_esm["default"].button(_templateObject4());
var FilterBox = styled_components_browser_esm["default"].div(_templateObject5());
var StatsContainer = styled_components_browser_esm["default"].div(_templateObject6());
var SearchResultsPage = styled_components_browser_esm["default"].div(_templateObject7());
var SortDropdown = styled_components_browser_esm["default"].div(_templateObject11(), (0,es/* palette */.DG)("white"), (0,es/* palette */.DG)("black"), (0,es/* palette */.DG)("black"), (0,es/* palette */.DG)("white"), dist.media.lg(_templateObject8(), (0,es/* palette */.DG)("black")), themes/* theme.palette.error */.r.palette.error, themes/* theme.palette.error */.r.palette.error, dist.media.lg(_templateObject9()), dist.media.xs(_templateObject10()));
function SearchResults(param1) {
    var query = param1.query;
    var StatsComponent = function StatsComponent(param) {
        var nbHits = param.nbHits, updateTotalHits = param.updateTotalHits;
        (0,react.useEffect)(function() {
            updateTotalHits(nbHits);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            nbHits
        ]);
        return null;
    };
    var PaginationComponent = function PaginationComponent(param) {
        var currentRefinement = param.currentRefinement, totalHits = param.totalHits;
        var ref = (0,react.useState)(0), loaded = ref[0], setLoaded = ref[1];
        (0,react.useEffect)(function() {
            if (currentRefinement === 1) {
                setLoaded(function() {
                    if (totalHits < 24) {
                        return totalHits;
                    }
                    return 24;
                });
            } else {
                setLoaded(function() {
                    if (currentRefinement * 24 > totalHits) {
                        return totalHits;
                    }
                    return currentRefinement * 24;
                });
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            currentRefinement,
            totalHits
        ]);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StatsContainer, {
            children: [
                "\xde\xfa hefur s\xe9\xf0 ",
                loaded,
                " af ",
                totalHits
            ]
        });
    };
    var InfiniteHits = function InfiniteHits(param) {
        var hits = param.hits, hasMore = param.hasMore, refineNext = param.refineNext, cols = param.cols;
        var ref = (0,react.useState)(0), totalHits = ref[0], setTotalHits = ref[1];
        var updateTotalHits = function(total) {
            setTotalHits(total);
        };
        var OnLoadMore = function() {
            refineNext();
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
                    style: {
                        marginTop: "20px"
                    },
                    children: hits.map(function(hit) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(products/* ProductCard */.Il, {
                            slug: hit.slug,
                            render: function(children) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                    col: cols,
                                    children: children
                                }, hit.id);
                            }
                        }, hit.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "stats-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomStats, {
                            updateTotalHits: updateTotalHits
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomPagination, {
                            defaultRefinement: 24,
                            totalHits: totalHits
                        }),
                        hasMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                            onClick: OnLoadMore,
                            disabled: !hasMore,
                            className: "load-button",
                            withGutter: true,
                            outlined: true,
                            children: "Sj\xe1 fleiri v\xf6rur"
                        })
                    ]
                })
            ]
        });
    };
    var RefinementList = function RefinementList(param) {
        var items = param.items, refine = param.refine;
        var ref = (0,react.useState)(false), showDropdown = ref[0], setShowDropdown = ref[1];
        (0,react.useEffect)(function() {
            if (screenType === "large") {
                setShowDropdown(true);
            }
        }, []);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterBox, {
            className: screenType !== "large" ? "filter-box" : "",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterHead, {
                    className: "filter_".concat(screenType),
                    onClick: function() {
                        if (screenType !== "large") {
                            setShowDropdown(!showDropdown);
                        }
                    },
                    children: "S\xedur"
                }),
                showDropdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: !(items === null || items === void 0 ? void 0 : items.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "loader",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterTitle, {
                                className: "filter_".concat(screenType),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightLineIcon_default()), {}),
                                    " Flokkar"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterContainer, {
                                className: "filter_".concat(screenType),
                                children: items.map(function(item, index) {
                                    return(// eslint-disable-next-line react/no-array-index-key
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "checkbox",
                                                    name: item.label,
                                                    id: item.label,
                                                    checked: item.isRefined,
                                                    onChange: function() {
                                                        refine(item.value);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    htmlFor: item.label,
                                                    children: item.label
                                                })
                                            ]
                                        })
                                    }, index));
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    var EnvRefinement = function EnvRefinement(param) {
        var refine = param.refine;
        var ref = (0,react.useState)(false), checked = ref[0], setChecked = ref[1];
        (0,react.useEffect)(function() {
            if (checked) {
                refine([
                    "true"
                ]);
            } else {
                refine([
                    "true",
                    "false"
                ]);
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            checked
        ]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "env-checkbox",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                label: "S\xeda vistv\xe6nar v\xf6rur",
                checked: checked,
                onClick: function() {
                    return setChecked(!checked);
                }
            })
        });
    };
    var width = (0,useWindowSize/* default */.Z)().width;
    var ref2 = (0,react.useState)(), stateQuery = ref2[0], setQuery = ref2[1];
    var ref1 = (0,react.useState)(), screenWidth = ref1[0], setScreenWidth = ref1[1];
    (0,react.useEffect)(function() {
        if (query) {
            setQuery(query);
        }
    }, [
        query
    ]);
    (0,react.useEffect)(function() {
        if (width) {
            setScreenWidth(width);
        }
    }, [
        width
    ]);
    var screenType = (0,react.useMemo)(function() {
        if (width >= 1180) {
            return "large";
        }
        if (width < 1180 && width >= 950) {
            return "big";
        }
        if (width < 950 && width > 720) {
            return "medium";
        }
        if (width <= 720) {
            return "small";
        }
        return "large";
    }, [
        width
    ]);
    var applicationID = "R9PI10M7BM" || 0;
    var searchAPIKey = "cf30bb915a3522dcefa0c2c4c710a527" || 0;
    var indexName = (0,strings/* getAlgoliaProductIndex */.Fc)();
    var searchClient = algoliasearch_lite_umd_default()(applicationID, searchAPIKey);
    var CustomStats = (0,connectStats/* default */.Z)(StatsComponent);
    var CustomPagination = (0,connectPagination/* default */.Z)(PaginationComponent);
    var SortContainer = function(param) {
        var items = param.items, refine = param.refine;
        var ref = (0,react.useState)(false), showDropdown = ref[0], setShowDropdown = ref[1];
        var ref3 = (0,react.useState)(), sort = ref3[0], setSort = ref3[1];
        var handleChange = function(item) {
            setSort(item.label);
            setShowDropdown(false);
            refine(item.value);
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SortDropdown, {
            className: "sort-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    type: "button",
                    className: "sort-button",
                    onClick: function() {
                        return setShowDropdown(!showDropdown);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: sort ? "Ra\xf0a eftir: ".concat(sort) : "Ra\xf0a eftir: Nafn"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: showDropdown ? "arrow up" : "arrow down"
                        })
                    ]
                }),
                showDropdown && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "options",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: items.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    onClick: function() {
                                        return handleChange(item);
                                    },
                                    className: sort === item.label ? "selected" : "",
                                    children: item.label
                                })
                            }, item.value);
                        })
                    })
                })
            ]
        });
    };
    var CustomInfiniteHits = (0,connectInfiniteHits/* default */.Z)(InfiniteHits);
    var CustomRefinementList = (0,connectRefinementList/* default */.Z)(RefinementList);
    var EnvCustomRefinementList = (0,connectRefinementList/* default */.Z)(EnvRefinement);
    var CustomSortBy = (0,connectSortBy/* default */.Z)(SortContainer);
    var colsObj = {
        small: 12,
        big: 4,
        medium: 6,
        large: 4
    };
    var serachResultReturn = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsPage, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InstantSearch/* default */.Z, {
                    searchClient: searchClient,
                    indexName: indexName,
                    children: stateQuery && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchResultContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "title-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockTitle */.bi, {
                                    title: "V\xf6ruleit"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                        col: screenType === "large" ? 3 : 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomRefinementList, {
                                            attribute: "category_name",
                                            limit: 40
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                        col: screenType === "large" ? 9 : 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: screenType === "large" ? "refine-container" : "",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EnvCustomRefinementList, {
                                                    attribute: "eco-friendly",
                                                    limit: 40
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSortBy, {
                                                    defaultRefinement: indexName,
                                                    items: [
                                                        {
                                                            value: indexName,
                                                            label: "Nafn"
                                                        },
                                                        // {
                                                        //   value: `${indexName}_price_desc`,
                                                        //   label: 'Hæsta verð',
                                                        // },
                                                        {
                                                            value: "".concat(indexName, "_price_asc"),
                                                            label: "L\xe6gsta ver\xf0"
                                                        },
                                                        {
                                                            value: "".concat(indexName, "_date"),
                                                            label: "N\xfdjast"
                                                        }, 
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBox/* default */.Z, {
                                                    defaultRefinement: stateQuery
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInfiniteHits, {
                                                    cols: colsObj[screenType]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        screenWidth,
        stateQuery
    ]);
    return serachResultReturn;
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/remixicon-react/SearchLineIcon.js
var SearchLineIcon = __webpack_require__(26554);
var SearchLineIcon_default = /*#__PURE__*/__webpack_require__.n(SearchLineIcon);
// EXTERNAL MODULE: ./node_modules/react-instantsearch-dom/dist/es/widgets/Hits.js + 2 modules
var Hits = __webpack_require__(14606);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./src/utils/paths.ts
var paths = __webpack_require__(27827);
;// CONCATENATED MODULE: ./src/components/search/SearchBar.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SearchBar_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchBar_templateObject() {
    var data = SearchBar_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  .hit-link {\n    :hover {\n      background-color: #f9f9f9;\n      color: #ef3f57;\n    }\n  }\n"
    ]);
    SearchBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchBar_templateObject1() {
    var data = SearchBar_taggedTemplateLiteral([
        "\n  position: absolute;\n  max-height: 460px;\n  width: 600px;\n  top: 60px;\n  z-index: 100;\n  background-color: #fff;\n  border-bottom: 1px solid rgba(232, 232, 232, 0.6);\n  overflow-y: scroll;\n  .product-name {\n    padding-left: 10px;\n  }\n  .products-title {\n    font-size: 18px;\n    font-weight: 600;\n    padding: 20px;\n  }\n  .hit-container {\n    padding: 20px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    border: 1px solid rgba(232, 232, 232, 0.6);\n  }\n  .hit-container > img {\n    object-fit: contain;\n  }\n\n  ::-webkit-scrollbar {\n    width: 0px;\n  }\n  border-left: 5px solid red;\n  border-bottom: 5px solid red;\n"
    ]);
    SearchBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchBar_templateObject2() {
    var data = SearchBar_taggedTemplateLiteral([
        "\n  padding: 5px 10px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    SearchBar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchBar_templateObject3() {
    var data = SearchBar_taggedTemplateLiteral([
        "\n    display: block;\n    width: 420px;\n  "
    ]);
    SearchBar_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SearchBar_templateObject4() {
    var data = SearchBar_taggedTemplateLiteral([
        "\n  .search-flex {\n    display: none;\n    ",
        "\n  }\n  input {\n    outline: none;\n    border: none;\n    padding: 5px;\n    background-color: transparent;\n    display: none;\n    ",
        "\n    appearence: none;\n  }\n  .ais-SearchBox {\n    display: none;\n    display: block;\n    width: 420px;\n  }\n\n  .ais-SearchBox-form {\n    outline: none;\n    border: none;\n    padding: 5px;\n    background-color: transparent;\n    :hover {\n      .ais-SearchBox-submit {\n        display: none;\n      }\n      .ais-SearchBox-reset {\n        display: none;\n      }\n    }\n    :focus-within {\n      .ais-SearchBox-submit {\n        display: none;\n      }\n      .ais-SearchBox-reset {\n        display: none;\n      }\n    }\n  }\n  .ais-SearchBox-submit {\n    display: none;\n  }\n  .ais-SearchBox-reset {\n    display: none;\n  }\n  .ErrorText {\n    background-color: #fff;\n    padding: 15px;\n  }\n"
    ]);
    SearchBar_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SearchBar_templateObject5() {
    var data = SearchBar_taggedTemplateLiteral([
        "\n  position: absolute;\n  max-height: 500px;\n  margin-top: 10px;\n  width: 90%;\n  z-index: 100;\n  background-color: #fff;\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid rgba(232, 232, 232, 0.6);\n  overflow-y: scroll;\n  border-left: 5px solid red;\n  border-bottom: 5px solid red;\n  .hit-container {\n    padding: 20px 10px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 10px;\n    border: 1px solid rgba(232, 232, 232, 0.6);\n  }\n  .hit-container > img {\n    object-fit: contain;\n  }\n  ::-webkit-scrollbar {\n    width: 0px;\n  }\n  .products-title {\n    border: 1px solid rgba(232, 232, 232, 0.6);\n    font-size: 18px;\n    font-weight: 600;\n    padding: 20px;\n  }\n"
    ]);
    SearchBar_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SearchBar_templateObject6() {
    var data = SearchBar_taggedTemplateLiteral([
        "\n  color: rgb(48, 48, 50);\n  padding-left: 10px;\n  .search-box {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    height: 50px;\n  }\n  input {\n    outline: none;\n    border: none;\n    padding: 5px;\n    background-color: transparent;\n  }\n  #mobileInput {\n    width: 80vw;\n    padding-right: 10px;\n  }\n  .ais-SearchBox-form {\n    outline: none;\n    border: none;\n    padding: 5px;\n    background-color: transparent;\n    :hover {\n      .ais-SearchBox-submit {\n        display: none;\n      }\n      .ais-SearchBox-reset {\n        display: none;\n      }\n    }\n    :focus-within {\n      .ais-SearchBox-submit {\n        display: none;\n      }\n      .ais-SearchBox-reset {\n        display: none;\n      }\n    }\n  }\n  .ais-SearchBox-submit {\n    display: none;\n  }\n  .ais-SearchBox-reset {\n    display: none;\n  }\n"
    ]);
    SearchBar_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */ /* eslint-disable no-console */ /* eslint-disable @next/next/no-img-element */ 










var HitContainer = styled_components_browser_esm["default"].div(SearchBar_templateObject());
var SearchContainer = styled_components_browser_esm["default"].div(SearchBar_templateObject1());
var SearchWrapper = styled_components_browser_esm["default"].div(SearchBar_templateObject4(), dist.media.md(SearchBar_templateObject2()), dist.media.md(SearchBar_templateObject3()));
var MobileSearchContainer = styled_components_browser_esm["default"].div(SearchBar_templateObject5());
var MobileSearchWrapper = styled_components_browser_esm["default"].div(SearchBar_templateObject6());
function SearchBar(param1) {
    var border = param1.border, showDropdown = param1.showDropdown;
    var InfiniteHits = function InfiniteHits(param) {
        var hits = param.hits, keyValue = param.keyValue, hasMore = param.hasMore, refineNext = param.refineNext, onEnter = param.onEnter, resetValue = param.resetValue;
        var resultElement = document.getElementById("result-container");
        (0,react.useEffect)(function() {
            if (keyValue && keyValue <= hits.length) {
                var focusElement = resultElement === null || resultElement === void 0 ? void 0 : resultElement.children[keyValue - 1];
                if (focusElement) {
                    focusElement.style.backgroundColor = "#f9f9f9";
                    focusElement.style.color = "#EF3F57";
                    focusElement === null || focusElement === void 0 ? void 0 : focusElement.scrollIntoView({
                        behavior: "smooth"
                    });
                }
                if (keyValue === hits.length && hasMore) {
                    resetValue(1);
                    refineNext();
                }
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            keyValue,
            resultElement
        ]);
        (0,react.useEffect)(function() {
            if (onEnter) {
                router.push("/vara/".concat(hits[keyValue - 1].slug));
                setShowHit(false);
            }
        }, [
            hits,
            keyValue,
            onEnter
        ]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HitContainer, {
                id: "result-container",
                children: hits.map(function(hit, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        "data-search-box": index,
                        className: "hit-link",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/vara/".concat(hit.slug),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/vara/".concat(hit.slug),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "hit-container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: hit.image_url,
                                            width: "40",
                                            height: "40",
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-name",
                                                children: hit.name
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }, hit.slug);
                })
            })
        });
    };
    var Hit = function Hit(param) {
        var hit = param.hit;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: "/vara/".concat(hit.slug),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "/vara/".concat(hit.slug),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "hit-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: hit.image_url,
                            width: "40",
                            height: "40",
                            alt: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-name",
                                children: hit.name
                            })
                        })
                    ]
                })
            })
        });
    };
    var ref6 = (0,react.useRef)(null);
    var mobileRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(), showHits = ref1[0], setShowHit = ref1[1];
    var ref2 = (0,react.useState)(), searchText = ref2[0], setSearchText = ref2[1];
    var ref3 = (0,react.useState)(), isMobile = ref3[0], setIsMobile = ref3[1];
    var ref4 = (0,react.useState)(), enter = ref4[0], setEnter = ref4[1];
    var toggleShowHits = (0,react.useCallback)(function(value) {
        return setShowHit(value);
    }, []);
    (0,react.useEffect)(function() {
        setIsMobile(border);
        setShowHit(showDropdown);
        if (!showDropdown) {
            setSearchText("");
        }
    }, [
        border,
        showDropdown
    ]);
    var useKeyboardEvent = function() {
        var ref = (0,react.useState)(0), value = ref[0], setValue = ref[1];
        var ResetValue = function(val) {
            if (val) {
                setValue(val);
            }
            setValue(0);
        };
        var handleKeypress = (0,react.useCallback)(function(val) {
            var focused = document.activeElement;
            if (!focused) {
                return;
            }
            if ((focused === null || focused === void 0 ? void 0 : focused.getAttribute("id")) === "searchInput" || (focused === null || focused === void 0 ? void 0 : focused.getAttribute("data-search-box"))) {
                if (val.code === "ArrowDown") {
                    var newValue = value + 1;
                    val.preventDefault();
                    setValue(newValue);
                    return;
                }
                if (val.code === "ArrowUp") {
                    var newValue1 = value - 1;
                    val.preventDefault();
                    if (newValue1 < 0) {
                        return;
                    }
                    setValue(newValue1);
                    return;
                }
            }
            if (val.code === "Escape") {
                setValue(0);
            }
        }, [
            value
        ]);
        return {
            value: value,
            handleKeypress: handleKeypress,
            ResetValue: ResetValue
        };
    };
    var ref5 = useKeyboardEvent(), value1 = ref5.value, handleKeypress1 = ref5.handleKeypress, ResetValue1 = ref5.ResetValue;
    (0,react.useEffect)(function() {
        if (isMobile && showHits) {
            document.addEventListener("mousedown", function(event) {
                var ref;
                if (!((ref = mobileRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target))) {
                    toggleShowHits(false);
                }
            });
        }
        if (showHits && !isMobile) {
            document.addEventListener("mousedown", function(event) {
                var ref;
                if (!((ref = ref6.current) === null || ref === void 0 ? void 0 : ref.contains(event.target))) {
                    toggleShowHits(false);
                    ResetValue1();
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    });
    (0,react.useEffect)(function() {
        document.addEventListener("keydown", handleKeypress1);
        return function() {
            document.removeEventListener("keydown", handleKeypress1);
        };
    }, [
        handleKeypress1
    ]);
    var applicationID = "R9PI10M7BM" || 0;
    var searchAPIKey = "cf30bb915a3522dcefa0c2c4c710a527" || 0;
    var indexName = (0,strings/* getAlgoliaProductIndex */.Fc)();
    var searchClient = (0,react.useMemo)(function() {
        var algoliaClient = algoliasearch_lite_umd_default()(applicationID, searchAPIKey);
        return _objectSpread({}, algoliaClient, {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            search: function search(requests) {
                var filteredReq = requests.filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                function(req) {
                    return req.params.query !== "";
                });
                if (filteredReq.length) {
                    return algoliaClient.search(filteredReq);
                }
                return Promise.resolve({});
            }
        });
    }, [
        applicationID,
        searchAPIKey
    ]);
    (0,react.useEffect)(function() {
        if (showHits && searchText) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [
        showHits,
        searchText
    ]);
    var handleSubmit = function(event) {
        event.preventDefault();
        if (!value1) {
            var path = "".concat(paths/* paths.search */.H.search).concat(searchText);
            toggleShowHits(false);
            router.push(path, path, {
                shallow: true
            });
            return;
        }
        setEnter(true);
    };
    var CustomInfiniteHits = (0,connectInfiniteHits/* default */.Z)(InfiniteHits);
    var serachBarReturn = isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSearchWrapper, {
        ref: mobileRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InstantSearch/* default */.Z, {
            searchClient: searchClient,
            indexName: indexName,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "search-box",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((SearchLineIcon_default()), {
                            size: 20,
                            color: themes/* theme.palette.red */.r.palette.red
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBox/* default */.Z, {
                            inputId: "mobileInput",
                            translations: {
                                placeholder: "A\xf0 hverju leitar \xfe\xfa?"
                            },
                            onSubmit: handleSubmit,
                            onChange: function(event) {
                                if (!showHits) {
                                    toggleShowHits(true);
                                }
                                setSearchText(event.target.value);
                                ResetValue1();
                            }
                        })
                    ]
                }),
                searchText && showHits && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileSearchContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "products-title",
                                children: "V\xf6rur"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hits/* default */.Z, {
                                hitComponent: Hit
                            })
                        ]
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchWrapper, {
        ref: ref6,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InstantSearch/* default */.Z, {
            searchClient: searchClient,
            indexName: indexName,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "search-flex",
                    tabIndex: 0,
                    "data-search-box": 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((SearchLineIcon_default()), {
                            size: 20,
                            color: themes/* theme.palette.red */.r.palette.red
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBox/* default */.Z, {
                            inputId: "searchInput",
                            "data-search-box": 0,
                            translations: {
                                placeholder: "A\xf0 hverju leitar \xfe\xfa?"
                            },
                            onSubmit: handleSubmit,
                            onChange: function(event) {
                                if (!showHits) {
                                    toggleShowHits(true);
                                }
                                setSearchText(event.target.value);
                                ResetValue1();
                            }
                        })
                    ]
                }),
                searchText && showHits && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchContainer, {
                        id: "search-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInfiniteHits, {
                            keyValue: value1,
                            onEnter: enter,
                            resetValue: ResetValue1
                        })
                    })
                })
            ]
        })
    });
    return serachBarReturn;
};

;// CONCATENATED MODULE: ./src/components/search/index.tsx




/***/ }),

/***/ 63066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ShoppingListItems; }
/* harmony export */ });
/* harmony import */ var _home_ubuntu_rekstrarvorur_storefront_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_rekstrarvorur_storefront_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_rekstrarvorur_storefront_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54572);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(186);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41145);
/* harmony import */ var remixicon_react_ArrowRightLineIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94187);
/* harmony import */ var remixicon_react_ArrowRightLineIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_ArrowRightLineIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var remixicon_react_PencilLineIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53320);
/* harmony import */ var remixicon_react_PencilLineIcon__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_PencilLineIcon__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var src_context_ShoppingListContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44339);
/* harmony import */ var src_utils_paths__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27827);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52287);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5152);
/* harmony import */ var _layout__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(49012);
/* harmony import */ var _products__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(18254);
/* harmony import */ var _typography__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56795);
/* harmony import */ var _buttons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(31494);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69446);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(53220);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: -10px;\n  margin-bottom: 18px;\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  color: ",
        ";\n  text-align: center;\n  margin: 50px 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


















var SubTitleWrapper = styled_components__WEBPACK_IMPORTED_MODULE_18__["default"].div(_templateObject());
var EmptyListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_18__["default"].div(_templateObject1(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_5__/* .palette */ .DG)("black60"));
/** Only load this on client. */ var ProductCard = (0,next_dynamic__WEBPACK_IMPORTED_MODULE_11__["default"])(_asyncToGenerator(_home_ubuntu_rekstrarvorur_storefront_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    return _home_ubuntu_rekstrarvorur_storefront_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                _ctx.next = 2;
                return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 80489));
            case 2:
                return _ctx.abrupt("return", _ctx.sent.ProductCard);
            case 3:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
})), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80489)
            ];
        }
    },
    ssr: false
});
var GetItem = function(param) {
    var product = param.product, shoppingListProductId = param.shoppingListProductId;
    if (!product.id) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ProductCard, {
        render: function(children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_4__.Col, {
                sm: 6,
                md: 4,
                lg: 3,
                children: children
            }, product.id);
        },
        slug: product.productVariant.product.slug,
        shoppingList: true,
        shoppingListProductId: shoppingListProductId
    }, product.id);
};
function ShoppingListItems() {
    var ref, ref1, ref2;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var id = router.query.listId;
    var ref3 = (0,src_context_ShoppingListContext__WEBPACK_IMPORTED_MODULE_8__/* .useShoppingList */ .B9)(), shoppingLists = ref3.shoppingLists, useSingleShoppingList = ref3.useSingleShoppingList, setCreateModalIsOpen = ref3.setCreateModalIsOpen, createModalIsOpen = ref3.createModalIsOpen;
    var ref4 = useSingleShoppingList(id), singleShoppingList = ref4.singleShoppingList, revalidateSingleShoppingList = ref4.revalidateSingleShoppingList;
    var isCurrCustomerList = shoppingLists === null || shoppingLists === void 0 ? void 0 : shoppingLists.some(function(list) {
        return list.id === id;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (shoppingLists && !isCurrCustomerList) {
            router.push(src_utils_paths__WEBPACK_IMPORTED_MODULE_9__/* .paths.shoppingList */ .H.shoppingList);
        }
    }, [
        isCurrCustomerList,
        shoppingLists,
        router
    ]);
    var handleShoppingLitstItems = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_4__.Row, {
            children: singleShoppingList === null || singleShoppingList === void 0 ? void 0 : singleShoppingList.items.map(function(product) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GetItem, {
                    product: product,
                    shoppingListProductId: product.id
                });
            })
        });
    }, [
        singleShoppingList
    ]);
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (!setCreateModalIsOpen) {
            return;
        }
        setCreateModalIsOpen(true);
    }, [
        setCreateModalIsOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_products__WEBPACK_IMPORTED_MODULE_13__/* .Breadcrumbs */ .Oo, {
                breadcrumbs: [
                    {
                        title: "Fors\xed\xf0a",
                        href: src_utils_paths__WEBPACK_IMPORTED_MODULE_9__/* .paths.home */ .H.home
                    },
                    {
                        title: "\xd3skalistar",
                        href: src_utils_paths__WEBPACK_IMPORTED_MODULE_9__/* .paths.shoppingList */ .H.shoppingList
                    },
                    {
                        title: singleShoppingList === null || singleShoppingList === void 0 ? void 0 : singleShoppingList.name,
                        href: router.asPath
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_layout__WEBPACK_IMPORTED_MODULE_12__/* .SpacingWrapper */ .$3, {
                spacing: 32,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout__WEBPACK_IMPORTED_MODULE_12__/* .BlockTitle */ .bi, {
                        title: !singleShoppingList ? "\xd3skalisti" : "\xd3skalisti - ".concat(singleShoppingList === null || singleShoppingList === void 0 ? void 0 : singleShoppingList.name)
                    }),
                    !!singleShoppingList && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SubTitleWrapper, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_typography__WEBPACK_IMPORTED_MODULE_14__/* .PSmall */ .zK, {
                                children: [
                                    singleShoppingList === null || singleShoppingList === void 0 ? void 0 : (ref = singleShoppingList.items) === null || ref === void 0 ? void 0 : ref.length,
                                    " ",
                                    (singleShoppingList === null || singleShoppingList === void 0 ? void 0 : (ref1 = singleShoppingList.items) === null || ref1 === void 0 ? void 0 : ref1.length) === 1 ? "vara" : "v\xf6rur"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_buttons__WEBPACK_IMPORTED_MODULE_15__/* .UnderlineButton */ .tg, {
                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((remixicon_react_PencilLineIcon__WEBPACK_IMPORTED_MODULE_7___default()), {
                                    color: src_themes__WEBPACK_IMPORTED_MODULE_10__/* .theme.palette.primary */ .r.palette.primary,
                                    size: 16
                                }),
                                text: "Breyta \xf3skalista",
                                onClick: handleClick
                            })
                        ]
                    }),
                    (singleShoppingList === null || singleShoppingList === void 0 ? void 0 : (ref2 = singleShoppingList.items) === null || ref2 === void 0 ? void 0 : ref2.length) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        children: handleShoppingLitstItems
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(EmptyListWrapper, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_14__.H5, {
                                withGutter: true,
                                children: "\xdeessi \xf3skalisti er t\xf3mur"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_typography__WEBPACK_IMPORTED_MODULE_14__/* .PSmall */ .zK, {
                                withGutter: true,
                                children: "B\xe6ttu \xfar \xfev\xed me\xf0 \xfev\xed a\xf0 sko\xf0a v\xf6rur \xed vefversluninni okkar!"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_buttons__WEBPACK_IMPORTED_MODULE_15__/* .AnchorButton */ .AN, {
                                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((remixicon_react_ArrowRightLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
                                    color: src_themes__WEBPACK_IMPORTED_MODULE_10__/* .theme.palette.primary */ .r.palette.primary
                                }),
                                href: src_utils_paths__WEBPACK_IMPORTED_MODULE_9__/* .paths.categories */ .H.categories,
                                withGutter: true,
                                children: "Fara \xed vefverslun"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_common__WEBPACK_IMPORTED_MODULE_16__/* .Modal */ .u_, {
                setShow: setCreateModalIsOpen,
                show: !!createModalIsOpen,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(___WEBPACK_IMPORTED_MODULE_17__/* .CreateNewShoppingList */ .Es, {
                    revalidateSingleShoppingList: revalidateSingleShoppingList,
                    list: singleShoppingList
                })
            })
        ]
    });
};


/***/ }),

/***/ 98895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ShoppingListsPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54572);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var remixicon_react_SubtractLineIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80207);
/* harmony import */ var remixicon_react_SubtractLineIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_SubtractLineIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52287);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(186);
/* harmony import */ var src_components_shoppingLists__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53220);
/* harmony import */ var _context_ShoppingListContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44339);
/* harmony import */ var _common_Modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92627);
/* harmony import */ var _buttons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31494);
/* harmony import */ var _typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56795);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69446);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: -10px;\n  margin-bottom: 32px;\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var SubTitleWrapper = styled_components__WEBPACK_IMPORTED_MODULE_11__["default"].div(_templateObject());
function ShoppingListsPage() {
    var ref4 = (0,_context_ShoppingListContext__WEBPACK_IMPORTED_MODULE_6__/* .useShoppingList */ .B9)(), shoppingLists = ref4.shoppingLists, deleteModalIsOpen = ref4.deleteModalIsOpen, setDeleteModalIsOpen = ref4.setDeleteModalIsOpen, deleteShoppingLists = ref4.deleteShoppingLists, createModalIsOpen = ref4.createModalIsOpen, setCreateModalIsOpen = ref4.setCreateModalIsOpen;
    var handleShoppingLists = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: shoppingLists === null || shoppingLists === void 0 ? void 0 : shoppingLists.map(function(list) {
                var ref, ref1, ref2, ref3;
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__.Col, {
                    sm: 4,
                    md: 3,
                    lg: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_shoppingLists__WEBPACK_IMPORTED_MODULE_5__/* .ShoppingListCard */ .OQ, {
                        title: list.name,
                        src: ((ref = list.items[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.productVariant) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.firstImage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.productList) || "/assets/no-image.svg",
                        href: "/oskalistar/".concat(list.id),
                        description: list.items.length === 1 ? "".concat(list.items.length, " vara") : "".concat(list.items.length, " v\xf6rur"),
                        listId: list.id,
                        linkCard: true,
                        emptyList: !list.items.length
                    })
                }, list.id);
            })
        });
    }, [
        shoppingLists
    ]);
    var handleDeleteAll = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var promiseArray = shoppingLists === null || shoppingLists === void 0 ? void 0 : shoppingLists.map(function(param) {
            var id = param.id;
            return deleteShoppingLists(id);
        });
        Promise.all(promiseArray).then(function() {
            if (!setDeleteModalIsOpen) {
                return;
            }
            setDeleteModalIsOpen(false);
        }).catch(function(err) {
            // TODO: handle error
            // eslint-disable-next-line no-console
            console.error(err);
        });
    }, [
        deleteShoppingLists,
        setDeleteModalIsOpen,
        shoppingLists
    ]);
    var handleSetDeleteModalIsOpen = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        if (setDeleteModalIsOpen) {
            setDeleteModalIsOpen(value);
        }
    }, [
        setDeleteModalIsOpen
    ]);
    var handleDeleteModalFalse = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (setDeleteModalIsOpen) {
            setDeleteModalIsOpen(false);
        }
    }, [
        setDeleteModalIsOpen
    ]);
    var handleDeleteClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (!setDeleteModalIsOpen) {
            return;
        }
        setDeleteModalIsOpen(true);
    }, [
        setDeleteModalIsOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__.Row, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__.Col, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__.Row, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__.Col, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SubTitleWrapper, {
                                    children: [
                                        shoppingLists && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: shoppingLists.length === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_typography__WEBPACK_IMPORTED_MODULE_9__/* .PSmall */ .zK, {
                                                children: [
                                                    shoppingLists.length,
                                                    " listi"
                                                ]
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_typography__WEBPACK_IMPORTED_MODULE_9__/* .PSmall */ .zK, {
                                                children: [
                                                    shoppingLists.length,
                                                    " listar"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons__WEBPACK_IMPORTED_MODULE_8__/* .UnderlineButton */ .tg, {
                                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_SubtractLineIcon__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                color: src_themes__WEBPACK_IMPORTED_MODULE_4__/* .theme.palette.primary */ .r.palette.primary
                                            }),
                                            text: "Ey\xf0a \xf6llum \xf3skalistum",
                                            onClick: handleDeleteClick
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__.Col, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__.Row, {
                            children: [
                                handleShoppingLists,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_2__.Col, {
                                    md: 3,
                                    lg: 2,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_shoppingLists__WEBPACK_IMPORTED_MODULE_5__/* .ShoppingListCard */ .OQ, {
                                        title: "B\xfaa til n\xfdjan \xf3skalista",
                                        onClickCreate: function() {
                                            return setCreateModalIsOpen(true);
                                        }
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Modal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                setShow: setCreateModalIsOpen,
                show: createModalIsOpen,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_shoppingLists__WEBPACK_IMPORTED_MODULE_5__/* .CreateNewShoppingList */ .Es, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Modal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                setShow: handleSetDeleteModalIsOpen,
                show: !!deleteModalIsOpen,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common__WEBPACK_IMPORTED_MODULE_10__/* .DeleteConfirmation */ .L3, {
                    title: "Ertu viss um a\xf0 \xfe\xfa viljir ey\xf0a \xf6llum \xf3skalistunum \xfe\xednum?",
                    text: "\xde\xfa munt ekki geta teki\xf0 \xfeessa a\xf0ger\xf0 til baka.",
                    onCancel: handleDeleteModalFalse,
                    onRemove: handleDeleteAll,
                    cancelText: "H\xe6tta vi\xf0",
                    submitText: "Ey\xf0a \xf6llu"
                })
            })
        ]
    });
};


/***/ }),

/***/ 53220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$b": function() { return /* reexport */ AddItemToShoppingList; },
  "Es": function() { return /* reexport */ CreateNewShoppingList; },
  "sm": function() { return /* reexport */ DeleteShoppingListItem; },
  "OQ": function() { return /* reexport */ ShoppingListCard; },
  "EC": function() { return /* reexport */ ShoppingListsPage/* default */.Z; }
});

// UNUSED EXPORTS: ShoppingListItems

// EXTERNAL MODULE: ./src/components/shoppingLists/ShoppingListsPage.tsx
var ShoppingListsPage = __webpack_require__(98895);
// EXTERNAL MODULE: ./src/components/shoppingLists/ShoppingListItems.tsx
var ShoppingListItems = __webpack_require__(63066);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./node_modules/styled-tools/dist/es/index.js + 6 modules
var es = __webpack_require__(41145);
// EXTERNAL MODULE: ./node_modules/remixicon-react/ArrowRightUpLineIcon.js
var ArrowRightUpLineIcon = __webpack_require__(28698);
var ArrowRightUpLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowRightUpLineIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/AddLineIcon.js
var AddLineIcon = __webpack_require__(69675);
var AddLineIcon_default = /*#__PURE__*/__webpack_require__.n(AddLineIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/DeleteBinLineIcon.js
var DeleteBinLineIcon = __webpack_require__(39285);
var DeleteBinLineIcon_default = /*#__PURE__*/__webpack_require__.n(DeleteBinLineIcon);
// EXTERNAL MODULE: ./src/context/ShoppingListContext.tsx
var ShoppingListContext = __webpack_require__(44339);
// EXTERNAL MODULE: ./src/components/common/index.tsx + 15 modules
var common = __webpack_require__(69446);
// EXTERNAL MODULE: ./src/themes/theme.ts
var theme = __webpack_require__(69431);
// EXTERNAL MODULE: ./src/components/typography/index.tsx + 1 modules
var typography = __webpack_require__(56795);
// EXTERNAL MODULE: ./src/styles/shadowStyles.ts
var shadowStyles = __webpack_require__(23633);
// EXTERNAL MODULE: ./src/styles/imageStyles.ts
var imageStyles = __webpack_require__(42521);
// EXTERNAL MODULE: ./src/components/buttons/index.tsx + 6 modules
var buttons = __webpack_require__(31494);
;// CONCATENATED MODULE: ./src/components/shoppingLists/ShoppingListCard.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  opacity: 0;\n  transition: opacity 0.15s;\n  z-index: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: 125px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n  justify-content: flex-end;\n  color: ",
        ";\n  border-top: 1px solid ",
        ";\n  min-height: 125px;\n  transition: background-color 0.15s;\n\n  ",
        " {\n    position: relative;\n    padding-top: 16px;\n    padding-bottom: 8px;\n    text-align: left;\n\n    &:before {\n      position: absolute;\n      content: '';\n      top: 0;\n      left: 0;\n      width: 20px;\n      border-top: 1px solid ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  height: 50%;\n  background: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .remixicon-icon {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  right: 0;\n  transition: visibility 0.15s;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  height: 250px;\n  min-width: 200px;\n  max-width: 500px;\n  margin-bottom: 20px;\n  transition: color 0.5s, border-color 0.5s, background-color 0.5s;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  cursor: pointer;\n  ",
        ";\n\n  &:hover&:not(:disabled) {\n    border: 1px solid ",
        ";\n\n    ",
        " {\n      .remixicon-icon {\n        fill: ",
        ";\n      }\n    }\n\n    ",
        " {\n      visibility: visible;\n    }\n\n    ",
        " {\n      opacity: 1;\n      cursor: pointer;\n    }\n  }\n\n  &:active {\n    ",
        " {\n      background-color: ",
        ";\n    }\n  }\n\n  ",
        " {\n    background-color: ",
        ";\n  }\n\n  &:focus,\n  &:focus-visible {\n    outline: 3px solid ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border: none;\n  padding: 0;\n  height: 250px;\n  cursor: pointer;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}















var TrashButton = styled_components_browser_esm["default"].div(_templateObject());
var EmptyListText = styled_components_browser_esm["default"].div(_templateObject1(), (0,es/* palette */.DG)("background"), (0,es/* palette */.DG)("black40"));
var CategoryTitleBox = styled_components_browser_esm["default"].div(_templateObject2(), (0,es/* palette */.DG)("secondary"), (0,es/* palette */.DG)("black20"), typography.H5, (0,es/* palette */.DG)("red"));
var AddIconWrapper = styled_components_browser_esm["default"].div(_templateObject3(), (0,es/* palette */.DG)("background"), (0,es/* palette */.DG)("black20"));
var IconContainer = styled_components_browser_esm["default"].div(_templateObject4());
var CardContainer = styled_components_browser_esm["default"].div(_templateObject5(), (0,es/* palette */.DG)("black20"), (0,es/* palette */.DG)("white"), (0,shadowStyles/* default */.ZP)({
    color: "red",
    outlined: false,
    length: 8,
    showOnHover: true
}), (0,es/* palette */.DG)("red"), AddIconWrapper, (0,es/* palette */.DG)("primary"), IconContainer, TrashButton, CategoryTitleBox, (0,es/* palette */.DG)("red10"), imageStyles/* BackgroundImageCover */.G, (0,es/* palette */.DG)("white"), (0,es/* palette */.DG)("sky"));
var CreateButton = styled_components_browser_esm["default"].button(_templateObject6(), (0,es/* palette */.DG)("white"));
function ShoppingListCard(param) {
    var listId = param.listId, src = param.src, title = param.title, description = param.description, linkCard = param.linkCard, emptyList = param.emptyList, href = param.href, onClickCreate = param.onClickCreate;
    var deleteShoppingLists = (0,ShoppingListContext/* useShoppingList */.B9)().deleteShoppingLists;
    var ref = (0,react.useState)(false), showDeleteModal = ref[0], setShowDeleteModal = ref[1];
    var handleRemove = (0,react.useCallback)(function() {
        if (listId) {
            deleteShoppingLists(listId);
        }
        setShowDeleteModal(false);
    }, [
        listId,
        deleteShoppingLists
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContainer, {
                children: linkCard ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TrashButton, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* CornerButton */.gm, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((DeleteBinLineIcon_default()), {
                                    size: 16
                                }),
                                onClick: function() {
                                    return setShowDeleteModal(true);
                                }
                            })
                        }),
                        href ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(common/* Link */.rU, {
                            href: href,
                            children: [
                                !emptyList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(imageStyles/* BackgroundImageCover */.G, {
                                    children: src ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: src,
                                        layout: "fill",
                                        objectFit: "contain",
                                        objectPosition: "center"
                                    }) : null
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyListText, {
                                    children: "\xdeessi \xf3skalisti er t\xf3mur"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryTitleBox, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightUpLineIcon_default()), {
                                                color: theme/* default.palette.red */.Z.palette.red
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H5, {
                                            children: title || "V\xf6ruflokkur"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PSmall */.zK, {
                                            color: "black40",
                                            children: description
                                        })
                                    ]
                                })
                            ]
                        }) : null
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(CreateButton, {
                    onClick: onClickCreate,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AddIconWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((AddLineIcon_default()), {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTitleBox, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H5, {
                                children: title
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Modal */.u_, {
                setShow: setShowDeleteModal,
                show: showDeleteModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* DeleteConfirmation */.L3, {
                    title: "Ertu viss um a\xf0 \xfe\xfa viljir ey\xf0a \u201E".concat(title, "\u201C?"),
                    text: "\xde\xfa munt ekki geta teki\xf0 \xfeessa a\xf0ger\xf0 til baka.",
                    onCancel: function() {
                        return setShowDeleteModal(false);
                    },
                    onRemove: handleRemove,
                    cancelText: "H\xe6tta vi\xf0",
                    submitText: "Ey\xf0a lista"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 120 modules
var formik_esm = __webpack_require__(59433);
// EXTERNAL MODULE: ./node_modules/styled-bootstrap-grid/dist/index.js
var dist = __webpack_require__(54572);
// EXTERNAL MODULE: ./node_modules/remixicon-react/FileListLineIcon.js
var FileListLineIcon = __webpack_require__(85771);
var FileListLineIcon_default = /*#__PURE__*/__webpack_require__.n(FileListLineIcon);
// EXTERNAL MODULE: ./src/themes/index.tsx
var themes = __webpack_require__(52287);
// EXTERNAL MODULE: ./src/components/form/Input.tsx
var Input = __webpack_require__(92469);
;// CONCATENATED MODULE: ./src/components/shoppingLists/CreateNewShoppingList.tsx
function CreateNewShoppingList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CreateNewShoppingList_templateObject() {
    var data = CreateNewShoppingList_taggedTemplateLiteral([
        "\n  padding-left: 2px;\n"
    ]);
    CreateNewShoppingList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CreateNewShoppingList_templateObject1() {
    var data = CreateNewShoppingList_taggedTemplateLiteral([
        "\n  padding-top: 12px;\n"
    ]);
    CreateNewShoppingList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CreateNewShoppingList_templateObject2() {
    var data = CreateNewShoppingList_taggedTemplateLiteral([
        "\n  padding-top: 12px;\n"
    ]);
    CreateNewShoppingList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CreateNewShoppingList_templateObject3() {
    var data = CreateNewShoppingList_taggedTemplateLiteral([
        "\n  text-align: center;\n  padding-top: 25px;\n"
    ]);
    CreateNewShoppingList_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












var InputLabelWrapper = styled_components_browser_esm["default"].div(CreateNewShoppingList_templateObject());
var InputWrapper = styled_components_browser_esm["default"].div(CreateNewShoppingList_templateObject1());
var ButtonWrapper = styled_components_browser_esm["default"].div(CreateNewShoppingList_templateObject2());
var TitleWrapper = styled_components_browser_esm["default"].div(CreateNewShoppingList_templateObject3());
function CreateNewShoppingList(param1) {
    var list = param1.list, revalidateSingleShoppingList = param1.revalidateSingleShoppingList;
    var ref = (0,ShoppingListContext/* useShoppingList */.B9)(), createShoppingList = ref.createShoppingList, setCreateModalIsOpen = ref.setCreateModalIsOpen, updateShoppingList = ref.updateShoppingList, shoppingLists = ref.shoppingLists;
    var validateName = function(values) {
        var errors = {};
        var isDuplicate = shoppingLists === null || shoppingLists === void 0 ? void 0 : shoppingLists.some(function(l) {
            return l.name.toLowerCase() === (values === null || values === void 0 ? void 0 : values.name.toLowerCase());
        });
        if (!values.name) {
            errors.name = "H\xe9r vantar nafn";
        } else if (isDuplicate) {
            errors.name = "\xdeessi \xf3skalisti er n\xfa \xfeegar til. Vinsamlegast veldu n\xfdtt nafn.";
        }
        return errors;
    };
    var ref1;
    var initialValues = {
        name: (ref1 = list === null || list === void 0 ? void 0 : list.name) !== null && ref1 !== void 0 ? ref1 : ""
    };
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: initialValues,
        validateOnChange: false,
        validate: function(values) {
            return validateName(values);
        },
        onSubmit: function(values, param) {
            var setSubmitting = param.setSubmitting, resetForm = param.resetForm;
            setSubmitting(true);
            if (list) {
                updateShoppingList(list.id, values);
                if (revalidateSingleShoppingList) {
                    revalidateSingleShoppingList();
                }
            } else {
                createShoppingList(values);
            }
            if (setCreateModalIsOpen) {
                setCreateModalIsOpen(false);
            }
            setSubmitting(false);
            resetForm({
                values: {
                    name: ""
                }
            });
        }
    });
    var handleClick = (0,react.useCallback)(function() {
        if (!setCreateModalIsOpen) {
            return;
        }
        setCreateModalIsOpen(false);
    }, [
        setCreateModalIsOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(typography.H4, {
                    withGutter: true,
                    children: [
                        list ? "Breyta" : "B\xfaa til n\xfdjan",
                        " \xf3skalista"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: formik.handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                md: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title6 */.L8, {
                                            textAlign: "left",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputLabelWrapper, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((FileListLineIcon_default()), {
                                                        color: themes/* theme.palette.primary */.r.palette.primary,
                                                        size: 12
                                                    }),
                                                    " ",
                                                    "Heiti \xf3skalista"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.II, {
                                            name: "name",
                                            label: "",
                                            type: "text",
                                            placeholder: "T.d. M\xf6tuneyti",
                                            autoComplete: "off",
                                            onChange: formik.handleChange,
                                            value: formik.values.name,
                                            showError: !!formik.errors.name,
                                            errorMsg: formik.errors.name,
                                            withGutter: true
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
                                        justifyContent: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                                order: 2,
                                                sm: 6,
                                                xs: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                                                    fill: true,
                                                    disabled: !formik.values.name || formik.values.name === initialValues.name,
                                                    withGutter: true,
                                                    type: "submit",
                                                    children: list ? "Sta\xf0festa" : "B\xfaa til lista"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                                order: 1,
                                                sm: 6,
                                                xs: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                                                    fill: true,
                                                    withGutter: true,
                                                    color: "secondary",
                                                    type: "button",
                                                    outlined: true,
                                                    onClick: handleClick,
                                                    children: "H\xe6tta vi\xf0"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    formik.isSubmitting && /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Loader */.aN, {})
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/shoppingLists/shoppingListItems/DeleteShoppingListItem.tsx




function DeleteShoppingListItem(param) {
    var id = param.id, listId = param.listId, setShowModal = param.setShowModal;
    var ref = (0,ShoppingListContext/* useShoppingList */.B9)(), deleteItemFromShoppingList = ref.deleteItemFromShoppingList, useSingleShoppingList = ref.useSingleShoppingList;
    var revalidateSingleShoppingList = useSingleShoppingList(listId).revalidateSingleShoppingList;
    var handleDeleteItem = (0,react.useCallback)(function() {
        deleteItemFromShoppingList(id);
        revalidateSingleShoppingList();
        setShowModal(false);
    }, [
        deleteItemFromShoppingList,
        id,
        revalidateSingleShoppingList,
        setShowModal, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* DeleteConfirmation */.L3, {
        title: "Ertu viss um a\xf0 \xfe\xfa viljir ey\xf0a v\xf6ru \xfar \xf3skalistanum \xfe\xednum?",
        text: "\xde\xfa munt ekki geta teki\xf0 \xfeessa a\xf0ger\xf0 til baka.",
        onCancel: function() {
            return setShowModal(false);
        },
        onRemove: handleDeleteItem,
        cancelText: "H\xe6tta vi\xf0",
        submitText: "Ey\xf0a v\xf6ru"
    });
};

// EXTERNAL MODULE: ./node_modules/remixicon-react/CloseLineIcon.js
var CloseLineIcon = __webpack_require__(46550);
var CloseLineIcon_default = /*#__PURE__*/__webpack_require__.n(CloseLineIcon);
// EXTERNAL MODULE: ./src/utils/graphql.ts
var graphql = __webpack_require__(27429);
// EXTERNAL MODULE: ./src/components/form/Checkbox.tsx
var Checkbox = __webpack_require__(1771);
;// CONCATENATED MODULE: ./src/components/shoppingLists/shoppingListItems/AddItemToShoppingList.tsx
function AddItemToShoppingList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function AddItemToShoppingList_templateObject() {
    var data = AddItemToShoppingList_taggedTemplateLiteral([
        "\n  padding: 25px 0;\n  width: 100%;\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    AddItemToShoppingList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AddItemToShoppingList_templateObject1() {
    var data = AddItemToShoppingList_taggedTemplateLiteral([
        "\n  padding-top: 25px;\n"
    ]);
    AddItemToShoppingList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AddItemToShoppingList_templateObject2() {
    var data = AddItemToShoppingList_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: 8px 0;\n"
    ]);
    AddItemToShoppingList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AddItemToShoppingList_templateObject3() {
    var data = AddItemToShoppingList_taggedTemplateLiteral([
        "\n  padding-left: 4px;\n  font-size: 0.75rem;\n  color: ",
        ";\n"
    ]);
    AddItemToShoppingList_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AddItemToShoppingList_templateObject4() {
    var data = AddItemToShoppingList_taggedTemplateLiteral([
        "\n    padding-top: 25px;\n"
    ]);
    AddItemToShoppingList_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function AddItemToShoppingList_templateObject5() {
    var data = AddItemToShoppingList_taggedTemplateLiteral([
        "\n  padding-top: 18px;\n  padding-left: 20px;\n\n  ",
        "\n"
    ]);
    AddItemToShoppingList_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function AddItemToShoppingList_templateObject6() {
    var data = AddItemToShoppingList_taggedTemplateLiteral([
        "\n  padding-top: 25px;\n  text-align: center;\n  padding-bottom: 25px;\n"
    ]);
    AddItemToShoppingList_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = AddItemToShoppingList_taggedTemplateLiteral([
        "\n    padding-right: ",
        ";\n    padding-left: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = AddItemToShoppingList_taggedTemplateLiteral([
        "\n  max-width: 600px;\n  text-align: left;\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = AddItemToShoppingList_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  width: calc(100% + 2px);\n  height: calc(100% + 2px);\n  opacity: ",
        ";\n  z-index: ",
        ";\n  transition: opacity 0.2s ease-in\n    ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = AddItemToShoppingList_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  height: 100%;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = AddItemToShoppingList_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  backdrop-filter: blur(1px);\n  background-color: rgba(0, 0, 0, 0.25);\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = AddItemToShoppingList_taggedTemplateLiteral([
        "\n    padding: 0 50px;\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = AddItemToShoppingList_taggedTemplateLiteral([
        "\n  padding: 0 4px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = AddItemToShoppingList_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  z-index: 1;\n  padding: 20px;\n  background-color: white;\n  border: 1px solid black;\n\n  &::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 3px;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}

















var ProductInfoContainer = styled_components_browser_esm["default"].div(AddItemToShoppingList_templateObject(), (0,es/* palette */.DG)("black10"), (0,es/* palette */.DG)("black10"));
var CheckboxContainer = styled_components_browser_esm["default"].div(AddItemToShoppingList_templateObject1());
var CheckboxWrapper = styled_components_browser_esm["default"].div(AddItemToShoppingList_templateObject2());
var ItemCount = styled_components_browser_esm["default"].div(AddItemToShoppingList_templateObject3(), (0,es/* palette */.DG)("black40"));
var AddListContainer = styled_components_browser_esm["default"].div(AddItemToShoppingList_templateObject5(), dist.media.md(AddItemToShoppingList_templateObject4()));
var TitleContainer = styled_components_browser_esm["default"].div(AddItemToShoppingList_templateObject6());
var TextWrapper = styled_components_browser_esm["default"].div(_templateObject8(), dist.media.sm(_templateObject7(), (0,es/* ifProp */.fq)({
    mirrored: true
}, "0", "20px"), (0,es/* ifProp */.fq)({
    mirrored: true
}, "20px", "0")));
var AddNewListPopover = styled_components_browser_esm["default"].div(_templateObject9(), (0,es/* ifProp */.fq)({
    open: true
}, 1, 0), (0,es/* ifProp */.fq)({
    open: true
}, 1, -1), (0,es/* ifProp */.fq)({
    open: true
}, "", ", z-index 0.2s step-end"));
var PopoverContainer = styled_components_browser_esm["default"].div(_templateObject10());
var PopoverBackgroundBlur = styled_components_browser_esm["default"].div(_templateObject11());
var CreateListWrapper = styled_components_browser_esm["default"].div(_templateObject13(), dist.media.sm(_templateObject12()));
var NewListInputContainer = styled_components_browser_esm["default"].div(_templateObject14(), (0,es/* palette */.DG)("red"));
function AddItemToShoppingList(param) {
    var title = param.title, image = param.image, id = param.id, itemInShoppingList = param.itemInShoppingList;
    var ref2 = (0,ShoppingListContext/* useShoppingList */.B9)(), shoppingLists = ref2.shoppingLists, addItemToShoppingList = ref2.addItemToShoppingList, setCreateModalIsOpen = ref2.setCreateModalIsOpen, createModalIsOpen = ref2.createModalIsOpen, deleteItemFromShoppingList = ref2.deleteItemFromShoppingList;
    var popoverRef = (0,react.useRef)(null);
    var initialListsIds = itemInShoppingList === null || itemInShoppingList === void 0 ? void 0 : itemInShoppingList.map(function(item) {
        return item.list;
    });
    var handleClick = (0,react.useCallback)(function(e) {
        var selectedId = e.target.value;
        var isChecked = e.target.checked;
        if (!isChecked) {
            var ref;
            var listItemId = (ref = itemInShoppingList === null || itemInShoppingList === void 0 ? void 0 : itemInShoppingList.find(function(i) {
                return i.list === selectedId;
            })) === null || ref === void 0 ? void 0 : ref.id;
            if (listItemId) {
                deleteItemFromShoppingList(listItemId);
            }
        } else {
            var ref1;
            var listItem = {
                productVariant: (ref1 = (0,graphql/* intFromGlobalId */._O)(id)) === null || ref1 === void 0 ? void 0 : ref1.id,
                quantity: 1,
                list: selectedId
            };
            addItemToShoppingList(listItem);
        }
    }, [
        addItemToShoppingList,
        deleteItemFromShoppingList,
        id,
        itemInShoppingList
    ]);
    var handleShoppingLists = (0,react.useMemo)(function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: shoppingLists ? shoppingLists.map(function(list) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(CheckboxWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            label: list.name,
                            type: "checkbox",
                            name: "oskalistar",
                            defaultValue: list.id,
                            fontWeight: "400",
                            checked: initialListsIds === null || initialListsIds === void 0 ? void 0 : initialListsIds.includes(list.id),
                            onClick: handleClick
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemCount, {
                            children: [
                                "(",
                                (ref = list.items) === null || ref === void 0 ? void 0 : ref.length,
                                ")"
                            ]
                        })
                    ]
                }, list.id);
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: "Enginn listi til"
            })
        });
    }, [
        shoppingLists,
        initialListsIds,
        handleClick
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H4, {
                    children: (itemInShoppingList === null || itemInShoppingList === void 0 ? void 0 : itemInShoppingList.length) ? "Uppf\xe6ra v\xf6ru \xe1 \xf3skalistum" : "B\xe6ta v\xf6ru vi\xf0 \xf3skalista"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductInfoContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                        xs: 4,
                                        sm: 4,
                                        children: image ? /*#__PURE__*/ (0,jsx_runtime.jsx)(imageStyles/* BackgroundImageContain */.r, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                layout: "fill",
                                                src: image,
                                                objectFit: "contain",
                                                objectPosition: "center"
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* NoImage */.Dy, {
                                            size: 32,
                                            textSize: "0.875rem"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                        xs: 6,
                                        sm: 4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextWrapper, {
                                            mirrored: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PSmall */.zK, {
                                                bold: true,
                                                children: title
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxContainer, {
                            children: handleShoppingLists
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddListContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* UnderlineButton */.tg, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((AddLineIcon_default()), {
                                    color: themes/* theme.palette.primary */.r.palette.primary
                                }),
                                text: "B\xfaa til n\xfdjan \xf3skalista",
                                onClick: function() {
                                    return setCreateModalIsOpen(true);
                                }
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AddNewListPopover, {
                open: createModalIsOpen,
                ref: popoverRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopoverContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverBackgroundBlur, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewListInputContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* CornerButton */.gm, {
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((CloseLineIcon_default()), {
                                        size: 20
                                    }),
                                    onClick: function() {
                                        return setCreateModalIsOpen(false);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateListWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateNewShoppingList, {})
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/shoppingLists/index.tsx








/***/ }),

/***/ 38248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ useScrollTop; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_utils_isSSR__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28095);


var useScrollTop = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(src_utils_isSSR__WEBPACK_IMPORTED_MODULE_1__/* .isSSR */ .y ? 0 : window.scrollY), scrollTop = ref[0], setScrollTop = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function() {
        var fn = function() {
            setScrollTop(window.scrollY);
        };
        window.addEventListener("scroll", fn);
        fn();
        return function() {
            window.removeEventListener("scroll", fn);
        };
    }, []);
    return scrollTop;
};


/***/ }),

/***/ 42521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ BackgroundImageCover; },
/* harmony export */   "r": function() { return /* binding */ BackgroundImageContain; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(186);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var BackgroundImageCover = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject());
var BackgroundImageContain = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div(_templateObject1());


/***/ }),

/***/ 58728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ scrollStyle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41145);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    overflow-y: auto;\n\n    /* width */\n    ::-webkit-scrollbar {\n      width: 6px;\n    }\n\n    /* Track */\n    ::-webkit-scrollbar-track {\n      background: ",
        ";\n      border: 1px solid ",
        ";\n    }\n\n    /* Handle */\n    ::-webkit-scrollbar-thumb {\n      background: ",
        ";\n    }\n\n    &:focus {\n      outline: none;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function scrollStyle(param) {
    var _color = param.color, color = _color === void 0 ? "black" : _color;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_0__/* .palette */ .DG)("".concat(color, "10")), (0,styled_tools__WEBPACK_IMPORTED_MODULE_0__/* .palette */ .DG)(color), (0,styled_tools__WEBPACK_IMPORTED_MODULE_0__/* .palette */ .DG)(color));
};


/***/ }),

/***/ 90844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ getPluralOrSingular; }
/* harmony export */ });
var getPluralOrSingular = function(param) {
    var plural = param.plural, singular = param.singular, value = param.value, _showQuantity = param.showQuantity, showQuantity = _showQuantity === void 0 ? true : _showQuantity;
    var word = function() {
        if (value.toString().endsWith("1") && !value.toString().endsWith("11")) {
            return singular;
        }
        return plural;
    }();
    if (!showQuantity) {
        return word;
    }
    return "".concat(value, " ").concat(word);
};


/***/ }),

/***/ 20619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ isTouchDevice; }
/* harmony export */ });
/* unused harmony export getIsTouchDevice */
var getIsTouchDevice = function() {
    if (false) {}
    return "ontouchstart" in window || navigator.maxTouchPoints > 0;
};
var isTouchDevice = getIsTouchDevice();


/***/ }),

/***/ 5979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S1": function() { return /* binding */ sortingArgsMap; },
/* harmony export */   "vu": function() { return /* binding */ attributeFilters; },
/* harmony export */   "NX": function() { return /* binding */ findItemInShoppingList; }
/* harmony export */ });
/* unused harmony exports mapAttributes, toAttrOption */
/* harmony import */ var src_api_saleor_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49554);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27429);
/* harmony import */ var _isNotNull__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84403);




// TODO: test
function mapAttributes(attributes) {
    var ref2;
    return fromPairs((ref2 = attributes !== null && attributes !== void 0 ? attributes : []) === null || ref2 === void 0 ? void 0 : ref2.filter(function(value) {
        return value && value.attribute && value.attribute.slug;
    }).map(function(attr) {
        return [
            attr.attribute.slug,
            attr
        ];
    }));
}
// TODO: test
// TODO: Check if sorting works for price when products have price
var sortingArgsMap = {
    new: [
        {
            field: src_api_saleor_generated__WEBPACK_IMPORTED_MODULE_0__/* .ProductOrderField.Date */ .$kU.Date,
            direction: src_api_saleor_generated__WEBPACK_IMPORTED_MODULE_0__/* .OrderDirection.Asc */ .N9t.Asc
        }
    ],
    price_asc: [
        {
            field: src_api_saleor_generated__WEBPACK_IMPORTED_MODULE_0__/* .ProductOrderField.Price */ .$kU.Price,
            direction: src_api_saleor_generated__WEBPACK_IMPORTED_MODULE_0__/* .OrderDirection.Asc */ .N9t.Asc
        }
    ],
    alph_asc: [
        {
            field: src_api_saleor_generated__WEBPACK_IMPORTED_MODULE_0__/* .ProductOrderField.Name */ .$kU.Name,
            direction: src_api_saleor_generated__WEBPACK_IMPORTED_MODULE_0__/* .OrderDirection.Asc */ .N9t.Asc
        }
    ],
    // alph_desc: [{field: ProductOrderField.Name, direction: OrderDirection.Desc}],
    undefined: [
        {
            field: src_api_saleor_generated__WEBPACK_IMPORTED_MODULE_0__/* .ProductOrderField.Date */ .$kU.Date,
            direction: src_api_saleor_generated__WEBPACK_IMPORTED_MODULE_0__/* .OrderDirection.Asc */ .N9t.Asc
        }
    ]
};
var ref, _name, _slug, _slug1;
// TODO: test
var toAttrOption = function(attributes) {
    return ((ref = attributes === null || attributes === void 0 ? void 0 : attributes.edges) !== null && ref !== void 0 ? ref : []).map(function(a) {
        var ref3;
        return {
            id: a.node.id,
            attrName: (_name = a.node.name) !== null && _name !== void 0 ? _name : "",
            slug: (_slug = a.node.slug) !== null && _slug !== void 0 ? _slug : "",
            attrValues: (((ref3 = a.node.choices) === null || ref3 === void 0 ? void 0 : ref3.edges) || []).map(function(param) {
                var node = param.node;
                return {
                    name: node.name,
                    slug: (_slug1 = node.slug) !== null && _slug1 !== void 0 ? _slug1 : "",
                    id: node.id
                };
            })
        };
    });
};
var ref1;
// TODO: test
var attributeFilters = function(attributes, filterQueryParams) {
    var ref4;
    return ((ref1 = attributes === null || attributes === void 0 ? void 0 : (ref4 = attributes.edges) === null || ref4 === void 0 ? void 0 : ref4.map(function(a) {
        var ref6, ref5;
        return {
            slug: a.node.slug,
            values: (ref6 = a.node) === null || ref6 === void 0 ? void 0 : (ref5 = ref6.choices) === null || ref5 === void 0 ? void 0 : ref5.edges.filter(function(v) {
                var ref7;
                return (v === null || v === void 0 ? void 0 : (ref7 = v.node) === null || ref7 === void 0 ? void 0 : ref7.slug) && (filterQueryParams === null || filterQueryParams === void 0 ? void 0 : filterQueryParams.includes(v.node.slug));
            }).map(function(v) {
                return v.node.slug;
            })
        };
    })) !== null && ref1 !== void 0 ? ref1 : []).filter((0,_isNotNull__WEBPACK_IMPORTED_MODULE_3__/* .isNotNullKey */ .W)("slug")).filter(function(value) {
        return value.slug != null && value.values != null && value.values.length > 0;
    });
};
// TODO: test
var findItemInShoppingList = function(param) {
    var variantId = param.variantId, shoppingLists = param.shoppingLists;
    return (shoppingLists || []).map(function(list) {
        return list.items.find(function(item) {
            var ref8;
            return (0,_graphql__WEBPACK_IMPORTED_MODULE_2__/* .toGlobalId */ .AW)("ProductVariant", item === null || item === void 0 ? void 0 : (ref8 = item.productVariant) === null || ref8 === void 0 ? void 0 : ref8.id) === variantId;
        });
    }).filter(_isNotNull__WEBPACK_IMPORTED_MODULE_3__/* .isNotNull */ .K);
};


/***/ }),

/***/ 8597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Oj": function() { return /* binding */ phoneRegExp; },
/* harmony export */   "Gp": function() { return /* binding */ postRegExp; },
/* harmony export */   "LD": function() { return /* binding */ emailRegExp; },
/* harmony export */   "SR": function() { return /* binding */ parsePhoneNumber; },
/* harmony export */   "un": function() { return /* binding */ formatPhoneNumber; },
/* harmony export */   "fc": function() { return /* binding */ formatPhoneNumberNoSpaces; },
/* harmony export */   "I8": function() { return /* binding */ removeSpaces; },
/* harmony export */   "cF": function() { return /* binding */ splitName; },
/* harmony export */   "_h": function() { return /* binding */ removeFileExt; },
/* harmony export */   "aR": function() { return /* binding */ isValidSsn; },
/* harmony export */   "X7": function() { return /* binding */ isValidCompanySsn; },
/* harmony export */   "Fc": function() { return /* binding */ getAlgoliaProductIndex; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var kennitala__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61473);
/* harmony import */ var kennitala__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(kennitala__WEBPACK_IMPORTED_MODULE_1__);


// This allows 7 digits plus spaces and not letters
var phoneRegExp = /^(?:[0-9]\x20?){6,6}[0-9]$/;
var postRegExp = /\b(10[1-9]|1[1-9][0-9]|[2-8][0-9]{2}|900)\b/;
// for email validation
var emailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
// TODO: Test
function parsePhoneNumber(phoneNumber) {
    if (!phoneNumber) {
        return "";
    }
    var trimmed = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.replace)(phoneNumber, " ", "");
    return trimmed;
}
// TODO: Test
function formatPhoneNumber(phone) {
    if (typeof phone !== "string") {
        return "";
    }
    var trimmed = phone === null || phone === void 0 ? void 0 : phone.replace("+354", "");
    if (trimmed.length < 7) {
        return trimmed;
    }
    return "".concat(trimmed.substr(0, 3), " ").concat(trimmed.substr(3, trimmed.length));
}
// TODO: Test
function formatPhoneNumberNoSpaces(phone) {
    var trimmed = phone === null || phone === void 0 ? void 0 : phone.replace("+354", "").replace(" ", "");
    return trimmed;
}
// TODO: Test
function removeSpaces(str) {
    return str === null || str === void 0 ? void 0 : str.replace(/\s/g, "");
}
function splitName(fullName) {
    var lastSpace = fullName.lastIndexOf(" ");
    var name = fullName.substring(0, lastSpace);
    var ref;
    var ssn = (0,kennitala__WEBPACK_IMPORTED_MODULE_1__.format)((ref = fullName.split(" ").pop()) !== null && ref !== void 0 ? ref : "");
    return [
        name,
        ssn
    ];
}
// TODO: Test
function removeFileExt(str) {
    return str.replace(/\.[^/.]+$/, "");
}
function isValidSsn(ssn) {
    return /(9|0)$/.test(ssn) && (0,kennitala__WEBPACK_IMPORTED_MODULE_1__.isValid)(ssn);
}
function isValidCompanySsn(ssn) {
    return /(9|0)$/.test(ssn) && (0,kennitala__WEBPACK_IMPORTED_MODULE_1__.isCompany)(ssn);
}
function getAlgoliaProductIndex() {
    var indexMap = {
        localhost: "dev",
        development: "dev",
        production: "prod"
    };
    var currentENV = "production" || 0;
    var indexName = "".concat(indexMap[currentENV], "_PRODUCT");
    return indexName;
}


/***/ }),

/***/ 37424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ validateEmail; }
/* harmony export */ });
var emailTester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
function validateEmail(email) {
    if (!email) return false;
    var emailParts = email.split("@");
    if (emailParts.length !== 2) return false;
    var account = emailParts[0];
    var address = emailParts[1];
    if (account.length > 64) return false;
    if (address.length > 255) return false;
    var domainParts = address.split(".");
    if (domainParts.some(function(part) {
        return part.length > 63;
    })) return false;
    if (!emailTester.test(email)) return false;
    return true;
}


/***/ })

}]);